import React, { useState, useEffect, useMemo, useRef } from "react";
import { depo } from "./depo.js";
import {
  ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip,
  CartesianGrid, Cell,
} from "recharts";

/* ═══════════════════════════════════════════════════════════════
   KARELIAS & SONS — İŞLETME PANELİ
   Tekil anahtar = platform + disId · elle[] alanları senkronda korunur
   ═══════════════════════════════════════════════════════════════ */

const CURRENCIES = ["USD", "EUR", "GBP", "TRY"];
const SIRKETLER = ["Asar Global LLC", "Asar Danışmanlık"];
const TEDARIKCILER = ["Asya Deri Halı", "Seyran Halı"];
const SIPARIS_DURUM = ["Yeni", "Hazırlanıyor", "Kargolandı", "Teslim edildi", "İade", "İptal"];
const ODEME_DURUM = ["Bekliyor", "Tahsil edildi"];
const GIDER_KAT = ["Tedarikçi ödemesi", "Reklam", "Kargo & lojistik", "Yazılım & abonelik",
  "Komisyon farkı", "Vergi", "Muhasebe & danışmanlık", "Maaş", "Gümrük", "Diğer"];

const DEFAULT_PLATFORMS = [
  { ad: "Trendyol", komisyon: 21, odemeGun: 21, cur: "TRY", yontem: "api", saglayici: "trendyol" },
  { ad: "Hepsiburada", komisyon: 18, odemeGun: 25, cur: "TRY", yontem: "api", saglayici: "hepsiburada" },
  { ad: "Shopify TR", komisyon: 3.4, odemeGun: 3, cur: "TRY", yontem: "webhook", saglayici: "shopify" },
  { ad: "Shopify USA", komisyon: 3.2, odemeGun: 3, cur: "USD", yontem: "webhook", saglayici: "shopify" },
  { ad: "Etsy Karelias", komisyon: 9.5, odemeGun: 7, cur: "USD", yontem: "api", saglayici: "etsy" },
  { ad: "Etsy Sierra Rugs", komisyon: 9.5, odemeGun: 7, cur: "USD", yontem: "api", saglayici: "etsy" },
  { ad: "Etsy Sisal Rugs", komisyon: 9.5, odemeGun: 7, cur: "USD", yontem: "api", saglayici: "etsy" },
  { ad: "Etsy Palimera", komisyon: 9.5, odemeGun: 7, cur: "USD", yontem: "api", saglayici: "etsy" },
  { ad: "Faire", komisyon: 15, odemeGun: 60, cur: "USD", yontem: "api", saglayici: "faire" },
  { ad: "Wayfair", komisyon: 15, odemeGun: 45, cur: "USD", yontem: "api", saglayici: "wayfair" },
  { ad: "eBay", komisyon: 13, odemeGun: 5, cur: "USD", yontem: "api", saglayici: "ebay" },
  { ad: "Mathis Home", komisyon: 0, odemeGun: 60, cur: "USD", yontem: "csv", saglayici: "csv" },
];

const DEFAULT_URUNLER = [
  { ad: "Dana Derisi", maliyet: 62, tedarikci: "Asya Deri Halı", anahtar: "cowhide,dana" },
  { ad: "Varaklı Dana Derisi", maliyet: 95, tedarikci: "Asya Deri Halı", anahtar: "metallic,varak" },
  { ad: "Peluş", maliyet: 34, tedarikci: "Seyran Halı", anahtar: "plush,pelus,faux" },
  { ad: "Toskana", maliyet: 78, tedarikci: "Asya Deri Halı", anahtar: "tuscan,toskana,sheepskin" },
  { ad: "Ceylan Derisi", maliyet: 110, tedarikci: "Asya Deri Halı", anahtar: "springbok,ceylan" },
  { ad: "Fok", maliyet: 88, tedarikci: "Asya Deri Halı", anahtar: "seal,fok" },
  { ad: "Leopar Derisi", maliyet: 92, tedarikci: "Asya Deri Halı", anahtar: "leopard,leopar" },
  { ad: "Dana Post", maliyet: 70, tedarikci: "Asya Deri Halı", anahtar: "hair on hide,dana post,post" },
  { ad: "Puantiyeli Dikişli Dana", maliyet: 84, tedarikci: "Asya Deri Halı", anahtar: "patchwork,puantiye" },
  { ad: "Oğlak Derisi", maliyet: 58, tedarikci: "Asya Deri Halı", anahtar: "goatskin,oglak" },
  { ad: "Rex Tavşan", maliyet: 120, tedarikci: "Asya Deri Halı", anahtar: "rabbit,rex,tavsan" },
  { ad: "Tilki Kafa", maliyet: 140, tedarikci: "Asya Deri Halı", anahtar: "fox head,tilki kafa" },
  { ad: "Tilki Karın", maliyet: 135, tedarikci: "Asya Deri Halı", anahtar: "fox belly,tilki karin" },
  { ad: "Fok Extra Border", maliyet: 105, tedarikci: "Asya Deri Halı", anahtar: "seal border" },
  { ad: "Vizon", maliyet: 165, tedarikci: "Asya Deri Halı", anahtar: "mink,vizon" },
  { ad: "Zebra Baskı Dana", maliyet: 74, tedarikci: "Asya Deri Halı", anahtar: "zebra print" },
  { ad: "Post Deri Cüzdan", maliyet: 12, tedarikci: "Asya Deri Halı", anahtar: "wallet,cuzdan" },
  { ad: "Monde", maliyet: 46, tedarikci: "Seyran Halı", anahtar: "monde" },
  { ad: "Asır", maliyet: 52, tedarikci: "Seyran Halı", anahtar: "asir" },
  { ad: "Petra India", maliyet: 61, tedarikci: "Seyran Halı", anahtar: "petra,india" },
  { ad: "Loopy Bombay", maliyet: 44, tedarikci: "Seyran Halı", anahtar: "loopy,bombay" },
  { ad: "Evita", maliyet: 39, tedarikci: "Seyran Halı", anahtar: "evita" },
  { ad: "Peru", maliyet: 48, tedarikci: "Seyran Halı", anahtar: "peru" },
];

/* Vurgu renkleri — hiçbiri sarı değil, hiçbiri kâr yeşili/zarar kırmızısıyla karışmıyor */
const VURGULAR = [
  { id: "erguvan", ad: "Erguvan", ornek: "#CC72AE", koyu: ["#E9A9D3", "#8C4879"], acik: ["#BE71A4", "#7C3A67"], rgb: "204,114,174" },
  { id: "cini", ad: "Çini", ornek: "#46BDB6", koyu: ["#86DDD7", "#217D79"], acik: ["#3FA9A3", "#0F625E"], rgb: "70,189,182" },
  { id: "civit", ad: "Çivit", ornek: "#7B99EE", koyu: ["#AEC3F9", "#3F5CAE"], acik: ["#5C7FD4", "#283F7E"], rgb: "123,153,238" },
  { id: "gece", ad: "Gece", ornek: "#C2CDD8", koyu: ["#E4EAF0", "#6F7C88"], acik: ["#74818D", "#333D46"], rgb: "194,205,216" },
];

const BANKA_KAT = ["Platform hakedişi", "Müşteri ödemesi", "Tedarikçi ödemesi", "Reklam",
  "Kargo & lojistik", "Vergi & SGK", "Maaş", "Banka masrafı", "Hesaplar arası virman",
  "Ortak / sermaye", "İade / chargeback", "Diğer"];

/* Beyan bankaya göre verildiği için hesaplar kaynak belge konumunda */
const DEFAULT_BANKALAR = [
  { id: "wf1", banka: "Wells Fargo", etiket: "Wells Fargo · İşletme", ulke: "USA", cur: "USD", sirket: "Asar Global LLC", son4: "4417", acilis: 21400 },
  { id: "mc1", banka: "Mercury", etiket: "Mercury · Ana hesap", ulke: "USA", cur: "USD", sirket: "Asar Global LLC", son4: "8102", acilis: 34600 },
  { id: "mc2", banka: "Mercury", etiket: "Mercury · Pazaryeri tahsilat", ulke: "USA", cur: "USD", sirket: "Asar Global LLC", son4: "8119", acilis: 12850 },
  { id: "mc3", banka: "Mercury", etiket: "Mercury · Vergi ayrımı", ulke: "USA", cur: "USD", sirket: "Asar Global LLC", son4: "8127", acilis: 18000 },
  { id: "ws1", banka: "Wise", etiket: "Wise · Çoklu döviz", ulke: "USA", cur: "USD", sirket: "Asar Global LLC", son4: "6640", acilis: 9300 },
  { id: "gt1", banka: "Garanti BBVA", etiket: "Garanti · TRY 1 (ana)", ulke: "TR", cur: "TRY", sirket: "Asar Danışmanlık", son4: "2231", acilis: 640000 },
  { id: "gt2", banka: "Garanti BBVA", etiket: "Garanti · TRY 2 (tedarik)", ulke: "TR", cur: "TRY", sirket: "Asar Danışmanlık", son4: "2248", acilis: 215000 },
  { id: "gtu", banka: "Garanti BBVA", etiket: "Garanti · USD (ihracat)", ulke: "TR", cur: "USD", sirket: "Asar Danışmanlık", son4: "9074", acilis: 14200 },
  { id: "zb1", banka: "Ziraat Bankası", etiket: "Ziraat · TRY", ulke: "TR", cur: "TRY", sirket: "Asar Danışmanlık", son4: "5518", acilis: 128000 },
];

const bugun = () => new Date().toISOString().slice(0, 10);
const simdi = () => new Date().toISOString();
const uid = () => Math.random().toString(36).slice(2, 9);
const ay = (t) => (t || "").slice(0, 7);
const AYLAR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
const ayAdi = (k) => { const [y, m] = k.split("-"); return AYLAR[Number(m) - 1].slice(0, 3) + " " + y.slice(2); };
const ayTam = (k) => { const [y, m] = k.split("-"); return AYLAR[Number(m) - 1] + " " + y; };

const kanonik = (x = {}) => ({
  id: x.id || uid(), anahtar: x.anahtar || null, disId: x.disId || "",
  kaynakTur: x.kaynakTur || "manuel", senkron: x.senkron || null, elle: x.elle || [],
  no: x.no || "SP-" + Math.floor(1000 + Math.random() * 9000), tarih: x.tarih || bugun(),
  platform: x.platform || DEFAULT_PLATFORMS[0].ad, urun: x.urun || DEFAULT_URUNLER[0].ad,
  urunAdi: x.urunAdi || "", sku: x.sku || "", adet: x.adet ?? 1, fiyat: x.fiyat ?? 0,
  en: x.en ?? null, boy: x.boy ?? null, m2: x.m2 ?? null,
  cur: x.cur || "USD", durum: x.durum || "Yeni", odemeDurum: x.odemeDurum || "Bekliyor",
  ulke: x.ulke || "", musteri: x.musteri || "", kargoFirma: x.kargoFirma || "", takipNo: x.takipNo || "",
  sirket: x.sirket || SIRKETLER[0], tedarikci: x.tedarikci || TEDARIKCILER[0],
  komisyonOran: x.komisyonOran ?? 10, komisyonGercek: x.komisyonGercek ?? null,
  kargoGider: x.kargoGider ?? 0, birimMaliyet: x.birimMaliyet ?? 0, digerKesinti: x.digerKesinti ?? 0,
  iadeTutar: x.iadeTutar ?? 0, iadeSebep: x.iadeSebep || "", not: x.not || "", ham: x.ham || null,
});

/* Ürün anahtar kelimeleri kodda değişince kayıtlı kopya eskide kalıyor.
   Sürüm artınca yalnızca anahtarlar tazelenir — maliyet ve tedarikçi kullanıcınındır. */
const URUN_SURUM = 2;
function urunleriTazele(d) {
  if (!d) return d;
  const a = d.ayarlar || {};
  if (a.urunSurum === URUN_SURUM) return d;
  const yeni = Object.fromEntries(DEFAULT_URUNLER.map((u) => [u.ad, u.anahtar]));
  return { ...d,
    urunler: (d.urunler || []).map((u) => (yeni[u.ad] ? { ...u, anahtar: yeni[u.ad] } : u)),
    ayarlar: { ...a, urunSurum: URUN_SURUM } };
}

function seedOrders() {
  const raw = [
    ["2026-07-21", "Etsy Karelias", "Dana Derisi", 1, 349, "USD", "Teslim edildi", "Bekliyor", "USA", "DHL", "api"],
    ["2026-07-19", "Shopify USA", "Toskana", 2, 420, "USD", "Kargolandı", "Tahsil edildi", "USA", "FedEx", "webhook"],
    ["2026-07-18", "Trendyol", "Peluş", 3, 4200, "TRY", "Teslim edildi", "Bekliyor", "TR", "Yurtiçi", "api"],
    ["2026-07-17", "Wayfair", "Dana Derisi", 6, 289, "USD", "Kargolandı", "Bekliyor", "USA", "UPS", "api"],
    ["2026-07-15", "Faire", "Loopy Bombay", 10, 180, "USD", "Teslim edildi", "Bekliyor", "USA", "DHL", "api"],
    ["2026-07-14", "Etsy Sierra Rugs", "Petra India", 1, 265, "USD", "Teslim edildi", "Tahsil edildi", "CA", "DHL", "api"],
    ["2026-07-12", "Hepsiburada", "Monde", 2, 3850, "TRY", "İade", "Tahsil edildi", "TR", "Aras", "api"],
    ["2026-07-11", "Shopify TR", "Asır", 1, 5200, "TRY", "Teslim edildi", "Tahsil edildi", "TR", "Yurtiçi", "webhook"],
    ["2026-07-09", "eBay", "Zebra Baskı Dana", 1, 310, "USD", "Teslim edildi", "Tahsil edildi", "DE", "DHL", "api"],
    ["2026-07-07", "Etsy Karelias", "Tilki Kafa", 1, 520, "USD", "Kargolandı", "Bekliyor", "FR", "DHL", "api"],
    ["2026-07-05", "Mathis Home", "Dana Derisi", 24, 168, "USD", "Teslim edildi", "Bekliyor", "USA", "Konteyner", "csv"],
    ["2026-07-03", "Etsy Sisal Rugs", "Evita", 1, 198, "USD", "Teslim edildi", "Tahsil edildi", "UK", "DHL", "api"],
    ["2026-06-28", "Etsy Karelias", "Varaklı Dana Derisi", 2, 465, "USD", "Teslim edildi", "Tahsil edildi", "USA", "DHL", "api"],
    ["2026-06-26", "Wayfair", "Peluş", 8, 145, "USD", "Teslim edildi", "Tahsil edildi", "USA", "UPS", "api"],
    ["2026-06-24", "Trendyol", "Oğlak Derisi", 2, 5600, "TRY", "Teslim edildi", "Tahsil edildi", "TR", "Trendyol Express", "api"],
    ["2026-06-22", "Shopify USA", "Rex Tavşan", 1, 690, "USD", "Teslim edildi", "Tahsil edildi", "USA", "FedEx", "webhook"],
    ["2026-06-19", "Faire", "Monde", 12, 165, "USD", "Teslim edildi", "Tahsil edildi", "USA", "DHL", "api"],
    ["2026-06-17", "Etsy Palimera", "Peru", 1, 210, "USD", "İade", "Tahsil edildi", "USA", "DHL", "api"],
    ["2026-06-14", "Hepsiburada", "Peluş", 4, 3900, "TRY", "Teslim edildi", "Tahsil edildi", "TR", "Aras", "api"],
    ["2026-06-11", "eBay", "Post Deri Cüzdan", 5, 48, "USD", "Teslim edildi", "Tahsil edildi", "NL", "PTT", "api"],
    ["2026-06-08", "Etsy Sierra Rugs", "Loopy Bombay", 2, 240, "USD", "Teslim edildi", "Tahsil edildi", "USA", "DHL", "api"],
    ["2026-06-04", "Shopify USA", "Fok Extra Border", 1, 580, "USD", "Teslim edildi", "Tahsil edildi", "USA", "FedEx", "webhook"],
    ["2026-05-29", "Wayfair", "Dana Derisi", 10, 289, "USD", "Teslim edildi", "Tahsil edildi", "USA", "UPS", "api"],
    ["2026-05-26", "Etsy Karelias", "Ceylan Derisi", 1, 445, "USD", "Teslim edildi", "Tahsil edildi", "USA", "DHL", "api"],
    ["2026-05-22", "Trendyol", "Asır", 3, 4800, "TRY", "Teslim edildi", "Tahsil edildi", "TR", "Yurtiçi", "api"],
    ["2026-05-19", "Mathis Home", "Toskana", 16, 245, "USD", "Teslim edildi", "Tahsil edildi", "USA", "Konteyner", "csv"],
    ["2026-05-15", "Faire", "Evita", 14, 155, "USD", "Teslim edildi", "Tahsil edildi", "USA", "DHL", "api"],
    ["2026-05-12", "Shopify TR", "Peluş", 2, 3600, "TRY", "İptal", "Bekliyor", "TR", "Yurtiçi", "webhook"],
    ["2026-05-08", "Etsy Sisal Rugs", "Petra India", 1, 285, "USD", "Teslim edildi", "Tahsil edildi", "AU", "DHL", "api"],
    ["2026-05-05", "eBay", "Vizon", 1, 820, "USD", "Teslim edildi", "Tahsil edildi", "USA", "DHL", "api"],
  ];
  return raw.map((r, i) => {
    const [tarih, platform, urun, adet, fiyat, cur, durum, odeme, ulke, kargoFirma, kt] = r;
    const p = DEFAULT_PLATFORMS.find((x) => x.ad === platform);
    const u = DEFAULT_URUNLER.find((x) => x.ad === urun);
    const disId = String(48200000 + i * 3719);
    return kanonik({
      anahtar: platform + ":" + disId, disId, kaynakTur: kt, senkron: simdi(),
      no: "SP-" + String(1040 - i), tarih, platform, urun, adet, fiyat, cur, durum,
      odemeDurum: durum === "İptal" ? "Bekliyor" : odeme, ulke, kargoFirma,
      takipNo: durum === "Yeni" || durum === "Hazırlanıyor" ? "" : "TK" + (7300000 + i * 137),
      sirket: cur === "TRY" ? SIRKETLER[1] : SIRKETLER[0],
      tedarikci: u ? u.tedarikci : TEDARIKCILER[0], komisyonOran: p ? p.komisyon : 10,
      kargoGider: Math.round((cur === "TRY" ? 260 : 34) * (adet > 5 ? 2.2 : 1)),
      birimMaliyet: u ? Math.round(u.maliyet * (cur === "TRY" ? 42 : 1)) : 0,
      iadeTutar: durum === "İade" ? adet * fiyat : 0,
      iadeSebep: durum === "İade" ? "Beklentiyi karşılamadı" : "",
    });
  });
}

function seedHareketler() {
  const h = [
    ["2026-07-22", "mc2", "giris", 4820, "Platform hakedişi", "Etsy Karelias", "1–15 Temmuz hakediş"],
    ["2026-07-20", "mc2", "giris", 3960, "Platform hakedişi", "Shopify Payments", "Temmuz 1. yarı"],
    ["2026-07-20", "gt2", "cikis", 186000, "Tedarikçi ödemesi", "Asya Deri Halı", "ADH-2026-114"],
    ["2026-07-19", "mc1", "cikis", 2400, "Reklam", "Google Ads", "Temmuz reklam"],
    ["2026-07-19", "mc1", "cikis", 1650, "Reklam", "Meta Ads", "Temmuz reklam"],
    ["2026-07-14", "gt1", "giris", 61500, "Platform hakedişi", "Hepsiburada", "Haziran hakediş"],
    ["2026-07-12", "wf1", "giris", 8600, "Müşteri ödemesi", "Mathis Home LLC", "AG-2026-0142 kısmi"],
    ["2026-07-10", "mc1", "cikis", 3120, "Kargo & lojistik", "DHL", "Aylık fatura"],
    ["2026-07-08", "mc2", "giris", 1240, "Platform hakedişi", "eBay", "Haziran"],
    ["2026-07-05", "mc1", "cikis", 410, "Diğer", "Shopify", "Abonelik + uygulamalar"],
    ["2026-07-03", "gt1", "cikis", 46000, "Vergi & SGK", "GİB", "Haziran KDV"],
    ["2026-06-30", "gt2", "cikis", 94000, "Tedarikçi ödemesi", "Seyran Halı", "SYH-2026-88"],
    ["2026-06-28", "gt1", "cikis", 18000, "Diğer", "SMMM", "Mali müşavirlik"],
    ["2026-06-26", "wf1", "giris", 11800, "Platform hakedişi", "Wayfair", "Mayıs hakediş"],
    ["2026-06-22", "ws1", "giris", 6400, "Müşteri ödemesi", "Faire", "Haziran siparişleri"],
    ["2026-06-20", "mc1", "cikis", 2100, "Reklam", "Google Ads", "Haziran reklam"],
    ["2026-06-12", "mc1", "cikis", 1450, "Kargo & lojistik", "Gümrük müşaviri", "Konteyner gümrükleme"],
    ["2026-06-05", "zb1", "giris", 74000, "Platform hakedişi", "Trendyol", "Mayıs hakediş"],
    ["2026-05-31", "gt2", "cikis", 142000, "Tedarikçi ödemesi", "Asya Deri Halı", "ADH-2026-092"],
    ["2026-05-28", "mc2", "giris", 5240, "Platform hakedişi", "Etsy Karelias", "Mayıs 2. yarı"],
    ["2026-05-20", "mc1", "cikis", 1380, "Reklam", "Meta Ads", "Mayıs reklam"],
    ["2026-05-14", "gtu", "giris", 9800, "Müşteri ödemesi", "Mikro ihracat", "Mayıs ihracat bedeli"],
  ];
  const liste = h.map(([tarih, hesapId, yon, tutar, kategori, karsiTaraf, aciklama]) => ({
    id: uid(), tarih, hesapId, yon, tutar, kategori, karsiTaraf, aciklama,
    belge: "", eslesen: "", virmanId: "", kaynakTur: "manuel",
  }));
  /* Şirketler arası virman — Form 5472 açısından ayrı izlenmeli */
  const v = uid();
  liste.push(
    { id: uid(), tarih: "2026-06-18", hesapId: "ws1", yon: "cikis", tutar: 12000, kategori: "Hesaplar arası virman",
      karsiTaraf: "Garanti · USD (ihracat)", aciklama: "Asar Global → Asar Danışmanlık", belge: "", eslesen: "", virmanId: v, kaynakTur: "manuel" },
    { id: uid(), tarih: "2026-06-18", hesapId: "gtu", yon: "giris", tutar: 11940, kategori: "Hesaplar arası virman",
      karsiTaraf: "Wise · Çoklu döviz", aciklama: "Asar Global → Asar Danışmanlık", belge: "", eslesen: "", virmanId: v, kaynakTur: "manuel" });
  return liste;
}

const SEED = {
  surum: 4,
  bankalar: DEFAULT_BANKALAR,
  hareketler: seedHareketler(),
  ayarlar: { baz: "USD", tema: "acik", vurgu: "civit", kur: { USD: 1, EUR: 1.09, GBP: 1.28, TRY: 0.0238 }, vergiTR: 25, vergiUS: 21, urunSurum: URUN_SURUM },
  sunucu: { url: "", anahtar: "" },
  ekstreProfil: {},
  platformlar: DEFAULT_PLATFORMS,
  urunler: DEFAULT_URUNLER,
  baglantilar: DEFAULT_PLATFORMS.map((p) => ({ platform: p.ad, saglayici: p.saglayici, yontem: p.yontem, aktif: false, sonSenkron: null, sonDurum: "Bağlanmadı" })),
  senkronLog: [],
  siparisler: seedOrders(),
  giderler: [
    { id: uid(), tarih: "2026-07-20", kategori: "Tedarikçi ödemesi", aciklama: "Temmuz dana derisi partisi", karsiTaraf: "Asya Deri Halı", tutar: 186000, cur: "TRY", sirket: "Asar Danışmanlık", faturaNo: "ADH-2026-114", kdv: 20 },
    { id: uid(), tarih: "2026-07-18", kategori: "Reklam", aciklama: "Google Ads", karsiTaraf: "Google", tutar: 2400, cur: "USD", sirket: "Asar Global LLC", faturaNo: "GG-77218", kdv: 0 },
    { id: uid(), tarih: "2026-07-18", kategori: "Reklam", aciklama: "Meta Ads", karsiTaraf: "Meta", tutar: 1650, cur: "USD", sirket: "Asar Global LLC", faturaNo: "MT-99021", kdv: 0 },
    { id: uid(), tarih: "2026-07-10", kategori: "Kargo & lojistik", aciklama: "DHL aylık fatura", karsiTaraf: "DHL", tutar: 3120, cur: "USD", sirket: "Asar Global LLC", faturaNo: "DHL-5521", kdv: 0 },
    { id: uid(), tarih: "2026-07-05", kategori: "Yazılım & abonelik", aciklama: "Shopify + uygulamalar", karsiTaraf: "Shopify", tutar: 410, cur: "USD", sirket: "Asar Global LLC", faturaNo: "SH-8814", kdv: 0 },
    { id: uid(), tarih: "2026-06-30", kategori: "Tedarikçi ödemesi", aciklama: "Makine halı siparişi", karsiTaraf: "Seyran Halı", tutar: 94000, cur: "TRY", sirket: "Asar Danışmanlık", faturaNo: "SYH-2026-88", kdv: 20 },
    { id: uid(), tarih: "2026-06-28", kategori: "Muhasebe & danışmanlık", aciklama: "Mali müşavir", karsiTaraf: "SMMM", tutar: 18000, cur: "TRY", sirket: "Asar Danışmanlık", faturaNo: "MM-0626", kdv: 20 },
    { id: uid(), tarih: "2026-06-20", kategori: "Reklam", aciklama: "Google Ads", karsiTaraf: "Google", tutar: 2100, cur: "USD", sirket: "Asar Global LLC", faturaNo: "GG-76110", kdv: 0 },
    { id: uid(), tarih: "2026-06-12", kategori: "Gümrük", aciklama: "Mathis Home konteyner gümrükleme", karsiTaraf: "Gümrük müşaviri", tutar: 1450, cur: "USD", sirket: "Asar Global LLC", faturaNo: "GM-311", kdv: 0 },
    { id: uid(), tarih: "2026-05-31", kategori: "Tedarikçi ödemesi", aciklama: "Toskana + oğlak partisi", karsiTaraf: "Asya Deri Halı", tutar: 142000, cur: "TRY", sirket: "Asar Danışmanlık", faturaNo: "ADH-2026-092", kdv: 20 },
    { id: uid(), tarih: "2026-05-20", kategori: "Reklam", aciklama: "Meta Ads", karsiTaraf: "Meta", tutar: 1380, cur: "USD", sirket: "Asar Global LLC", faturaNo: "MT-97744", kdv: 0 },
    { id: uid(), tarih: "2026-05-10", kategori: "Vergi", aciklama: "KDV ödemesi (Nisan)", karsiTaraf: "GİB", tutar: 46000, cur: "TRY", sirket: "Asar Danışmanlık", faturaNo: "-", kdv: 0 },
  ],
  tahsilatlar: [
    { id: uid(), tarih: "2026-07-22", platform: "Etsy Karelias", donem: "1–15 Tem", tutar: 4820, cur: "USD", durum: "Tahsil edildi", sirket: "Asar Global LLC", kaynakTur: "api" },
    { id: uid(), tarih: "2026-07-20", platform: "Shopify USA", donem: "Temmuz 1. yarı", tutar: 3960, cur: "USD", durum: "Tahsil edildi", sirket: "Asar Global LLC", kaynakTur: "api" },
    { id: uid(), tarih: "2026-08-05", platform: "Wayfair", donem: "Haziran hakediş", tutar: 7420, cur: "USD", durum: "Bekliyor", sirket: "Asar Global LLC", kaynakTur: "manuel" },
    { id: uid(), tarih: "2026-08-10", platform: "Faire", donem: "Temmuz siparişleri", tutar: 3150, cur: "USD", durum: "Bekliyor", sirket: "Asar Global LLC", kaynakTur: "manuel" },
    { id: uid(), tarih: "2026-08-01", platform: "Trendyol", donem: "Temmuz hakediş", tutar: 82000, cur: "TRY", durum: "Bekliyor", sirket: "Asar Danışmanlık", kaynakTur: "api" },
    { id: uid(), tarih: "2026-07-14", platform: "Hepsiburada", donem: "Haziran hakediş", tutar: 61500, cur: "TRY", durum: "Tahsil edildi", sirket: "Asar Danışmanlık", kaynakTur: "api" },
    { id: uid(), tarih: "2026-09-01", platform: "Mathis Home", donem: "Temmuz konteyner", tutar: 4030, cur: "USD", durum: "Bekliyor", sirket: "Asar Global LLC", kaynakTur: "manuel" },
    { id: uid(), tarih: "2026-07-08", platform: "eBay", donem: "Haziran", tutar: 1240, cur: "USD", durum: "Tahsil edildi", sirket: "Asar Global LLC", kaynakTur: "api" },
  ],
  faturalar: [
    { id: uid(), tarih: "2026-07-20", no: "AG-2026-0142", tip: "Satış", karsiTaraf: "Mathis Home LLC", tutar: 4032, cur: "USD", kdv: 0, sirket: "Asar Global LLC", durum: "Kesildi" },
    { id: uid(), tarih: "2026-07-15", no: "AD-2026-0311", tip: "Satış", karsiTaraf: "Mikro ihracat – Temmuz", tutar: 218000, cur: "TRY", kdv: 0, sirket: "Asar Danışmanlık", durum: "Kesildi" },
    { id: uid(), tarih: "2026-07-12", no: "AD-2026-0309", tip: "Satış", karsiTaraf: "Trendyol yurtiçi", tutar: 96400, cur: "TRY", kdv: 20, sirket: "Asar Danışmanlık", durum: "Kesildi" },
    { id: uid(), tarih: "2026-06-30", no: "AG-2026-0131", tip: "Satış", karsiTaraf: "Faire Wholesale", tutar: 1980, cur: "USD", kdv: 0, sirket: "Asar Global LLC", durum: "Kesildi" },
    { id: uid(), tarih: "2026-06-28", no: "AD-2026-0294", tip: "Satış", karsiTaraf: "Hepsiburada yurtiçi", tutar: 74800, cur: "TRY", kdv: 20, sirket: "Asar Danışmanlık", durum: "Kesildi" },
    { id: uid(), tarih: "2026-07-24", no: "—", tip: "Satış", karsiTaraf: "Wayfair Haziran hakediş", tutar: 7420, cur: "USD", kdv: 0, sirket: "Asar Global LLC", durum: "Kesilecek" },
  ],
};

/* ── GERÇEK KULLANIMA GEÇERKEN BURAYI false YAPIN ──
   Örnek siparişler, giderler, hakedişler ve banka bakiyeleri temizlenir;
   panel boş açılır ve yalnızca sizin girdiğiniz veriyi gösterir.
   Hesap adları ve ürün grupları korunur, sadece rakamlar sıfırlanır. */
const ORNEK_VERI = false;


const BASLANGIC = ORNEK_VERI ? SEED : {
  ...SEED,
  siparisler: [], giderler: [], tahsilatlar: [], faturalar: [], hareketler: [], senkronLog: [],
  bankalar: SEED.bankalar.map((b) => ({ ...b, acilis: 0 })),
};

const useDB = () => {
  const [db, setDb] = useState(BASLANGIC);
  const [hazir, setHazir] = useState(false);
  useEffect(() => { (async () => {
    try { const kayit = await depo.oku(); if (kayit) setDb(urunleriTazele(kayit)); } catch (e) {}
    setHazir(true);
  })(); }, []);
  /* Kayıt geciktirilir — form doldururken her harfte tüm veritabanını yazmak
     birkaç bin kayıtta arayüzü kilitler */
  useEffect(() => {
    if (!hazir) return;
    const z = setTimeout(() => { (async () => { try { await depo.yaz(db); } catch (e) {} })(); }, 700);
    return () => clearTimeout(z);
  }, [db, hazir]);
  return [db, setDb, hazir];
};

/* "Peluş" ile "pelus" aynı şeydir; Excel'de hangisi yazıldığı kullanıcıya kalmış */
const sadelestir = (x) => String(x || "").toLocaleLowerCase("tr")
  .replace(/[şŞ]/g, "s").replace(/[ğĞ]/g, "g").replace(/[üÜ]/g, "u")
  .replace(/[ıİ]/g, "i").replace(/[öÖ]/g, "o").replace(/[çÇ]/g, "c")
  .replace(/\s+/g, " ").trim();

/* En uzun eşleşen anahtar kazanır — yoksa "Puantiyeli dikişli dana" içindeki
   kısa "dana" anahtarı satırı yanlışlıkla Dana Derisi'ne yazar. */
/* "sahin" yazınca "Şahin" bulunsun, "peluş 122" yazınca kelime sırası önemsiz olsun.
   Boş arama her kaydı geçirir. */
function araEsle(sorgu, alanlar) {
  const q = sadelestir(sorgu);
  if (!q) return true;
  const havuz = sadelestir(alanlar.filter(Boolean).join(" "));
  return q.split(" ").filter(Boolean).every((k) => havuz.includes(k));
}

/* Sipariş numarası boş olan satırlar için içerikten türetilen kalıcı anahtar.
   Sıra numarası veya bugünün tarihi kullanılsaydı aynı dosya ikinci kez
   yüklendiğinde her satır yeniden eklenirdi. */
function parmakIzi(...parcalar) {
  const t = parcalar.map((x) => sadelestir(x)).join("|");
  let h = 5381;
  for (let i = 0; i < t.length; i++) h = (((h << 5) + h + t.charCodeAt(i)) >>> 0);
  return h.toString(36);
}

function urunEsle(metin, urunler) {
  const t = sadelestir(metin);
  if (!t) return null;
  let enIyi = null, enUzun = 0;
  for (const u of urunler) {
    for (const k of String(u.anahtar || u.ad).split(",").map(sadelestir)) {
      if (k && t.includes(k) && k.length > enUzun) { enUzun = k.length; enIyi = u; }
    }
  }
  return enIyi;
}

function demoCek(platform, db) {
  const p = db.platformlar.find((x) => x.ad === platform);
  const n = 1 + Math.floor(Math.random() * 3);
  const c = [];
  for (let i = 0; i < n; i++) {
    const u = db.urunler[Math.floor(Math.random() * db.urunler.length)];
    const adet = 1 + Math.floor(Math.random() * 3);
    const carpan = p.cur === "TRY" ? 42 : 1;
    c.push({ disId: String(90000000 + Math.floor(Math.random() * 9999999)), tarih: bugun(), platform,
      urunAdi: u.ad + " Rug", sku: "KS-" + u.ad.slice(0, 3).toUpperCase() + "-" + (100 + i), adet,
      fiyat: Math.round(u.maliyet * carpan * (2.6 + Math.random() * 1.4)), cur: p.cur, durum: "Yeni",
      odemeDurum: "Bekliyor", ulke: p.cur === "TRY" ? "TR" : ["USA", "DE", "FR", "UK", "CA"][Math.floor(Math.random() * 5)],
      musteri: "", komisyonOran: p.komisyon });
  }
  return c;
}

function birlestir(mevcut, gelenler, db, kaynakTur) {
  const liste = [...mevcut];
  let yeni = 0, guncel = 0;
  const yeniIdler = [];
  gelenler.forEach((g) => {
    const anahtar = g.platform + ":" + g.disId;
    const u = urunEsle((g.urunAdi || "") + " " + (g.sku || ""), db.urunler);
    const p = db.platformlar.find((x) => x.ad === g.platform);
    const carpan = g.cur === "TRY" ? Math.round(1 / (db.ayarlar.kur.TRY || 0.024)) : 1;
    /* Dosyadan gelen değer varsa o kullanılır; yoksa ürün grubundan tahmin edilir */
    const gelen = { ...g, anahtar, kaynakTur, senkron: simdi(),
      urun: g.urun || (u ? u.ad : "Eşleşmedi"),
      tedarikci: g.tedarikci || (u ? u.tedarikci : TEDARIKCILER[0]),
      birimMaliyet: g.birimMaliyet != null && g.birimMaliyet > 0
        ? g.birimMaliyet : (u ? Math.round(u.maliyet * carpan) : 0),
      sirket: g.sirket || (g.cur === "TRY" ? SIRKETLER[1] : SIRKETLER[0]),
      komisyonOran: g.komisyonOran ?? (p ? p.komisyon : 10) };
    const i = liste.findIndex((o) => o.anahtar === anahtar);
    if (i < 0) { const k = kanonik(gelen); liste.unshift(k); yeniIdler.push(k.id); yeni++; }
    else {
      const eski = liste[i]; const korunan = {};
      (eski.elle || []).forEach((a) => { korunan[a] = eski[a]; });
      liste[i] = { ...eski, ...gelen, ...korunan, id: eski.id, no: eski.no, elle: eski.elle };
      guncel++;
    }
  });
  return { liste, yeni, guncel, yeniIdler };
}

/* Ayırıcı bankaya göre değişir: virgül (US), noktalı virgül (TR Excel), sekme */
function ayiriciSec(metin) {
  const satirlar = metin.split(/\r?\n/).filter((s) => s.trim()).slice(0, 6);
  const say = (ch) => satirlar.reduce((a, s) => {
    let n = 0, tirnak = false;
    for (let i = 0; i < s.length; i++) {
      const c = s[i];
      if (c === '"') tirnak = !tirnak; else if (c === ch && !tirnak) n++;
    }
    return a + n;
  }, 0);
  const aday = [[",", say(",")], [";", say(";")], ["\t", say("\t")]].sort((a, b) => b[1] - a[1]);
  return aday[0][1] > 0 ? aday[0][0] : ",";
}

/* Tırnak içindeki satır sonlarını da doğru geçer */
function csvIzgara(metin) {
  const ay = ayiriciSec(metin);
  const izgara = [];
  let satir = [], g = "", tirnak = false;
  for (let i = 0; i < metin.length; i++) {
    const c = metin[i];
    if (c === '"') { if (tirnak && metin[i + 1] === '"') { g += '"'; i++; } else tirnak = !tirnak; }
    else if (c === ay && !tirnak) { satir.push(g); g = ""; }
    else if ((c === "\n" || c === "\r") && !tirnak) {
      if (c === "\r" && metin[i + 1] === "\n") i++;
      satir.push(g); izgara.push(satir); satir = []; g = "";
    } else g += c;
  }
  satir.push(g);
  if (satir.some((x) => x !== "")) izgara.push(satir);
  return izgara.map((r) => r.map((x) => x.trim()));
}

/* Banka ve muhasebe dosyaları başlıktan önce banka adı, hesap no, dönem gibi satırlar
   taşır. Başlık satırı: kendisinden sonra da benzer genişlikte satır gelen ilk dolu satır. */
function izgaraTablo(izgara) {
  const bos = (x) => String(x ?? "").trim() === "";
  const dolu = (r) => (r || []).filter((x) => !bos(x)).length;
  const bak = Math.min(izgara.length, 25);
  let bi = -1;
  for (let i = 0; i < bak; i++)
    if (dolu(izgara[i]) >= 3 && izgara.slice(i + 1, i + 5).some((r) => dolu(r) >= 3)) { bi = i; break; }
  if (bi < 0) for (let i = 0; i < bak; i++) if (dolu(izgara[i]) >= 2) { bi = i; break; }
  if (bi < 0) bi = 0;

  /* Excel dosyaları biçimlendirilmiş ama boş sütunlar taşıyabiliyor — sağdaki
     tamamen boş sütunlar atılmazsa "Sütun 883" gibi yüzlerce sahte alan çıkar. */
  let son = -1;
  for (const r of izgara.slice(bi)) for (let i = 0; i < (r || []).length; i++) if (!bos(r[i]) && i > son) son = i;
  const genislik = son + 1;

  const ham = (izgara[bi] || []).map((x) => String(x ?? "").trim());
  const basliklar = [];
  for (let i = 0; i < genislik; i++) {
    let ad = ham[i] || "Sütun " + (i + 1);
    while (basliklar.includes(ad)) ad += " ";
    basliklar.push(ad);
  }
  const veriler = izgara.slice(bi + 1).filter((r) => dolu(r) > 0).map((r) => {
    const o = {};
    basliklar.forEach((b, i) => { o[b] = String(r[i] ?? "").trim(); });
    return o;
  });
  const onbilgi = izgara.slice(0, bi).map((r) => (r || []).join(" ")).join(" ");
  return { basliklar, veriler, onbilgi };
}

function csvAyristir(metin) {
  return izgaraTablo(csvIzgara(String(metin || "").replace(/^﻿/, "")));
}

/* Banka dosyaları UTF-8 olmayabilir — TR bankaları sık sık Windows-1254 verir.
   Önce UTF-8 denenir, bozuk karakter çıkarsa 1254'e düşülür. */
function metinCoz(buf) {
  const b = new Uint8Array(buf);
  if (b[0] === 0xEF && b[1] === 0xBB && b[2] === 0xBF) return new TextDecoder("utf-8").decode(b.subarray(3));
  if (b[0] === 0xFF && b[1] === 0xFE) return new TextDecoder("utf-16le").decode(b);
  if (b[0] === 0xFE && b[1] === 0xFF) return new TextDecoder("utf-16be").decode(b);
  const utf8 = new TextDecoder("utf-8").decode(b);
  if (!utf8.includes("�")) return utf8;
  try { return new TextDecoder("windows-1254").decode(b); } catch (e) { return utf8; }
}

/* .xlsx bir zip arşividir; tarayıcının yerleşik DecompressionStream'i deflate açabildiği
   için dış kütüphane gerekmiyor — sunucuya ek paket yüklenmiyor. */
async function zipAc(buf) {
  const dv = new DataView(buf), u8 = new Uint8Array(buf);
  let son = -1;
  for (let i = u8.length - 22; i >= 0 && i > u8.length - 66000; i--)
    if (dv.getUint32(i, true) === 0x06054b50) { son = i; break; }
  if (son < 0) throw new Error("dosya bir xlsx arşivi gibi görünmüyor");
  const adet = dv.getUint16(son + 10, true);
  let p = dv.getUint32(son + 16, true);
  const kayit = {};
  for (let i = 0; i < adet; i++) {
    if (p + 46 > u8.length || dv.getUint32(p, true) !== 0x02014b50) break;
    const yontem = dv.getUint16(p + 10, true);
    const boyut = dv.getUint32(p + 20, true);
    const adBoy = dv.getUint16(p + 28, true);
    const ekBoy = dv.getUint16(p + 30, true);
    const yorumBoy = dv.getUint16(p + 32, true);
    const yerel = dv.getUint32(p + 42, true);
    const ad = new TextDecoder().decode(u8.subarray(p + 46, p + 46 + adBoy));
    const bas = yerel + 30 + dv.getUint16(yerel + 26, true) + dv.getUint16(yerel + 28, true);
    kayit[ad] = { yontem, veri: u8.subarray(bas, bas + boyut) };
    p += 46 + adBoy + ekBoy + yorumBoy;
  }
  const cikar = async (ad) => {
    const d = kayit[ad];
    if (!d) return null;
    if (d.yontem === 0) return new TextDecoder().decode(d.veri);
    const akis = new Blob([d.veri]).stream().pipeThrough(new DecompressionStream("deflate-raw"));
    return new TextDecoder().decode(await new Response(akis).arrayBuffer());
  };
  return { adlar: Object.keys(kayit), cikar };
}

const xmlCoz = (x) => new DOMParser().parseFromString(x, "application/xml");

/* Çalışma kitabındaki sayfa adları ve hangi XML dosyasına denk düştükleri.
   Zip içindeki dosya sırası kitaptaki sırayla aynı olmak zorunda değil — ilişki
   dosyasından çözmezsek yanlış sayfa okunur. */
async function xlsxSayfalar(zip) {
  const kitap = await zip.cikar("xl/workbook.xml");
  if (!kitap) throw new Error("xlsx içinde çalışma kitabı bulunamadı");
  const iliski = await zip.cikar("xl/_rels/workbook.xml.rels");
  const hedef = {};
  if (iliski) for (const r of [...xmlCoz(iliski).getElementsByTagName("Relationship")])
    hedef[r.getAttribute("Id")] = String(r.getAttribute("Target") || "").replace(/^\/?(xl\/)?/, "");
  const liste = [...xmlCoz(kitap).getElementsByTagName("sheet")].map((s, i) => {
    const rid = s.getAttribute("r:id") || s.getAttribute("id");
    const yol = hedef[rid] || "worksheets/sheet" + (i + 1) + ".xml";
    return { ad: s.getAttribute("name") || "Sayfa " + (i + 1), yol: "xl/" + yol };
  });
  return liste.filter((s) => zip.adlar.includes(s.yol));
}

/* Bir sayfayı satır/sütun ızgarasına çevirir. Hücre biçimi değil değeri okunur;
   tarihler Excel seri numarası olarak gelir ve tarihCoz onları çözer. */
async function xlsxIzgara(buf, sayfaAdi) {
  const zip = await zipAc(buf);
  const sayfalar = await xlsxSayfalar(zip);
  if (!sayfalar.length) throw new Error("çalışma sayfası bulunamadı");
  const secili = sayfalar.find((s) => s.ad === sayfaAdi) || sayfalar[0];

  let ortak = [];
  const ss = await zip.cikar("xl/sharedStrings.xml");
  if (ss) ortak = [...xmlCoz(ss).getElementsByTagName("si")]
    .map((si) => [...si.getElementsByTagName("t")].map((t) => t.textContent).join(""));

  const doc = xmlCoz(await zip.cikar(secili.yol));
  const sutunNo = (ref) => {
    let n = 0;
    for (const ch of (String(ref).match(/^[A-Z]+/) || ["A"])[0]) n = n * 26 + (ch.charCodeAt(0) - 64);
    return n - 1;
  };
  const izgara = [...doc.getElementsByTagName("row")].map((row) => {
    const satir = [];
    for (const c of [...row.getElementsByTagName("c")]) {
      const i = sutunNo(c.getAttribute("r") || "A");
      const tur = c.getAttribute("t");
      let d = "";
      if (tur === "inlineStr") d = [...c.getElementsByTagName("t")].map((x) => x.textContent).join("");
      else {
        const v = c.getElementsByTagName("v")[0];
        d = v ? v.textContent : "";
        if (tur === "s") d = ortak[Number(d)] ?? "";
      }
      satir[i] = String(d ?? "").trim();
    }
    return satir;
  });
  return { izgara, sayfalar: sayfalar.map((s) => s.ad), sayfa: secili.ad };
}

/* Dosyadan tabloya — .csv/.txt metin, .xlsx zip olarak okunur.
   sayfaAdi verilmezse kitaptaki ilk sayfa alınır. */
async function dosyaOku(dosya, sayfaAdi) {
  const ad = (dosya.name || "").toLowerCase();
  const buf = await dosya.arrayBuffer();
  if (ad.endsWith(".xls") && !ad.endsWith(".xlsx"))
    throw new Error("eski .xls biçimi okunamıyor — Excel'de .xlsx veya CSV olarak kaydedin");
  if (ad.endsWith(".xlsx") || ad.endsWith(".xlsm")) {
    const { izgara, sayfalar, sayfa } = await xlsxIzgara(buf, sayfaAdi);
    return { ...izgaraTablo(izgara), ad: dosya.name, sayfalar, sayfa, buf };
  }
  return { ...csvAyristir(metinCoz(buf)), ad: dosya.name, sayfalar: [], sayfa: "" };
}

/* Aynı dosyanın başka bir sayfasına geç — dosyayı yeniden okumaya gerek yok */
async function sayfaDegis(tablo, sayfaAdi) {
  if (!tablo || !tablo.buf) return tablo;
  const { izgara, sayfalar, sayfa } = await xlsxIzgara(tablo.buf, sayfaAdi);
  return { ...izgaraTablo(izgara), ad: tablo.ad, sayfalar, sayfa, buf: tablo.buf };
}

const ALAN_IPUCU = {
  disId: ["disid", "order id", "order no", "order number", "sipariş no", "sipariş numarası", "receipt id", "po number", "name"],
  tarih: ["date", "tarih", "created", "paid at"],
  platform: ["platform", "pazaryeri", "marketplace", "satış yeri", "kanal"],
  urun: ["ürün grubu", "urun grubu", "ürün$", "product group", "tip", "type"],
  urunAdi: ["ürünadı", "urunadi", "product name", "item name", "lineitem name", "product", "ürün", "urun", "item", "title", "açıklama", "description"],
  sku: ["sku", "stok kodu", "barkod"],
  adet: ["adet", "qty", "quantity"],
  fiyat: ["fiyat", "price", "birim fiyat", "sales amount", "lineitem price"],
  cur: ["pb", "currency", "para birimi"],
  maliyet: ["birimmaliyet", "maliyet", "cost", "p.cost", "alış"],
  kargo: ["kargo", "shipping", "nakliye"],
  komisyonOran: ["komisyonoran", "komisyon %", "komisyon oran", "commission rate"],
  komisyonGercek: ["gerçekkomisyon", "gerceckomisyon", "komisyon tutar", "commission amount", "commission"],
  iadeTutar: ["iadetutar", "iade tutar", "return amount", "refund", "return", "iade"],
  durum: ["durum", "status", "sipariş durumu"],
  odemeDurum: ["ödeme", "odeme", "payment", "tahsilat"],
  sirket: ["şirket", "sirket", "company"],
  tedarikci: ["tedarikçi", "tedarikci", "vendor", "supplier"],
  en: ["w", "en", "genişlik", "width"],
  boy: ["h", "boy", "yükseklik", "height"],
  m2: ["m2", "m²", "metrekare", "alan"],
  ulke: ["ülke", "ulke", "country", "shipping country"],
  musteri: ["müşteri", "musteri", "customer", "buyer", "billing name"],
  takipNo: ["takip", "tracking"],
  kargoFirma: ["kargo firma", "carrier"],
};
/* Sıra önemli: önce dar ipuçlu alanlar eşleşir, alınan başlık bir daha kullanılmaz —
   yoksa "Product Group" ile "Product Name" aynı sütuna düşer. */
const otoEsle = (b) => {
  const m = {}, alinan = new Set();
  const ara = (ip) => {
    /* Önce birebir: "H" sütunu yalnızca "h" ipucuyla eşleşmeli.
       İçerik araması yapılsaydı "Shipping" başlığındaki h'ye takılırdı. */
    for (const i of ip) {
      const f = b.find((x) => !alinan.has(x) && x.trim().toLowerCase() === i);
      if (f) return f;
    }
    for (const i of ip) {
      if (i.length <= 2) continue;
      const f = b.find((x) => !alinan.has(x) && x.toLowerCase().includes(i));
      if (f) return f;
    }
    return null;
  };
  Object.entries(ALAN_IPUCU).forEach(([a, ip]) => {
    const f = ara(ip);
    if (f) { m[a] = f; alinan.add(f); }
  });
  return m;
};

/* Dosyada para birimi sütunu yoksa panel platformun varsayılanını kabul eder:
   Trendyol ve Shopify TR için TRY. Ama elle tutulan takip dosyaları çoğu zaman
   her şeyi tek para biriminde yazar. O zaman TRY sanılan satırlar 42'ye bölünür
   ve ciro sessizce kırkta bir görünür — bunu satır büyüklüklerinden yakalıyoruz:
   gerçekten TRY olsalardı USD satırlarından kat kat büyük olmaları gerekirdi. */
function paraSez(veriler, esleme, platformlar) {
  if (!esleme.fiyat || !esleme.platform) return "";
  const parap = platformlar.map((p) => [sadelestir(p.ad), p.cur]);
  const grup = {};
  veriler.forEach((v) => {
    const pa = sadelestir(v[esleme.platform]);
    if (!pa) return;
    const bulunan = parap.find(([a]) => pa.includes(a) || a.includes(pa));
    const t = sayiCoz(v[esleme.fiyat]);
    if (!bulunan || !(t > 0)) return;
    (grup[bulunan[1]] = grup[bulunan[1]] || []).push(t);
  });
  const orta = (a = []) => { const d = [...a].sort((x, y) => x - y); return d.length ? d[Math.floor(d.length / 2)] : 0; };
  const tr = orta(grup.TRY), usd = orta(grup.USD);
  if ((grup.TRY || []).length < 5 || (grup.USD || []).length < 5 || !tr || !usd) return "";
  return tr < usd * 5 ? "USD" : "";
}

/* Platform sütununun başlığı her zaman "Platform" olmuyor. Bu dosyada gerçek
   sütun "Wayfair" diye adlandırılmış, "Marketplace" başlıklı sütun ise bomboş —
   başlığa güvenip boş sütunu seçersek bütün siparişler tek platforma yazılır.
   Bu yüzden başlık eşleşmesi de içerikle doğrulanır. */
function platformOrani(basliklar, veriler, platformlar, sutun) {
  if (!sutun || !basliklar.includes(sutun)) return 0;
  const adlar = platformlar.map((p) => sadelestir(p.ad)).filter(Boolean);
  const d = veriler.map((v) => sadelestir(v[sutun])).filter(Boolean);
  if (d.length < 3) return 0;
  return d.filter((x) => adlar.some((a) => x.includes(a) || a.includes(x))).length / d.length;
}

function platformSutunuBul(basliklar, veriler, platformlar) {
  let iyi = null, iyiOran = 0;
  for (const b of basliklar) {
    const oran = platformOrani(basliklar, veriler, platformlar, b);
    if (oran > iyiOran) { iyiOran = oran; iyi = b; }
  }
  return iyiOran >= 0.6 ? iyi : null;
}


/* ═══════ EKSTRE OKUMA ═══════ */

/* Sayı biçimi bankaya göre değişir: 1.234,56 (TR) · 1,234.56 (US) · (1234.56) negatif */
function sayiCoz(m) {
  if (m == null || m === "") return 0;
  let t = String(m).replace(/[^\d,.\-+()]/g, "").trim();
  if (!t) return 0;
  const negatif = /^\(.*\)$/.test(String(m).trim()) || t.includes("-");
  t = t.replace(/[()+\-]/g, "");
  const nokta = t.lastIndexOf("."), virgul = t.lastIndexOf(",");
  if (virgul > nokta) t = t.replace(/\./g, "").replace(",", ".");  // 1.234,56
  else t = t.replace(/,/g, "");                                    // 1,234.56
  const n = parseFloat(t) || 0;
  return negatif ? -n : n;
}

/* Tarih biçimi belirsiz olabilir (05/06 → 5 Haziran mı 6 Mayıs mı), kullanıcı seçer */
function tarihCoz(m, bicim = "oto") {
  if (!m) return null;
  const t = String(m).trim();
  /* Excel tarihi seri numarası olarak saklar — 45000 ≈ 2023 */
  if (/^\d{5}(?:[.,]\d+)?$/.test(t)) {
    const n = parseFloat(t.replace(",", "."));
    if (n > 20000 && n < 60000)
      return new Date(Date.UTC(1899, 11, 30) + Math.round(n) * 86400000).toISOString().slice(0, 10);
  }
  let g = t.match(/^(\d{4})[-.\/](\d{1,2})[-.\/](\d{1,2})/);
  if (g) return `${g[1]}-${String(+g[2]).padStart(2, "0")}-${String(+g[3]).padStart(2, "0")}`;
  g = t.match(/^(\d{1,2})[-.\/](\d{1,2})[-.\/](\d{4})/);
  if (g) {
    let a = +g[1], b = +g[2];
    let gun, ayy;
    if (bicim === "gaa") { gun = a; ayy = b; }
    else if (bicim === "aag") { gun = b; ayy = a; }
    else { gun = a > 12 ? a : (b > 12 ? b : a); ayy = a > 12 ? b : (b > 12 ? a : b); }
    /* 01.25.2024 gibi ters yazılmış satırlar: ay 12'yi geçiyorsa yer değiştir.
       Hâlâ tutmuyorsa tarih okunamamış sayılır — uydurulmuş tarih hepsinden kötü. */
    if (ayy > 12 && gun <= 12) { const x = gun; gun = ayy; ayy = x; }
    if (ayy < 1 || ayy > 12 || gun < 1 || gun > 31) return null;
    return `${g[3]}-${String(ayy).padStart(2, "0")}-${String(gun).padStart(2, "0")}`;
  }
  const d = new Date(t);
  return isNaN(d.getTime()) ? null : d.toISOString().slice(0, 10);
}

/* Tek bir 07/12/2026 belirsizdir, ama sütunun tamamı çoğu zaman ele verir:
   bir satırda ilk parça 12'yi geçiyorsa gün önce, ikinci parça geçiyorsa ay öncedir. */
function tarihBicimSez(degerler) {
  let gaa = 0, aag = 0;
  for (const d of degerler) {
    const g = String(d ?? "").trim().match(/^(\d{1,2})[-.\/](\d{1,2})[-.\/]\d{4}/);
    if (!g) continue;
    if (+g[1] > 12) gaa++;
    if (+g[2] > 12) aag++;
  }
  /* Elle tutulan tabloda birkaç satır ters yazılmış olabilir; oybirliği aramak
     yüzlerce sağlam satırın kanıtını çöpe atar. Ezici çoğunluk yeter. */
  if (gaa >= 5 && gaa >= aag * 5) return "gaa";
  if (aag >= 5 && aag >= gaa * 5) return "aag";
  if (gaa && !aag) return "gaa";
  if (aag && !gaa) return "aag";
  return null;
}

/* Açıklamadan kategori tahmini — hepsi düzeltilebilir */
const KATEGORI_IPUCU = [
  [/etsy|shopify|trendyol|hepsiburada|wayfair|faire|ebay|payout|hakedi/i, "Platform hakedişi"],
  [/google|meta|facebook|\bads\b|reklam/i, "Reklam"],
  [/dhl|ups|fedex|kargo|aras|yurti[cç]i|ptt|shipping|freight/i, "Kargo & lojistik"],
  [/asya deri|seyran|tedarik|supplier/i, "Tedarikçi ödemesi"],
  [/g[iİ]b|vergi|kdv|sgk|\btax\b|muhtasar/i, "Vergi & SGK"],
  [/maa[sş]|salary|payroll|bordro/i, "Maaş"],
  [/komisyon|masraf|\bfee\b|charge|havale [uü]cret|bsmv/i, "Banka masrafı"],
  [/virman|transfer aras|kendi hesab/i, "Hesaplar arası virman"],
  [/iade|refund|chargeback|ters ibra/i, "İade / chargeback"],
];
const kategoriTahmin = (a) => (KATEGORI_IPUCU.find(([k]) => k.test(a || "")) || [null, "Diğer"])[1];

const EKSTRE_IPUCU = {
  tarih: ["tarih", "date", "işlem tarihi", "islem tarihi", "value date", "posted", "transaction date"],
  aciklama: ["açıklama", "aciklama", "description", "detay", "memo", "narrative", "işlem açıklaması"],
  tutar: ["tutar", "amount", "işlem tutarı", "islem tutari", "miktar", "value"],
  giris: ["alacak", "credit", "gelen", "para girişi", "deposit"],
  cikis: ["borç", "borc", "debit", "giden", "para çıkışı", "withdrawal"],
  referans: ["referans", "ref", "dekont", "işlem no", "transaction id", "fiş no", "id"],
  karsiTaraf: ["karşı taraf", "karsi taraf", "counterparty", "gönderen", "alıcı", "unvan", "name"],
};

/* Aynı ekstre iki kez yüklenirse mükerrer kayıt oluşmasın diye tekil anahtar */
function ekstreAnahtar(hesapId, h) {
  const temel = h.referans
    ? `${hesapId}:${h.referans}`
    : `${hesapId}:${h.tarih}:${h.yon}:${Math.round((Number(h.tutar) || 0) * 100)}:${(h.aciklama || "").slice(0, 40)}`;
  return temel.toLowerCase().replace(/\s+/g, " ");
}

function hareketBirlestir(mevcut, gelenler) {
  const liste = [...mevcut];
  const bilinen = new Set(liste.map((h) => h.anahtar).filter(Boolean));
  let yeni = 0, atlanan = 0;
  gelenler.forEach((g) => {
    if (bilinen.has(g.anahtar)) { atlanan++; return; }
    liste.unshift({ ...g, id: uid() });
    bilinen.add(g.anahtar);
    yeni++;
  });
  liste.sort((a, b) => (a.tarih < b.tarih ? 1 : -1));
  return { liste, yeni, atlanan };
}

/* ═══════ HAREKET & ARAYÜZ PARÇALARI ═══════ */

/* Sayı sıfırdan hedefe akar — rakamın ağırlığını hissettirir */
function useSayac(hedef, sure = 900) {
  const [d, setD] = useState(0);
  const onceki = useRef(0);
  useEffect(() => {
    const bas = onceki.current, fark = hedef - bas, t0 = performance.now();
    let iptal = false;
    const adim = (t) => {
      if (iptal) return;
      const p = Math.min(1, (t - t0) / sure);
      const e = 1 - Math.pow(1 - p, 3);
      setD(bas + fark * e);
      if (p < 1) requestAnimationFrame(adim); else onceki.current = hedef;
    };
    requestAnimationFrame(adim);
    return () => { iptal = true; onceki.current = hedef; };
  }, [hedef, sure]);
  return d;
}

const Kivilcim = ({ veri, renk = "var(--vurgu)" }) => {
  if (!veri || veri.length < 2) return null;
  const min = Math.min(...veri), max = Math.max(...veri), a = max - min || 1;
  const nokta = veri.map((v, i) => `${(i / (veri.length - 1)) * 100},${28 - ((v - min) / a) * 24}`).join(" ");
  return (
    <svg className="kivilcim" viewBox="0 0 100 30" preserveAspectRatio="none">
      <polyline points={`0,30 ${nokta} 100,30`} fill="url(#kg)" stroke="none" opacity=".18" />
      <polyline points={nokta} fill="none" stroke={renk} strokeWidth="1.6" vectorEffect="non-scaling-stroke" strokeLinejoin="round" />
      <defs><linearGradient id="kg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor={renk} /><stop offset="100%" stopColor={renk} stopOpacity="0" />
      </linearGradient></defs>
    </svg>
  );
};

const Delta = ({ v }) => {
  if (v === null || !isFinite(v)) return null;
  const yukari = v >= 0;
  return <span className={"delta " + (yukari ? "up" : "down")}>{yukari ? "▲" : "▼"} %{Math.abs(v).toFixed(0)}</span>;
};

const Panel = ({ baslik, sag, children, pad = true, gecikme = 0 }) => (
  <section className="panel bel" style={{ animationDelay: gecikme + "ms" }}>
    {(baslik || sag) && <header className="panel-h"><span className="eyebrow">{baslik}</span><div className="panel-h-r">{sag}</div></header>}
    <div className={pad ? "panel-b" : ""}>{children}</div>
  </section>
);

const Kpi = ({ etiket, deger, alt, ton, seri, delta, gecikme = 0 }) => (
  <div className="kpi bel" style={{ animationDelay: gecikme + "ms" }}>
    <div className="kpi-ust"><span className="eyebrow">{etiket}</span><Delta v={delta} /></div>
    <div className={"kpi-v " + (ton || "")}>{deger}</div>
    <div className="kpi-alt"><span className="kpi-a">{alt}</span>{seri && <Kivilcim veri={seri} renk={ton === "bad" ? "var(--kina)" : ton === "ok" ? "var(--yosun)" : "var(--vurgu)"} />}</div>
  </div>
);

const Pill = ({ v }) => {
  const map = { "Teslim edildi": "ok", "Tahsil edildi": "ok", "Kesildi": "ok", "Bağlı": "ok",
    "Kargolandı": "info", "Hazırlanıyor": "warn", "Yeni": "warn", "Bekliyor": "warn", "Kesilecek": "warn",
    "İade": "bad", "İptal": "bad", "Hata": "bad" };
  return <span className={"pill " + (map[v] || "")}><i />{v}</span>;
};

/* Banka işareti — varsayılan olarak harften çizilir; web/public/logolar/ içine
   gerçek logo konursa o kullanılır. Böylece panel dış kaynağa bağlı kalmıyor,
   üçüncü taraf marka dosyası da depoya gömülmüyor. Renkler pill diliyle uyumlu
   (soluk zemin + renkli harf) — dolu blok olsaydı kâr yeşili/zarar kırmızısıyla
   karışırdı. */
const BANKA_MARKA = {
  "wells fargo": { kisa: "WF", renk: "#B4343B" },
  "mercury": { kisa: "M", renk: "#5266EB" },
  "wise": { kisa: "W", renk: "#1F7A4C" },
  "garanti bbva": { kisa: "G", renk: "#0E8A4A" },
  "ziraat bankasi": { kisa: "Z", renk: "#C0392B" },
};
/* .png önce denenir: sunucu bulunamayan yolda index.html döndürüyor (tek sayfa
   uygulaması yönlendirmesi), yani "yok" cevabı 404 değil 200 geliyor. Sıra
   önemli değil gibi görünse de en olası biçimi başa almak gereksiz turu azaltır. */
const LOGO_UZANTI = ["png", "svg", "webp"];
/* Sonuç yalnızca sayfa açıkken hatırlanır. Bir zamanlar localStorage'a
   yazılıyordu; logo sonradan eklenince panel "yok" kaydını hatırlayıp bir daha
   bakmıyordu. Beş küçük istek, kalıcı yanlış cevaptan iyidir. */
const logoOnbellek = new Map();
const logoYaz = (slug, deger) => logoOnbellek.set(slug, deger);
try { localStorage.removeItem("karelias:logolar"); } catch (e) {}

function BankaLogo({ banka }) {
  const k = sadelestir(banka);
  const slug = k.replace(/\s+/g, "-");
  const marka = BANKA_MARKA[k] || { kisa: (banka || "?").trim().slice(0, 2).toUpperCase(), renk: "#7B99EE" };
  const [sira, setSira] = useState(() => (logoOnbellek.has(slug) ? logoOnbellek.get(slug) : 0));

  if (sira < LOGO_UZANTI.length) {
    return (
      <img className="bnk-logo" alt="" aria-hidden="true"
        src={`/logolar/${slug}.${LOGO_UZANTI[sira]}`}
        onError={() => { const y = sira + 1; logoYaz(slug, y); setSira(y); }}
        onLoad={() => { if (logoOnbellek.get(slug) !== sira) logoYaz(slug, sira); }} />);
  }
  return (
    <span className="bnk-mark" title={banka}
      style={{ color: marka.renk, borderColor: marka.renk + "44", background: marka.renk + "14" }}>
      {marka.kisa}
    </span>);
}

/* Platform başına sabit bir renk — 12 platformu okumadan ayırt etmeyi sağlıyor.
   Palette bilerek yeşil ve kırmızı yok: onlar kâr/zarar anlamına ayrılmış. */
const PLATFORM_RENK = {
  "wayfair": "#6E8FE0", "etsy karelias": "#B06BC4", "etsy sierra rugs": "#CC72AE",
  "etsy palimera": "#8E7BD8", "etsy sisal rugs": "#6FA3C9", "shopify usa": "#46BDB6",
  "shopify tr": "#4E9E97", "trendyol": "#C98A5E", "hepsiburada": "#A8785C",
  "faire": "#7B99EE", "ebay": "#9AA3B5", "mathis home": "#A0729B",
};
const YEDEK_RENK = ["#6E8FE0", "#B06BC4", "#46BDB6", "#C98A5E", "#8E7BD8", "#9AA3B5"];
function platformRenk(ad) {
  const k = sadelestir(ad);
  if (PLATFORM_RENK[k]) return PLATFORM_RENK[k];
  let h = 0;
  for (let i = 0; i < k.length; i++) h = (h * 31 + k.charCodeAt(i)) >>> 0;
  return YEDEK_RENK[h % YEDEK_RENK.length];
}
const PlatformRozet = ({ ad }) => (
  <span className="plat"><i style={{ background: platformRenk(ad) }} />{ad}</span>
);

/* Kaynak artık her satırda etiket değil, sipariş numarasının önünde küçük bir işaret —
   481 satırda tekrarlanan rozet tabloyu okunmaz hale getiriyordu. */
const KAYNAK_AD = { api: "API'den geldi", webhook: "Webhook ile geldi", csv: "Dosyadan yüklendi", manuel: "Elle girildi" };
const KaynakNokta = ({ t }) => <i className={"kay-n k-" + t} title={KAYNAK_AD[t] || "Bilinmiyor"} />;

const gunTam = (t) => {
  const [y, a, g] = String(t || "").split("-");
  if (!y || !a || !g) return t || "";
  return Number(g) + " " + AYLAR[Number(a) - 1] + " " + y;
};

const Kaynak = ({ t }) => <span className={"kay k-" + t}>{{ api: "API", webhook: "WBHK", csv: "CSV", manuel: "ELLE" }[t] || "—"}</span>;

const Serit = ({ maliyet, komisyon, kargo, kar, net, gecikme = 0 }) => {
  if (!net) return <div className="serit" />;
  const w = (x) => Math.max(0, (x / net) * 100) + "%";
  const st = { animationDelay: gecikme + "ms" };
  if (kar < 0) return <div className="serit"><i className="s-zarar buyu" style={{ ...st, width: "100%" }} /></div>;
  return (
    <div className="serit" title={`Maliyet %${Math.round((maliyet / net) * 100)} · Komisyon %${Math.round((komisyon / net) * 100)} · Kargo %${Math.round((kargo / net) * 100)} · Kâr %${Math.round((kar / net) * 100)}`}>
      <i className="s-mal buyu" style={{ ...st, width: w(maliyet) }} />
      <i className="s-kom buyu" style={{ ...st, width: w(komisyon) }} />
      <i className="s-go buyu" style={{ ...st, width: w(kargo) }} />
      <i className="s-kar buyu" style={{ ...st, width: w(kar) }} />
    </div>
  );
};

const Modal = ({ baslik, onClose, children, genis }) => (
  <div className="ovl" onClick={onClose}>
    <div className={"modal" + (genis ? " genis" : "")} onClick={(e) => e.stopPropagation()}>
      <header className="modal-h"><span className="eyebrow">{baslik}</span>
        <button className="btn ghost" onClick={onClose}>Kapat</button></header>
      <div className="modal-b">{children}</div>
    </div>
  </div>
);

const F = ({ label, children, w }) => (
  <label className="f" style={w ? { gridColumn: `span ${w}` } : undefined}><span>{label}</span>{children}</label>
);

const Onayli = ({ etiket, onay, onTamam }) => {
  const [a, setA] = useState(false);
  if (!a) return <button className="btn ghost" onClick={() => setA(true)}>{etiket}</button>;
  return <span className="onay"><b>{onay}</b>
    <button className="btn" onClick={() => { onTamam(); setA(false); }}>Evet</button>
    <button className="btn ghost" onClick={() => setA(false)}>Hayır</button></span>;
};


/* Riskli değişiklikleri uyarır — büyük fiyat sıçraması, sıfır stok, boş başlık */
function l_uyari(degisiklik, listelemeler) {
  const u = [];
  Object.entries(degisiklik).forEach(([id, d]) => {
    const l = listelemeler.find((x) => String(x.listelemeId) === String(id));
    if (!l) return;
    if (d.fiyat !== undefined && l.fiyat) {
      const fark = ((d.fiyat - l.fiyat) / l.fiyat) * 100;
      if (Math.abs(fark) >= 30) u.push(`${l.baslik.slice(0, 26)}: fiyat %${fark.toFixed(0)} değişiyor`);
      if (d.fiyat <= 0) u.push(`${l.baslik.slice(0, 26)}: fiyat sıfır veya eksi`);
    }
    if (d.stok !== undefined && d.stok === 0) u.push(`${l.baslik.slice(0, 26)}: stok sıfırlanıyor, listeleme görünmez olur`);
    if (d.baslik !== undefined && d.baslik.trim().length < 10) u.push(`${l.baslik.slice(0, 26)}: başlık çok kısa`);
    if (l.cokVaryasyonlu && d.fiyat !== undefined)
      u.push(`${l.baslik.slice(0, 26)}: ${l.varyasyonlar.length} varyasyonun HEPSİ aynı fiyata çekilecek`);
  });
  if (!u.length) return "";
  return "Dikkat — " + u.slice(0, 4).join(" · ") + (u.length > 4 ? ` · +${u.length - 4} uyarı daha` : "");
}

/* ═══════ ANA UYGULAMA ═══════ */

export default function App() {
  const [db, setDb, hazir] = useDB();
  const [gorunum, setGorunum] = useState("ozet");
  const [ayFilt, setAyFilt] = useState("hepsi");
  const [platFilt, setPlatFilt] = useState("hepsi");
  const [sirketFilt, setSirketFilt] = useState("hepsi");
  const [ara, setAra] = useState("");
  const [duzenle, setDuzenle] = useState(null);
  const [ice, setIce] = useState(false);
  const [virman, setVirman] = useState(false);
  const [ekstre, setEkstre] = useState(false);
  const [calisiyor, setCalisiyor] = useState("");
  const [parlayan, setParlayan] = useState([]);
  const [sayfa, setSayfa] = useState(1);
  const SAYFA_BOY = 100;
  const [bildirim, setBildirim] = useState([]);

  /* Oturumu kapat — ortak bilgisayarda panel açık kalmasın */
  const cikisYap = () => {
    try { localStorage.removeItem("karelias:jeton"); } catch (e) {}
    location.reload();
  };

  const haber = (m, tur = "ok") => {
    const id = uid();
    setBildirim((b) => [...b, { id, m, tur }]);
    setTimeout(() => setBildirim((b) => b.filter((x) => x.id !== id)), 3400);
  };

  const A = db.ayarlar, baz = A.baz;
  const koyu = (A.tema || "acik") === "koyu";
  const V = VURGULAR.find((x) => x.id === (A.vurgu || "civit")) || VURGULAR[2];
  const [vA, vB] = koyu ? V.koyu : V.acik;
  const G = koyu
    ? { izgara: "#3A2C21", yazi: "#C7B8A6", eksen: "#2C2119", ciroA: "#4A3A2A", ciroB: "#33261C",
        karA: vA, karB: vB, net: "#7FCB99", imlec: `rgba(${V.rgb},.08)`,
        tt: { background: "#241B14", border: "1px solid #3D2E22", borderRadius: 7, color: "#F3EADF", fontSize: 12, boxShadow: "0 10px 30px rgba(0,0,0,.5)" } }
    : { izgara: "#E7E7EC", yazi: "#45454C", eksen: "#D9D9DE", ciroA: "#C4C4CC", ciroB: "#9E9EA9",
        karA: vA, karB: vB, net: "#1B7A44", imlec: `rgba(${V.rgb},.09)`,
        tt: { background: "#FFFFFF", border: "1px solid #E2D8C9", borderRadius: 7, color: "#2A2018", fontSize: 12, boxShadow: "0 10px 30px rgba(90,70,45,.16)" } };
  const cev = (t, c) => (Number(t) || 0) * (A.kur[c] || 1) / (A.kur[baz] || 1);
  const sim = baz === "TRY" ? "₺" : baz === "USD" ? "$" : baz === "EUR" ? "€" : "£";
  const P = (n, d = 0) => {
    const s = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: d, minimumFractionDigits: d }).format(n || 0);
    return baz === "TRY" ? s + " ₺" : sim + s;
  };

  const hesap = (o) => {
    const brut = (Number(o.adet) || 0) * (Number(o.fiyat) || 0);
    const iade = Number(o.iadeTutar) || 0;
    const net = o.durum === "İptal" ? 0 : brut - iade;
    const kom = o.komisyonGercek != null ? Number(o.komisyonGercek) : net * ((Number(o.komisyonOran) || 0) / 100);
    const kargo = o.durum === "İptal" ? 0 : Number(o.kargoGider) || 0;
    const mal = o.durum === "İptal" ? 0 : (Number(o.adet) || 0) * (Number(o.birimMaliyet) || 0);
    const dig = Number(o.digerKesinti) || 0;
    const kar = net - kom - kargo - mal - dig;
    return { brut, iade, net, kom, kargo, mal, dig, kar, marj: net ? (kar / net) * 100 : 0,
      bazNet: cev(net, o.cur), bazKar: cev(kar, o.cur), bazMal: cev(mal, o.cur),
      bazKom: cev(kom, o.cur), bazKargo: cev(kargo, o.cur) };
  };

  /* ── BANKA ── */
  const bankalar = db.bankalar || [];
  const hareketler = db.hareketler || [];
  const hesapAdi = (id) => bankalar.find((b) => b.id === id)?.etiket || "—";
  const hesapCur = (id) => bankalar.find((b) => b.id === id)?.cur || baz;

  /* Bir tarihe kadarki bakiye — dönem başı devri için */
  const bakiye = (hid, tariheKadar) => {
    const h = bankalar.find((x) => x.id === hid);
    if (!h) return 0;
    return hareketler
      .filter((x) => x.hesapId === hid && (!tariheKadar || x.tarih < tariheKadar))
      .reduce((s, x) => s + (x.yon === "giris" ? 1 : -1) * (Number(x.tutar) || 0), Number(h.acilis) || 0);
  };

  const donemHareket = useMemo(() => hareketler.filter((x) =>
    (ayFilt === "hepsi" || ay(x.tarih) === ayFilt) &&
    (sirketFilt === "hepsi" || bankalar.find((b) => b.id === x.hesapId)?.sirket === sirketFilt) &&
    (!ara || [x.karsiTaraf, x.aciklama, x.kategori, x.belge, hesapAdi(x.hesapId)].join(" ").toLowerCase().includes(ara.toLowerCase()))
  ).sort((a, b) => (a.tarih < b.tarih ? 1 : -1)), [db, ayFilt, sirketFilt, ara]);

  const B = useMemo(() => {
    let giris = 0, cikis = 0;
    donemHareket.forEach((x) => {
      const d = cev(x.tutar, hesapCur(x.hesapId));
      if (x.yon === "giris") giris += d; else cikis += d;
    });
    const toplam = bankalar
      .filter((b) => sirketFilt === "hepsi" || b.sirket === sirketFilt)
      .reduce((s, b) => s + cev(bakiye(b.id), b.cur), 0);
    return { giris, cikis, net: giris - cikis, toplam };
  }, [donemHareket, db, baz, sirketFilt]);

  /* Beyan özeti: hesap bazında devir / giriş / çıkış / kapanış */
  const beyan = useMemo(() => {
    const bas = ayFilt === "hepsi" ? null : ayFilt + "-01";
    const sonAy = ayFilt === "hepsi" ? null : (() => {
      const [y, m] = ayFilt.split("-").map(Number);
      return m === 12 ? `${y + 1}-01-01` : `${y}-${String(m + 1).padStart(2, "0")}-01`;
    })();
    return bankalar.filter((b) => sirketFilt === "hepsi" || b.sirket === sirketFilt).map((b) => {
      const hs = hareketler.filter((x) => x.hesapId === b.id &&
        (!bas || (x.tarih >= bas && x.tarih < sonAy)));
      const giris = hs.filter((x) => x.yon === "giris").reduce((s, x) => s + (Number(x.tutar) || 0), 0);
      const cikis = hs.filter((x) => x.yon === "cikis").reduce((s, x) => s + (Number(x.tutar) || 0), 0);
      const devir = bakiye(b.id, bas);
      return { ...b, devir, giris, cikis, kapanis: devir + giris - cikis, adet: hs.length };
    });
  }, [db, ayFilt, sirketFilt]);

  const aylar = useMemo(() => {
    const s = new Set(db.siparisler.map((o) => ay(o.tarih)));
    db.giderler.forEach((g) => s.add(ay(g.tarih)));
    (db.hareketler || []).forEach((h) => s.add(ay(h.tarih)));
    return Array.from(s).sort().reverse();
  }, [db]);

  const siparisler = useMemo(() => db.siparisler.filter((o) =>
    (ayFilt === "hepsi" || ay(o.tarih) === ayFilt) && (platFilt === "hepsi" || o.platform === platFilt) &&
    (sirketFilt === "hepsi" || o.sirket === sirketFilt) &&
    araEsle(ara, [o.no, o.disId, o.urun, o.urunAdi, o.sku, o.platform, o.musteri, o.takipNo, o.ulke, o.tarih])
  ).sort((a, b) => (a.tarih < b.tarih ? 1 : -1)), [db, ayFilt, platFilt, sirketFilt, ara]);

  const giderler = useMemo(() => db.giderler.filter((g) =>
    (ayFilt === "hepsi" || ay(g.tarih) === ayFilt) && (sirketFilt === "hepsi" || g.sirket === sirketFilt)
  ).sort((a, b) => (a.tarih < b.tarih ? 1 : -1)), [db, ayFilt, sirketFilt]);

  const T = useMemo(() => {
    let ciro = 0, kom = 0, kargo = 0, mal = 0, kar = 0, iade = 0, adet = 0, iadeAdet = 0;
    siparisler.forEach((o) => { const h = hesap(o);
      ciro += h.bazNet; kom += h.bazKom; kargo += h.bazKargo; mal += h.bazMal; kar += h.bazKar;
      adet += Number(o.adet) || 0; if (o.durum === "İade") { iade += cev(h.iade, o.cur); iadeAdet++; } });
    const gider = giderler.filter((g) => g.kategori !== "Tedarikçi ödemesi").reduce((s, g) => s + cev(g.tutar, g.cur), 0);
    const tedarik = giderler.filter((g) => g.kategori === "Tedarikçi ödemesi").reduce((s, g) => s + cev(g.tutar, g.cur), 0);
    const bekleyen = db.tahsilatlar.filter((t) => t.durum === "Bekliyor").reduce((s, t) => s + cev(t.tutar, t.cur), 0);
    return { ciro, kom, kargo, mal, kar, iade, adet, iadeAdet, gider, tedarik, netKar: kar - gider, bekleyen, marj: ciro ? (kar / ciro) * 100 : 0 };
  }, [siparisler, giderler, db, baz]);

  const aylikSeri = useMemo(() => {
    const m = {};
    db.siparisler.forEach((o) => { const k = ay(o.tarih), h = hesap(o);
      m[k] = m[k] || { ay: k, ciro: 0, kar: 0, gider: 0 }; m[k].ciro += h.bazNet; m[k].kar += h.bazKar; });
    db.giderler.filter((g) => g.kategori !== "Tedarikçi ödemesi").forEach((g) => { const k = ay(g.tarih);
      m[k] = m[k] || { ay: k, ciro: 0, kar: 0, gider: 0 }; m[k].gider += cev(g.tutar, g.cur); });
    return Object.values(m).sort((a, b) => (a.ay < b.ay ? -1 : 1)).map((x) => ({ ...x, etiket: ayAdi(x.ay), net: x.kar - x.gider }));
  }, [db, baz]);

  /* Bir önceki döneme göre değişim */
  const delta = useMemo(() => {
    const i = ayFilt === "hepsi" ? aylikSeri.length - 1 : aylikSeri.findIndex((x) => x.ay === ayFilt);
    if (i < 1) return {};
    const s = aylikSeri[i], o = aylikSeri[i - 1];
    const y = (a, b) => (b ? ((a - b) / Math.abs(b)) * 100 : null);
    return { ciro: y(s.ciro, o.ciro), kar: y(s.kar, o.kar), gider: y(s.gider, o.gider), net: y(s.net, o.net) };
  }, [aylikSeri, ayFilt]);

  const seriler = useMemo(() => ({
    ciro: aylikSeri.map((x) => x.ciro), kar: aylikSeri.map((x) => x.kar),
    gider: aylikSeri.map((x) => x.gider), net: aylikSeri.map((x) => x.net),
  }), [aylikSeri]);

  const platformSeri = useMemo(() => {
    const m = {};
    siparisler.forEach((o) => { const h = hesap(o);
      m[o.platform] = m[o.platform] || { ad: o.platform, ciro: 0, kar: 0 };
      m[o.platform].ciro += h.bazNet; m[o.platform].kar += h.bazKar; });
    return Object.values(m).sort((a, b) => b.ciro - a.ciro);
  }, [siparisler, baz]);

  const urunSeri = useMemo(() => {
    const m = {};
    siparisler.forEach((o) => { const h = hesap(o);
      m[o.urun] = m[o.urun] || { ad: o.urun, ciro: 0, kar: 0, adet: 0 };
      m[o.urun].ciro += h.bazNet; m[o.urun].kar += h.bazKar; m[o.urun].adet += Number(o.adet) || 0; });
    return Object.values(m).map((x) => ({ ...x, marj: x.ciro ? (x.kar / x.ciro) * 100 : 0 })).sort((a, b) => b.kar - a.kar);
  }, [siparisler, baz]);

  /* ── ETSY LİSTELEME ── */
  const [etsyMagaza, setEtsyMagaza] = useState("Etsy Sisal Rugs");
  const [listelemeler, setListelemeler] = useState([]);
  const [degisiklik, setDegisiklik] = useState({});
  const [secili, setSecili] = useState([]);
  const [etsyYukleniyor, setEtsyYukleniyor] = useState(false);
  const [etsySonuc, setEtsySonuc] = useState([]);
  const [denemeYapildi, setDenemeYapildi] = useState(false);
  const [etsyAlt, setEtsyAlt] = useState("liste");
  const [acikSatir, setAcikSatir] = useState(null);
  const [etiketMetin, setEtiketMetin] = useState("");
  const [etsyDurumFiltre, setEtsyDurumFiltre] = useState("active");

  const etsyIstek = async (yol, secenek = {}) => {
    const { url, anahtar } = db.sunucu;
    if (!url) throw new Error("Sunucu adresi tanımlı değil");
    const r = await fetch(`${url.replace(/\/$/, "")}${yol}`, {
      ...secenek,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + anahtar, ...(secenek.headers || {}) },
    });
    const c = await r.json();
    if (!r.ok) throw new Error(c.hata || "Sunucu " + r.status);
    return c;
  };

  const listelemeleriYukle = async () => {
    setEtsyYukleniyor(true); setEtsySonuc([]); setDenemeYapildi(false);
    try {
      const c = await etsyIstek(`/api/etsy/listelemeler?magaza=${encodeURIComponent(etsyMagaza)}&durum=${etsyDurumFiltre}`);
      setListelemeler(c.listelemeler || []);
      setDegisiklik({}); setSecili([]); setAcikSatir(null);
      haber(`${(c.listelemeler || []).length} listeleme çekildi`);
    } catch (e) { haber("Listelemeler alınamadı: " + e.message, "bad"); }
    setEtsyYukleniyor(false);
  };

  const lst = (id) => listelemeler.find((x) => String(x.listelemeId) === String(id));

  /* Değişiklikler yerelde birikir; eski değere dönülürse kayıttan düşer */
  const degistir = (id, alan, deger) => {
    setDenemeYapildi(false);
    setDegisiklik((d) => {
      const l = lst(id);
      const eski = { baslik: l?.baslik, fiyat: l?.fiyat, stok: l?.stok }[alan];
      const y = { ...(d[id] || {}) };
      if (alan !== "etiketler" && alan !== "varyasyonlar" && String(deger) === String(eski)) delete y[alan];
      else y[alan] = deger;
      const t = { ...d };
      if (Object.keys(y).length) t[id] = y; else delete t[id];
      return t;
    });
  };

  const etiketleri = (id) => degisiklik[id]?.etiketler ?? (lst(id)?.etiketler || []);

  const etiketDegistir = (id, yeni) => {
    const l = lst(id);
    const ayni = JSON.stringify(yeni) === JSON.stringify(l?.etiketler || []);
    setDenemeYapildi(false);
    setDegisiklik((d) => {
      const y = { ...(d[id] || {}) };
      if (ayni) delete y.etiketler; else y.etiketler = yeni;
      const t = { ...d };
      if (Object.keys(y).length) t[id] = y; else delete t[id];
      return t;
    });
  };

  const varyasyonDegistir = (id, urunId, alan, deger) => {
    setDenemeYapildi(false);
    setDegisiklik((d) => {
      const v = { ...(d[id]?.varyasyonlar || {}) };
      v[urunId] = { ...(v[urunId] || {}), [alan]: Number(deger) };
      return { ...d, [id]: { ...(d[id] || {}), varyasyonlar: v } };
    });
  };

  /* ── Toplu işlemler ── */
  const topluFiyat = (yuzde) => {
    setDenemeYapildi(false);
    setDegisiklik((d) => {
      const t = { ...d };
      secili.forEach((id) => {
        const l = lst(id); if (!l?.fiyat) return;
        t[id] = { ...(t[id] || {}), fiyat: Math.round(l.fiyat * (1 + yuzde / 100) * 100) / 100 };
      });
      return t;
    });
    haber(`${secili.length} listelemede fiyat %${yuzde > 0 ? "+" : ""}${yuzde} — henüz gönderilmedi`);
  };

  const topluEtiket = (cikar) => {
    const kelimeler = etiketMetin.split(",").map((x) => x.trim().toLowerCase()).filter(Boolean);
    if (!kelimeler.length || !secili.length) return;
    let tasan = 0;
    secili.forEach((id) => {
      let e = [...etiketleri(id)];
      if (cikar) e = e.filter((x) => !kelimeler.includes(x.toLowerCase()));
      else {
        kelimeler.forEach((k) => {
          if (e.length >= 13) { tasan++; return; }
          if (!e.some((x) => x.toLowerCase() === k)) e.push(k);
        });
      }
      etiketDegistir(id, e);
    });
    setEtiketMetin("");
    haber(cikar ? `${kelimeler.length} etiket çıkarıldı` :
      tasan ? `Etiket eklendi — ${tasan} tanesi 13 sınırına takıldı` : `${kelimeler.length} etiket eklendi`);
  };

  const topluDurum = async (yeniDurum) => {
    if (!secili.length) return;
    setEtsyYukleniyor(true);
    try {
      const c = await etsyIstek("/api/etsy/durum", {
        method: "POST",
        body: JSON.stringify({ magaza: etsyMagaza, listelemeIdler: secili, yeniDurum }),
      });
      const ok = (c.sonuc || []).filter((x) => x.durum === "tamam").length;
      haber(`${ok} listeleme ${yeniDurum === "active" ? "yayınlandı" : yeniDurum === "inactive" ? "gizlendi" : "taslağa alındı"}`);
      listelemeleriYukle();
    } catch (e) { haber("Durum değiştirilemedi: " + e.message, "bad"); }
    setEtsyYukleniyor(false);
  };

  const kopyala = async (kaynakId) => {
    setEtsyYukleniyor(true);
    try {
      const c = await etsyIstek("/api/etsy/kopyala", {
        method: "POST", body: JSON.stringify({ magaza: etsyMagaza, kaynakId }),
      });
      haber(`Taslak oluşturuldu (${c.yeniId}) — fotoğrafları Etsy'den ekleyin`);
    } catch (e) { haber("Kopyalanamadı: " + e.message, "bad"); }
    setEtsyYukleniyor(false);
  };

  const etsyUygula = async (deneme) => {
    setEtsyYukleniyor(true);
    try {
      const islemler = Object.entries(degisiklik).map(([id, d]) => ({
        listelemeId: Number(id), baslik: d.baslik, fiyat: d.fiyat, stok: d.stok,
        etiketler: d.etiketler, varyasyonlar: d.varyasyonlar,
      }));
      const c = await etsyIstek("/api/etsy/uygula", {
        method: "POST", body: JSON.stringify({ magaza: etsyMagaza, islemler, deneme }),
      });
      setEtsySonuc(c.sonuc || []);
      if (deneme) {
        const hata = (c.sonuc || []).filter((x) => x.durum === "hata").length;
        setDenemeYapildi(hata === 0);
        haber(hata ? `Denemede ${hata} hata — düzeltmeden uygulamayın` : "Deneme temiz, uygulayabilirsiniz");
      } else {
        setDenemeYapildi(false); setDegisiklik({});
        haber(`${(c.sonuc || []).filter((x) => x.durum === "tamam").length} listeleme güncellendi`);
        listelemeleriYukle();
      }
    } catch (e) { haber("İşlem başarısız: " + e.message, "bad"); }
    setEtsyYukleniyor(false);
  };

  const etsySirali = useMemo(() => {
    const l = [...listelemeler];
    if (etsyAlt === "seo") return l.sort((a, b) => (a.seo?.puan ?? 100) - (b.seo?.puan ?? 100));
    if (etsyAlt === "perf") return l.sort((a, b) => (b.goruntulenme || 0) - (a.goruntulenme || 0));
    return l;
  }, [listelemeler, etsyAlt]);

  const ciroSayac = useSayac(T.ciro);

  /* Görünen dilim — filtre değişince başa dön */
  useEffect(() => { setSayfa(1); }, [ayFilt, platFilt, sirketFilt, ara, gorunum]);
  const sayfaSayisi = Math.max(1, Math.ceil(siparisler.length / SAYFA_BOY));
  const gorunen = useMemo(
    () => siparisler.slice((sayfa - 1) * SAYFA_BOY, sayfa * SAYFA_BOY),
    [siparisler, sayfa]);

  async function senkronEt(platform, sessiz) {
    setCalisiyor(platform);
    const bag = db.baglantilar.find((b) => b.platform === platform);
    const { url, anahtar } = db.sunucu;
    try {
      let gelenler;
      if (url) {
        const since = bag?.sonSenkron || "2020-01-01T00:00:00Z";
        const r = await fetch(`${url.replace(/\/$/, "")}/api/siparisler?platform=${encodeURIComponent(platform)}&since=${encodeURIComponent(since)}`,
          { headers: anahtar ? { Authorization: "Bearer " + anahtar } : {} });
        if (!r.ok) throw new Error("Sunucu " + r.status);
        const c = await r.json();
        gelenler = Array.isArray(c) ? c : c.siparisler || [];
      } else { await new Promise((r) => setTimeout(r, 650)); gelenler = demoCek(platform, db); }

      let ozet = null;
      setDb((d) => {
        const { liste, yeni, guncel, yeniIdler } = birlestir(d.siparisler, gelenler, d, url ? (bag?.yontem === "webhook" ? "webhook" : "api") : "api");
        ozet = { yeni, guncel, yeniIdler };
        return { ...d, siparisler: liste,
          baglantilar: d.baglantilar.map((b) => b.platform === platform ? { ...b, aktif: true, sonSenkron: simdi(), sonDurum: "Bağlı" } : b),
          senkronLog: [{ id: uid(), zaman: simdi(), platform, tur: url ? "API" : "DEMO", yeni, guncel, durum: "ok", mesaj: `${yeni} yeni, ${guncel} güncellendi` }, ...d.senkronLog].slice(0, 60) };
      });
      setTimeout(() => {
        if (ozet?.yeniIdler?.length) { setParlayan(ozet.yeniIdler); setTimeout(() => setParlayan([]), 2600); }
        if (!sessiz) haber(`${platform}: ${ozet.yeni} yeni, ${ozet.guncel} güncellendi`);
      }, 0);
    } catch (e) {
      setDb((d) => ({ ...d, baglantilar: d.baglantilar.map((b) => b.platform === platform ? { ...b, sonDurum: "Hata" } : b),
        senkronLog: [{ id: uid(), zaman: simdi(), platform, tur: "API", yeni: 0, guncel: 0, durum: "hata", mesaj: String(e.message || e) }, ...d.senkronLog].slice(0, 60) }));
      haber(`${platform} bağlanamadı: ${e.message}`, "bad");
    }
    setCalisiyor("");
  }

  async function hepsiniSenkronEt() {
    for (const b of db.baglantilar.filter((x) => x.yontem !== "csv")) await senkronEt(b.platform, true);
    haber("Tüm platformlar senkronize edildi");
  }

  const mutabakat = (t) => {
    let n = 0;
    setDb((d) => {
      const liste = d.siparisler.map((o) => {
        if (o.platform === t.platform && o.odemeDurum === "Bekliyor" && o.tarih <= t.tarih && o.durum !== "İptal") { n++; return { ...o, odemeDurum: "Tahsil edildi" }; }
        return o; });
      return { ...d, siparisler: liste,
        senkronLog: [{ id: uid(), zaman: simdi(), platform: t.platform, tur: "MUTABAKAT", yeni: 0, guncel: n, durum: "ok", mesaj: `${n} sipariş tahsil edildi` }, ...d.senkronLog].slice(0, 60) };
    });
    setTimeout(() => haber(`${t.platform}: ${n} sipariş tahsil edildi işaretlendi`), 0);
  };

  const kaydet = (tip, kayit) => {
    setDb((d) => {
      const liste = [...d[tip]];
      const i = liste.findIndex((x) => x.id === kayit.id);
      if (i >= 0) {
        let k = kayit;
        if (tip === "siparisler") {
          const eski = liste[i];
          const deg = Object.keys(kayit).filter((a) => !["elle", "senkron", "ham"].includes(a) && JSON.stringify(kayit[a]) !== JSON.stringify(eski[a]));
          k = { ...kayit, elle: Array.from(new Set([...(eski.elle || []), ...deg])) };
        }
        liste[i] = k;
      } else liste.unshift({ ...kayit, id: kayit.id || uid() });
      return { ...d, [tip]: liste };
    });
    setDuzenle(null);
    haber("Kaydedildi");
  };
  /* Virman iki bağlı hareket üretir: çıkan ve giren */
  const virmanKaydet = (v) => {
    const vid = uid();
    const kaynak = bankalar.find((b) => b.id === v.kaynakId);
    const hedef = bankalar.find((b) => b.id === v.hedefId);
    const ortak = { kategori: "Hesaplar arası virman", aciklama: v.aciklama, belge: "", eslesen: "", virmanId: vid, kaynakTur: "manuel" };
    const ikili = [
      { id: uid(), tarih: v.tarih, hesapId: v.kaynakId, yon: "cikis", tutar: Number(v.cikan) || 0, karsiTaraf: hedef?.etiket || "", ...ortak },
      { id: uid(), tarih: v.tarih, hesapId: v.hedefId, yon: "giris", tutar: Number(v.giren) || 0, karsiTaraf: kaynak?.etiket || "", ...ortak },
    ];
    setDb((d) => ({ ...d, hareketler: [...ikili, ...(d.hareketler || [])] }));
    setVirman(false);
    haber("Virman iki hesaba da işlendi");
  };

  const sil = (tip, id) => { setDb((d) => ({ ...d, [tip]: d[tip].filter((x) => x.id !== id) })); haber("Silindi", "bad"); };

  const indir = (icerik, ad, tur) => {
    const b = new Blob([icerik], { type: tur }); const a = document.createElement("a");
    a.href = URL.createObjectURL(b); a.download = ad; a.click(); haber(ad + " indirildi");
  };
  const csvAktar = () => {
    const b = ["No,DisID,Kaynak,Tarih,Platform,Ürün,Adet,Fiyat,PB,Net,Komisyon,Kargo,Maliyet,Kâr,Marj%,Durum,Ödeme,Şirket"];
    siparisler.forEach((o) => { const h = hesap(o);
      b.push([o.no, o.disId, o.kaynakTur, o.tarih, o.platform, o.urun, o.adet, o.fiyat, o.cur,
        h.net.toFixed(2), h.kom.toFixed(2), h.kargo, h.mal, h.kar.toFixed(2), h.marj.toFixed(1), o.durum, o.odemeDurum, o.sirket].join(",")); });
    indir("\uFEFF" + b.join("\n"), `siparisler-${bugun()}.csv`, "text/csv");
  };

  const NAV = [["ozet", "Genel bakış", ""], ["siparis", "Siparişler", siparisler.length],
    ["kargo", "Kargo & iade", siparisler.filter((o) => o.durum === "Kargolandı").length],
    ["tahsilat", "Tahsilat", db.tahsilatlar.filter((t) => t.durum === "Bekliyor").length],
    ["banka", "Bankalar", (db.bankalar || []).length],
    ["etsy", "Etsy listeleme", ""],
    ["gider", "Giderler", ""], ["muhasebe", "Ön muhasebe", ""],
    ["baglanti", "Bağlantılar", ""], ["ayar", "Ayarlar", ""]];

  const donemAdi = ayFilt === "hepsi" ? "Tüm dönemler" : ayTam(ayFilt);
  const akis = [["Ürün maliyeti", T.mal, "s-mal"], ["Komisyon", T.kom, "s-kom"],
    ["Kargo", T.kargo, "s-go"], ["İşletme gideri", T.gider, "s-gid"], ["Kalan kâr", Math.max(0, T.netKar), "s-kar"]];
  const akisTop = akis.reduce((s, x) => s + Math.max(0, x[1]), 0) || 1;

  return (
    <div className={"app v-" + V.id + (koyu ? "" : " acik")}>
      <style>{CSS}</style>

      <aside className="rail">
        <div className="brand">
          <span className="brand-k">K<em>&amp;</em>S</span>
          <span className="brand-t">Karelias &amp; Sons<span>işletme paneli</span></span>
        </div>
        <nav>{NAV.map(([k, t, n]) => (
          <button key={k} className={"nav" + (gorunum === k ? " on" : "")} onClick={() => setGorunum(k)}>
            <span>{t}</span>{n ? <b>{n}</b> : null}
            {k === "baglanti" && !db.sunucu.url && <i className="nokta" />}
          </button>))}
        </nav>
        <div className="rail-f">
          <span className="eyebrow">Bekleyen tahsilat</span>
          <div className="rail-v">{P(T.bekleyen)}</div>
          <div className="rail-s">{db.senkronLog[0]
            ? `son akış · ${new Date(db.senkronLog[0].zaman).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}`
            : "henüz senkron yok"}</div>
          <button className="cikis" onClick={cikisYap}>Oturumu kapat</button>
        </div>
      </aside>

      <main className="main">
        <div className="bar">
          <div className="bar-l">
            <select value={ayFilt} onChange={(e) => setAyFilt(e.target.value)}>
              <option value="hepsi">Tüm dönemler</option>
              {aylar.map((a) => <option key={a} value={a}>{ayTam(a)}</option>)}
            </select>
            <select value={platFilt} onChange={(e) => setPlatFilt(e.target.value)}>
              <option value="hepsi">Tüm platformlar</option>
              {db.platformlar.map((p) => <option key={p.ad} value={p.ad}>{p.ad}</option>)}
            </select>
            <select value={sirketFilt} onChange={(e) => setSirketFilt(e.target.value)}>
              <option value="hepsi">Her iki şirket</option>
              {SIRKETLER.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
            <div className="arama"><input placeholder="Müşteri, sipariş no, ürün, SKU, takip no" value={ara} onChange={(e) => setAra(e.target.value)} />
              {ara && <button className="temizle" onClick={() => setAra("")}>×</button>}</div>
          </div>
          <div className="bar-r">
            <button className={"btn ghost senk" + (calisiyor ? " calisiyor" : "")} onClick={hepsiniSenkronEt} disabled={!!calisiyor}>
              <i className="carkifelek" />{calisiyor ? calisiyor : "Senkronize et"}
            </button>
            <button className="btn ghost tema-dgm" title={koyu ? "Açık temaya geç" : "Koyu temaya geç"}
              onClick={() => setDb((d) => ({ ...d, ayarlar: { ...d.ayarlar, tema: koyu ? "acik" : "koyu" } }))}>
              {koyu ? "☀" : "☾"}
            </button>
            <div className="seg">{CURRENCIES.map((c) => (
              <button key={c} className={baz === c ? "on" : ""} onClick={() => setDb((d) => ({ ...d, ayarlar: { ...d.ayarlar, baz: c } }))}>{c}</button>))}
            </div>
          </div>
        </div>

        <div key={gorunum + ayFilt + platFilt} className="sahne">

        {gorunum === "ozet" && (<>
          {/* ── HERO: ciro ve paranın akışı ── */}
          <section className="hero">
            <div className="hero-ust">
              <div className="hero-sol">
                <span className="eyebrow">{donemAdi} · {platFilt === "hepsi" ? "tüm platformlar" : platFilt}</span>
                <div className="hero-rakam">
                  <em>{sim}</em>{new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(ciroSayac)}
                </div>
                <div className="hero-alt">
                  <span>net ciro</span><Delta v={delta.ciro} />
                  <span className="ayirac" />
                  <span>{siparisler.length} sipariş · {T.adet} adet</span>
                </div>
              </div>
              <div className="hero-sag">
                <div className="hero-mini"><span className="eyebrow">Brüt kâr</span>
                  <b className={T.kar >= 0 ? "ok" : "bad"}>{P(T.kar)}</b><Kivilcim veri={seriler.kar} renk="var(--yosun)" /></div>
                <div className="hero-mini"><span className="eyebrow">Net sonuç</span>
                  <b className={T.netKar >= 0 ? "ok" : "bad"}>{P(T.netKar)}</b><Kivilcim veri={seriler.net} renk="var(--vurgu)" /></div>
                <div className="hero-mini"><span className="eyebrow">Kâr marjı</span>
                  <b>%{T.marj.toFixed(1)}</b><Kivilcim veri={seriler.ciro} renk="var(--cini)" /></div>
              </div>
            </div>

            <div className="akis">
              {akis.map(([ad, v, cls], i) => (
                <div key={ad} className="akis-seg" style={{ flexGrow: Math.max(0.02, v), animationDelay: 220 + i * 110 + "ms" }}>
                  <i className={cls} />
                  <div className="akis-bilgi">
                    <b>%{Math.round((Math.max(0, v) / akisTop) * 100)}</b>
                    <span>{ad}</span><em>{P(v)}</em>
                  </div>
                </div>))}
            </div>
          </section>

          <div className="kpi-grid">
            <Kpi etiket="Ürün maliyeti" deger={P(T.mal)} alt={`ciro'nun %${T.ciro ? ((T.mal / T.ciro) * 100).toFixed(0) : 0}'i`} gecikme={0} />
            <Kpi etiket="Komisyonlar" deger={P(T.kom)} alt={`ciro'nun %${T.ciro ? ((T.kom / T.ciro) * 100).toFixed(1) : 0}'i`} gecikme={60} />
            <Kpi etiket="Kargo gideri" deger={P(T.kargo)} alt={`ciro'nun %${T.ciro ? ((T.kargo / T.ciro) * 100).toFixed(1) : 0}'i`} gecikme={120} />
            <Kpi etiket="İşletme gideri" deger={P(T.gider)} alt="tedarikçi hariç" seri={seriler.gider} delta={delta.gider} gecikme={180} />
            <Kpi etiket="Tedarikçi ödemesi" deger={P(T.tedarik)} alt="Asya Deri + Seyran" gecikme={240} />
            <Kpi etiket="İadeler" deger={P(T.iade)} alt={`${T.iadeAdet} sipariş · %${siparisler.length ? ((T.iadeAdet / siparisler.length) * 100).toFixed(1) : 0}`} ton={T.iadeAdet ? "bad" : ""} gecikme={300} />
          </div>

          <div className="grid2">
            <Panel baslik="Aylık ciro, kâr ve gider" gecikme={100}>
              <div style={{ height: 252 }}>
                <ResponsiveContainer>
                  <ComposedChart data={aylikSeri} margin={{ top: 10, right: 6, left: -14, bottom: 0 }}>
                    <defs>
                      <linearGradient id="gCiro" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor={G.ciroA} /><stop offset="100%" stopColor={G.ciroB} /></linearGradient>
                      <linearGradient id="gKar" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor={G.karA} /><stop offset="100%" stopColor={G.karB} /></linearGradient>
                    </defs>
                    <CartesianGrid stroke={G.izgara} vertical={false} />
                    <XAxis dataKey="etiket" tick={{ fill: G.yazi, fontSize: 12 }} axisLine={{ stroke: G.eksen }} tickLine={false} />
                    <YAxis tick={{ fill: G.yazi, fontSize: 12 }} axisLine={false} tickLine={false} />
                    <Tooltip contentStyle={G.tt} formatter={(v, n) => [P(v), n]} cursor={{ fill: G.imlec }} />
                    <Bar dataKey="ciro" name="Ciro" fill="url(#gCiro)" radius={[4, 4, 0, 0]} animationDuration={900} />
                    <Bar dataKey="kar" name="Brüt kâr" fill="url(#gKar)" radius={[4, 4, 0, 0]} animationDuration={900} />
                    <Line type="monotone" dataKey="net" name="Net sonuç" stroke={G.net} strokeWidth={2.2} dot={{ r: 3, fill: G.net, strokeWidth: 0 }} animationDuration={1100} />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            </Panel>

            <Panel baslik="Platform bazında ciro" gecikme={160} pad={false}>
              <div className="pl-liste">
                {platformSeri.map((p, i) => {
                  const en = platformSeri[0]?.ciro || 1;
                  return (
                    <div key={p.ad} className="pl" style={{ animationDelay: 200 + i * 45 + "ms" }}>
                      <span className="pl-ad">{p.ad}</span>
                      <div className="pl-yol"><i className="buyu" style={{ width: (p.ciro / en) * 100 + "%", animationDelay: 240 + i * 45 + "ms" }} /></div>
                      <span className="pl-v n">{P(p.ciro)}</span>
                      <span className={"pl-k n " + (p.kar >= 0 ? "ok" : "bad")}>{P(p.kar)}</span>
                    </div>);
                })}
                {!platformSeri.length && <div className="bos">Bu filtrede satış yok.</div>}
              </div>
            </Panel>
          </div>

          <Panel baslik="Ürün grubu kârlılığı" sag={<span className="mini">kârdan büyüğe · {urunSeri.length} grup</span>} pad={false} gecikme={220}>
            <div className="tbl-sar">
              <table className="tbl">
                <thead><tr><th>Ürün grubu</th><th className="r">Adet</th><th className="r">Ciro</th><th className="r">Kâr</th><th className="r">Marj</th><th style={{ width: 170 }}>Marj dağılımı</th></tr></thead>
                <tbody>{urunSeri.map((u, i) => (
                  <tr key={u.ad} className="bel-satir" style={{ animationDelay: Math.min(i * 22, 500) + "ms" }}>
                    <td className="kalin">{u.ad}</td><td className="r n">{u.adet}</td><td className="r n">{P(u.ciro)}</td>
                    <td className={"r n " + (u.kar >= 0 ? "ok" : "bad")}>{P(u.kar)}</td>
                    <td className="r n">%{u.marj.toFixed(1)}</td>
                    <td><div className="mini-bar"><i className={"buyu " + (u.marj >= 0 ? "" : "neg")} style={{ width: Math.min(100, Math.max(2, u.marj)) + "%", animationDelay: 200 + i * 22 + "ms" }} /></div></td></tr>))}
                  {!urunSeri.length && <tr><td colSpan="6" className="bos">Bu filtrede sipariş yok.</td></tr>}
                </tbody>
              </table>
            </div>
          </Panel>
        </>)}

        {gorunum === "siparis" && (
          <Panel baslik={`Siparişler — ${siparisler.length} kayıt`}
            sag={<><button className="btn ghost" onClick={() => setIce(true)}>Dosya yükle</button>
              <button className="btn ghost" onClick={csvAktar}>CSV indir</button>
              <button className="btn" onClick={() => setDuzenle({ tip: "siparisler", kayit: kanonik({ platform: db.platformlar[0].ad, cur: db.platformlar[0].cur, komisyonOran: db.platformlar[0].komisyon }) })}>Sipariş ekle</button></>} pad={false}>
            <div className="tbl-sar">
            <div className="sip-liste">
              {(() => {
                /* Tablo yerine ferah liste: her sipariş iki kademe — üstte ne satıldı
                   ve ne kazandırdı, altta kim/nereden ve maliyet kırılımı. */
                const cikti = [];
                let oncekiGun = null;
                gorunen.forEach((o, i) => {
                  if (o.tarih !== oncekiGun) {
                    oncekiGun = o.tarih;
                    const gun = siparisler.filter((x) => x.tarih === o.tarih);
                    const toplam = gun.reduce((a, x) => a + hesap(x).bazNet, 0);
                    const gunKar = gun.reduce((a, x) => a + hesap(x).bazKar, 0);
                    cikti.push(
                      <div key={"g-" + o.tarih} className="gun">
                        <span className="gun-ad">{gunTam(o.tarih)}</span>
                        <span className="gun-adet">{gun.length} sipariş</span>
                        <span className="gun-cizgi" />
                        <span className="gun-tut n">{P(toplam)}</span>
                        <span className={"gun-kar n " + (gunKar >= 0 ? "ok" : "bad")}>{P(gunKar)}</span>
                      </div>);
                  }
                  const h = hesap(o);
                  cikti.push(
                    <div key={o.id}
                      className={"sip bel-satir" + (parlayan.includes(o.id) ? " parla" : "")}
                      style={{ animationDelay: Math.min(i * 12, 260) + "ms" }}
                      onClick={() => setDuzenle({ tip: "siparisler", kayit: o })}>
                      <i className="sip-bar" style={{ background: platformRenk(o.platform) }} />

                      <div className="sip-kim">
                        <div className="sip-urun">
                          {o.urun}
                          {o.en && o.boy ? <span className="sip-olcu">{Math.round(o.boy)}×{Math.round(o.en)} cm</span> : null}
                          {(o.elle || []).length > 0 && <i className="kilit" title="Elle düzeltilmiş alanlar var — senkron ezmez">◆</i>}
                        </div>
                        <div className="sip-meta">
                          <span className="sip-plat"><i style={{ background: platformRenk(o.platform) }} />{o.platform}</span>
                          <span className="ayr" />
                          <span className="kod"><KaynakNokta t={o.kaynakTur} />{o.no}</span>
                          {o.m2 ? <><span className="ayr" /><span>{Number(o.m2).toFixed(2)} m²</span></> : null}
                          {Number(o.adet) > 1 ? <><span className="ayr" /><span>{o.adet} adet</span></> : null}
                          {o.musteri ? <><span className="ayr" /><span className="sip-mus">{o.musteri}</span></> : null}
                        </div>
                      </div>

                      <div className="sip-gider">
                        <Serit maliyet={h.mal} komisyon={h.kom} kargo={h.kargo} kar={h.kar} net={h.net}
                          gecikme={Math.min(i * 12, 260) + 90} />
                        <div className="sip-kirilim">
                          <span>maliyet <b className="n">{P(h.bazMal)}</b></span>
                          <span>komisyon <b className="n">{P(h.bazKom)}</b></span>
                          <span>kargo <b className="n">{P(h.bazKargo)}</b></span>
                        </div>
                      </div>

                      <div className="sip-tutar">
                        <div className="sip-net n">{P(h.bazNet)}</div>
                      </div>

                      <div className="sip-tutar">
                        <div className={"sip-kar n " + (h.kar >= 0 ? "ok" : "bad")}>{P(h.bazKar)}</div>
                        <div className={"sip-etiket " + (h.kar >= 0 ? "" : "bad")}>%{h.marj.toFixed(0)} marj</div>
                      </div>

                      <div className="sip-durum">
                        <Pill v={o.durum} />
                        <Pill v={o.odemeDurum} />
                      </div>

                      <button className="x sil-h" title="Bu siparişi sil"
                        onClick={(e) => { e.stopPropagation(); sil("siparisler", o.id); }}>sil</button>
                    </div>);
                });
                return cikti;
              })()}
              {!siparisler.length && <div className="bos">Kayıt yok. Sipariş ekleyin, CSV/Excel yükleyin ya da Bağlantılar'dan senkronize edin.</div>}
            </div>
            </div>
            {sayfaSayisi > 1 && (
              <div className="sayfalar">
                <button className="btn ghost" disabled={sayfa === 1} onClick={() => setSayfa(1)}>ilk</button>
                <button className="btn ghost" disabled={sayfa === 1} onClick={() => setSayfa(sayfa - 1)}>önceki</button>
                <span className="n">
                  {(sayfa - 1) * SAYFA_BOY + 1}–{Math.min(sayfa * SAYFA_BOY, siparisler.length)}
                  <em> / {siparisler.length}</em>
                </span>
                <button className="btn ghost" disabled={sayfa === sayfaSayisi} onClick={() => setSayfa(sayfa + 1)}>sonraki</button>
                <button className="btn ghost" disabled={sayfa === sayfaSayisi} onClick={() => setSayfa(sayfaSayisi)}>son</button>
              </div>)}
          </Panel>
        )}

        {gorunum === "kargo" && (<>
          <div className="kpi-grid k4">
            <Kpi etiket="Hazırlanıyor" deger={siparisler.filter((o) => o.durum === "Hazırlanıyor" || o.durum === "Yeni").length} alt="sevk bekleyen" gecikme={0} />
            <Kpi etiket="Yolda" deger={siparisler.filter((o) => o.durum === "Kargolandı").length} alt="teslim bekleyen" gecikme={60} />
            <Kpi etiket="İade" deger={T.iadeAdet} alt={P(T.iade)} ton={T.iadeAdet ? "bad" : ""} gecikme={120} />
            <Kpi etiket="Kargo gideri" deger={P(T.kargo)} alt={`ciro'nun %${T.ciro ? ((T.kargo / T.ciro) * 100).toFixed(1) : 0}'i`} gecikme={180} />
          </div>
          <Panel baslik="Sevkiyat takibi" pad={false} gecikme={120}>
            <div className="tbl-sar"><table className="tbl">
              <thead><tr><th>No</th><th>Tarih</th><th>Platform</th><th>Ürün</th><th>Ülke</th><th>Kargo firması</th><th>Takip no</th><th className="r">Kargo gideri</th><th>Durum</th></tr></thead>
              <tbody>{siparisler.filter((o) => o.durum !== "İade" && o.durum !== "İptal").map((o, i) => (
                <tr key={o.id} className="bel-satir" style={{ animationDelay: Math.min(i * 18, 400) + "ms" }} onClick={() => setDuzenle({ tip: "siparisler", kayit: o })}>
                  <td className="kod dim">{o.no}</td><td className="kod dim">{o.tarih.slice(5)}</td><td>{o.platform}</td>
                  <td className="kalin">{o.urun}</td><td className="kod">{o.ulke}</td><td>{o.kargoFirma || "—"}</td>
                  <td className="kod dim">{o.takipNo || "—"}</td><td className="r n">{P(cev(o.kargoGider, o.cur))}</td><td><Pill v={o.durum} /></td></tr>))}
              </tbody></table></div>
          </Panel>
          <Panel baslik="İadeler ve iptaller" pad={false} gecikme={180}>
            <div className="tbl-sar"><table className="tbl">
              <thead><tr><th>No</th><th>Tarih</th><th>Platform</th><th>Ürün</th><th>Sebep</th><th className="r">İade tutarı</th><th className="r">Net etki</th><th>Durum</th></tr></thead>
              <tbody>{siparisler.filter((o) => o.durum === "İade" || o.durum === "İptal").map((o, i) => { const h = hesap(o); return (
                <tr key={o.id} className="bel-satir" style={{ animationDelay: Math.min(i * 18, 400) + "ms" }} onClick={() => setDuzenle({ tip: "siparisler", kayit: o })}>
                  <td className="kod dim">{o.no}</td><td className="kod dim">{o.tarih.slice(5)}</td><td>{o.platform}</td>
                  <td className="kalin">{o.urun}</td><td className="dim">{o.iadeSebep || "—"}</td>
                  <td className="r n">{P(cev(o.iadeTutar, o.cur))}</td>
                  <td className={"r n " + (h.kar >= 0 ? "ok" : "bad")}>{P(h.bazKar)}</td><td><Pill v={o.durum} /></td></tr>); })}
                {!siparisler.filter((o) => o.durum === "İade" || o.durum === "İptal").length && <tr><td colSpan="8" className="bos">Bu dönemde iade yok — iyi haber.</td></tr>}
              </tbody></table></div>
          </Panel>
        </>)}

        {gorunum === "tahsilat" && (<>
          <div className="kpi-grid k4">
            <Kpi etiket="Bekleyen hakediş" deger={P(db.tahsilatlar.filter((t) => t.durum === "Bekliyor").reduce((s, t) => s + cev(t.tutar, t.cur), 0))} alt={`${db.tahsilatlar.filter((t) => t.durum === "Bekliyor").length} kayıt`} ton="warn" gecikme={0} />
            <Kpi etiket="Tahsil edilen" deger={P(db.tahsilatlar.filter((t) => t.durum === "Tahsil edildi").reduce((s, t) => s + cev(t.tutar, t.cur), 0))} alt="tüm dönemler" ton="ok" gecikme={60} />
            <Kpi etiket="Ödemesi bekleyen sipariş" deger={siparisler.filter((o) => o.odemeDurum === "Bekliyor" && o.durum !== "İptal").length} alt="platform ödemesi gelmedi" gecikme={120} />
            <Kpi etiket="Sipariş bazlı alacak" deger={P(siparisler.filter((o) => o.odemeDurum === "Bekliyor" && o.durum !== "İptal").reduce((s, o) => { const h = hesap(o); return s + h.bazNet - h.bazKom; }, 0))} alt="komisyon düşülmüş" gecikme={180} />
          </div>
          <Panel baslik="Platform hakedişleri" gecikme={120}
            sag={<button className="btn" onClick={() => setDuzenle({ tip: "tahsilatlar", kayit: { id: "", tarih: bugun(), platform: db.platformlar[0].ad, donem: "", tutar: 0, cur: "USD", durum: "Bekliyor", sirket: SIRKETLER[0], kaynakTur: "manuel" } })}>Hakediş ekle</button>} pad={false}>
            <div className="tbl-sar"><table className="tbl">
              <thead><tr><th></th><th>Tarih</th><th>Platform</th><th>Dönem</th><th>Şirket</th><th className="r">Tutar</th><th className="r">{baz}</th><th>Durum</th><th>Mutabakat</th><th></th></tr></thead>
              <tbody>{[...db.tahsilatlar].sort((a, b) => (a.tarih < b.tarih ? 1 : -1)).map((t, i) => (
                <tr key={t.id} className="bel-satir" style={{ animationDelay: Math.min(i * 22, 400) + "ms" }}>
                  <td><Kaynak t={t.kaynakTur || "manuel"} /></td>
                  <td className="kod dim" onClick={() => setDuzenle({ tip: "tahsilatlar", kayit: t })}>{t.tarih}</td>
                  <td className="kalin" onClick={() => setDuzenle({ tip: "tahsilatlar", kayit: t })}>{t.platform}</td>
                  <td className="dim">{t.donem}</td><td className="dim">{t.sirket}</td>
                  <td className="r n">{new Intl.NumberFormat("tr-TR").format(t.tutar)} {t.cur}</td>
                  <td className="r n">{P(cev(t.tutar, t.cur))}</td><td><Pill v={t.durum} /></td>
                  <td><button className="x lnk" onClick={() => mutabakat(t)}>siparişleri işaretle</button>
                    <button className="x lnk" style={{ marginLeft: 10 }} onClick={() => setDuzenle({ tip: "hareketler", kayit: {
                      id: "", tarih: t.tarih, hesapId: (bankalar.find((b) => b.sirket === t.sirket && b.cur === t.cur) || bankalar[0])?.id || "",
                      yon: "giris", tutar: t.tutar, kategori: "Platform hakedişi", karsiTaraf: t.platform,
                      aciklama: t.donem, belge: "", eslesen: t.id, virmanId: "", kaynakTur: "manuel" } })}>bankaya işle</button></td>
                  <td className="r"><button className="x" onClick={() => sil("tahsilatlar", t.id)}>sil</button></td></tr>))}
              </tbody></table></div>
          </Panel>
          <p className="uyari">Mutabakat, o platformun hakediş tarihine kadarki bekleyen siparişlerini tahsil edildi yapar. Sunucu bağlandığında eşleştirme sipariş kırılımlı hakediş kalemleriyle otomatik olur ve tahmini komisyon gerçeğiyle değişir.</p>
        </>)}

        {gorunum === "banka" && (<>
          <div className="kpi-grid k4">
            <Kpi etiket="Toplam bakiye" deger={P(B.toplam)} alt={`${bankalar.filter((b) => sirketFilt === "hepsi" || b.sirket === sirketFilt).length} hesap · ${baz} karşılığı`} gecikme={0} />
            <Kpi etiket="Dönem girişi" deger={P(B.giris)} alt="bankaya yatan" ton="ok" gecikme={60} />
            <Kpi etiket="Dönem çıkışı" deger={P(B.cikis)} alt="bankadan çıkan" ton="bad" gecikme={120} />
            <Kpi etiket="Net akış" deger={P(B.net)} alt="giriş − çıkış" ton={B.net >= 0 ? "ok" : "bad"} gecikme={180} />
          </div>

          <Panel baslik="Hesaplar" sag={<span className="mini">bakiye = açılış + giriş − çıkış</span>} pad={false} gecikme={80}>
            <div className="hesaplar">
              {["Asar Global LLC", "Asar Danışmanlık"].filter((sr) => sirketFilt === "hepsi" || sr === sirketFilt).map((sr) => (
                <div key={sr} className="hs-grup">
                  <div className="hs-baslik">
                    <span className="eyebrow">{sr}</span>
                    <b className="n">{P(bankalar.filter((b) => b.sirket === sr).reduce((t, b) => t + cev(bakiye(b.id), b.cur), 0))}</b>
                  </div>
                  <div className="hs-izgara">
                    {bankalar.filter((b) => b.sirket === sr).map((b, i) => {
                      const bk = bakiye(b.id);
                      return (
                        <div key={b.id} className="hs bel" style={{ animationDelay: i * 40 + "ms" }}
                          onClick={() => setDuzenle({ tip: "hareketler", kayit: { id: "", tarih: bugun(), hesapId: b.id, yon: "giris", tutar: 0, kategori: BANKA_KAT[0], karsiTaraf: "", aciklama: "", belge: "", eslesen: "", virmanId: "", kaynakTur: "manuel" } })}>
                          <div className="hs-marka">
                            <BankaLogo banka={b.banka} />
                            <span className="kod">···{b.son4}</span>
                          </div>
                          <div className="hs-ust">
                            <span className="hs-ad">{b.etiket}</span>
                          </div>
                          <div className={"hs-bakiye n " + (bk < 0 ? "bad" : "")}>
                            {new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(bk)}
                            <em>{b.cur}</em>
                          </div>
                          <div className="hs-alt">
                            <span className="kod">{b.ulke}</span>
                            <span>{b.cur !== baz ? "≈ " + P(cev(bk, b.cur)) : ""}</span>
                          </div>
                        </div>);
                    })}
                  </div>
                </div>))}
            </div>
          </Panel>

          <Panel baslik={`Banka hareketleri — ${donemHareket.length} kayıt`} gecikme={140}
            sag={<><button className="btn ghost" onClick={() => setEkstre(true)}>Ekstre yükle</button>
              <button className="btn ghost" onClick={() => setVirman(true)}>Virman</button>
              <button className="btn" onClick={() => setDuzenle({ tip: "hareketler", kayit: { id: "", tarih: bugun(), hesapId: bankalar[0]?.id || "", yon: "giris", tutar: 0, kategori: BANKA_KAT[0], karsiTaraf: "", aciklama: "", belge: "", eslesen: "", virmanId: "", kaynakTur: "manuel" } })}>Hareket ekle</button></>} pad={false}>
            <div className="tbl-sar"><table className="tbl">
              <thead><tr><th>Tarih</th><th>Hesap</th><th>Kategori</th><th>Karşı taraf</th><th>Açıklama</th><th>Belge</th>
                <th className="r">Giriş</th><th className="r">Çıkış</th><th className="r">{baz}</th><th></th></tr></thead>
              <tbody>{donemHareket.map((x, i) => {
                const c = hesapCur(x.hesapId);
                const bicim = (v) => new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(v) + " " + c;
                return (
                  <tr key={x.id} className="bel-satir" style={{ animationDelay: Math.min(i * 18, 400) + "ms" }}
                    onClick={() => setDuzenle({ tip: "hareketler", kayit: x })}>
                    <td className="kod dim">{x.tarih}</td>
                    <td className="kalin">{hesapAdi(x.hesapId)}</td>
                    <td>{x.kategori}{x.virmanId && <i className="kilit" title="Virmanın karşı bacağı var">◆</i>}</td>
                    <td>{x.karsiTaraf}</td><td className="dim">{x.aciklama}</td>
                    <td className="kod dim">{x.belge || "—"}</td>
                    <td className="r n ok">{x.yon === "giris" ? bicim(x.tutar) : ""}</td>
                    <td className="r n bad">{x.yon === "cikis" ? bicim(x.tutar) : ""}</td>
                    <td className="r n">{P((x.yon === "giris" ? 1 : -1) * cev(x.tutar, c))}</td>
                    <td className="r"><button className="x" onClick={(e) => { e.stopPropagation(); sil("hareketler", x.id); }}>sil</button></td>
                  </tr>); })}
                {!donemHareket.length && <tr><td colSpan="10" className="bos">Bu dönemde banka hareketi yok.</td></tr>}
              </tbody></table></div>
          </Panel>

          <Panel baslik="Beyan özeti — hesap bazında" sag={<span className="mini">{ayFilt === "hepsi" ? "tüm dönemler" : ayTam(ayFilt)}</span>} pad={false} gecikme={200}>
            <div className="tbl-sar"><table className="tbl">
              <thead><tr><th>Hesap</th><th>Şirket</th><th>Ülke</th><th>PB</th><th className="r">Devir</th>
                <th className="r">Giriş</th><th className="r">Çıkış</th><th className="r">Kapanış</th><th className="r">Hareket</th></tr></thead>
              <tbody>{beyan.map((b, i) => (
                <tr key={b.id} className="bel-satir" style={{ animationDelay: Math.min(i * 22, 400) + "ms" }}>
                  <td className="kalin">{b.etiket}</td><td className="dim">{b.sirket}</td>
                  <td className="kod">{b.ulke}</td><td className="kod">{b.cur}</td>
                  <td className="r n dim">{new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(b.devir)}</td>
                  <td className="r n ok">{b.giris ? new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(b.giris) : "—"}</td>
                  <td className="r n bad">{b.cikis ? new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(b.cikis) : "—"}</td>
                  <td className="r n kalin">{new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(b.kapanis)}</td>
                  <td className="r n dim">{b.adet}</td></tr>))}
              </tbody></table></div>
          </Panel>
          <p className="uyari">Beyan özeti her hesabı kendi para biriminde gösterir — beyan bu şekilde verildiği için çeviri yapılmaz. Üst çubuktaki para birimi düğmesi yalnızca toplam bakiye ve karşılık sütununu etkiler. Şirketler arası virmanlar ayrı kategoride izlenir; Form 5472 açısından bu ayrım önemlidir.</p>
        </>)}

        {gorunum === "etsy" && (
        <div className="vitrin">
          <section className="v-hero">
            <div className="v-hero-sol">
              <span className="v-eyebrow">ETSY MAĞAZA YÖNETİMİ</span>
              <h2 className="v-baslik">{etsyMagaza}</h2>
              <div className="v-secim">
                <select value={etsyMagaza} onChange={(e) => { setEtsyMagaza(e.target.value); setListelemeler([]); setDegisiklik({}); }}>
                  {db.platformlar.filter((p) => p.saglayici === "etsy").map((p) => <option key={p.ad}>{p.ad}</option>)}
                </select>
                <select value={etsyDurumFiltre} onChange={(e) => setEtsyDurumFiltre(e.target.value)}>
                  <option value="active">Yayında</option><option value="draft">Taslak</option><option value="inactive">Gizli</option>
                </select>
                <button className="v-btn" onClick={listelemeleriYukle} disabled={etsyYukleniyor}>
                  {etsyYukleniyor ? "Çekiliyor…" : "Listelemeleri çek"}
                </button>
              </div>
            </div>
            {listelemeler.length > 0 && (
              <div className="v-hero-istatistik">
                <div><b>{listelemeler.length}</b><span>listeleme</span></div>
                <div><b className={Object.keys(degisiklik).length ? "v-canli" : ""}>{Object.keys(degisiklik).length}</b><span>değişiklik</span></div>
                <div><b>{Math.round(listelemeler.reduce((s, l) => s + (l.seo?.puan ?? 0), 0) / listelemeler.length)}</b><span>ort. SEO</span></div>
                <div><b>{listelemeler.reduce((s, l) => s + (l.goruntulenme || 0), 0).toLocaleString("tr-TR")}</b><span>görüntülenme</span></div>
              </div>)}
          </section>

          {!db.sunucu.url && <div className="v-uyari">Sunucu adresi tanımlı değil. Bağlantılar ekranından girin — bu ekran doğrudan Etsy'ye yazar, demo modu yok.</div>}
          {db.sunucu.url && !listelemeler.length && !etsyYukleniyor &&
            <div className="v-bos"><span>🏺</span>Mağazayı seçip listelemeleri çekin.<br/>Değişiklikler burada birikir, siz onaylamadan Etsy'ye gitmez.</div>}

          {listelemeler.length > 0 && (<>
            <div className="v-cubuk">
              <div className="v-sekme">
                {[["liste", "Vitrin"], ["seo", "SEO sağlığı"], ["perf", "Performans"]].map(([k, t]) => (
                  <button key={k} className={etsyAlt === k ? "on" : ""} onClick={() => setEtsyAlt(k)}>{t}</button>))}
              </div>
              <div className="v-toplu">
                <span>{secili.length} seçili</span>
                <button disabled={!secili.length} onClick={() => topluFiyat(-10)}>−%10</button>
                <button disabled={!secili.length} onClick={() => topluFiyat(10)}>+%10</button>
                <input placeholder="etiket, etiket" value={etiketMetin} onChange={(e) => setEtiketMetin(e.target.value)} />
                <button disabled={!secili.length || !etiketMetin} onClick={() => topluEtiket(false)}>etiket ekle</button>
                <button disabled={!secili.length || etsyYukleniyor} onClick={() => topluDurum("active")}>yayınla</button>
                <button disabled={!secili.length || etsyYukleniyor} onClick={() => topluDurum("inactive")}>gizle</button>
              </div>
            </div>

            {etsyAlt === "liste" && (
              <div className="v-galeri">
                {listelemeler.map((l, i) => {
                  const d = degisiklik[l.listelemeId] || {};
                  const dgs = Object.keys(d).length > 0;
                  const puan = l.seo?.puan ?? 0;
                  return (
                    <div key={l.listelemeId} className={"v-kart bel" + (dgs ? " v-degisti" : "")}
                      style={{ animationDelay: Math.min(i * 30, 500) + "ms" }}
                      onClick={() => setAcikSatir(l.listelemeId)}>
                      <div className="v-foto-sar">
                        {l.gorsel ? <img src={l.gorsel} alt="" className="v-foto" /> : <div className="v-foto v-foto-bos">🏺</div>}
                        <div className="v-foto-ust">
                          <input type="checkbox" checked={secili.includes(l.listelemeId)}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => setSecili(e.target.checked ? [...secili, l.listelemeId] : secili.filter((x) => x !== l.listelemeId))} />
                          <span className={"v-seo-halka " + (puan >= 80 ? "iyi" : puan >= 55 ? "orta" : "kotu")}>{puan}</span>
                        </div>
                        <div className="v-foto-alt">
                          <span className="v-fiyat">{d.fiyat !== undefined ? d.fiyat : (l.fiyat != null ? "$" + l.fiyat : "çoklu")}</span>
                          <span className={"v-stok " + ((d.stok ?? l.stok) === 0 ? "tukendi" : "")}>{d.stok ?? l.stok ?? "—"} adet</span>
                        </div>
                        {dgs && <span className="v-rozet">değişti</span>}
                      </div>
                      <div className="v-kart-alt">
                        <span className="v-kart-baslik">{d.baslik ?? l.baslik}</span>
                        <div className="v-kart-meta">
                          <span>👁 {l.goruntulenme ?? 0}</span><span>♡ {l.favori ?? 0}</span>
                          {l.cokVaryasyonlu && <span>{l.varyasyonlar.length} varyasyon</span>}
                        </div>
                      </div>
                    </div>);
                })}
              </div>)}

            {etsyAlt === "seo" && (
              <div className="v-tablo-sar"><table className="v-tablo">
                <thead><tr><th></th><th>Listeleme</th><th className="r">SEO</th><th>Sorunlar</th><th className="r">Etiket</th><th className="r">Foto</th></tr></thead>
                <tbody>{[...listelemeler].sort((a, b) => (a.seo?.puan ?? 100) - (b.seo?.puan ?? 100)).map((l) => (
                  <tr key={l.listelemeId} onClick={() => setAcikSatir(l.listelemeId)}>
                    <td>{l.gorsel ? <img src={l.gorsel} className="v-mini-foto" alt="" /> : <div className="v-mini-foto v-foto-bos" />}</td>
                    <td className="v-satir-baslik">{l.baslik}</td>
                    <td className="r"><span className={"v-seo-halka kucuk " + (l.seo.puan >= 80 ? "iyi" : l.seo.puan >= 55 ? "orta" : "kotu")}>{l.seo.puan}</span></td>
                    <td className="dim">{l.seo.sorunlar.join(" · ") || "temiz"}</td>
                    <td className={"r n " + (l.etiketler.length < 13 ? "warn" : "ok")}>{l.etiketler.length}/13</td>
                    <td className={"r n " + (l.fotoSayisi < 5 ? "warn" : "ok")}>{l.fotoSayisi}/10</td>
                  </tr>))}</tbody>
              </table></div>)}

            {etsyAlt === "perf" && (
              <div className="v-tablo-sar"><table className="v-tablo">
                <thead><tr><th></th><th>Listeleme</th><th className="r">Görüntülenme</th><th className="r">Günlük</th><th className="r">Favori</th><th className="r">Fav/1000</th><th className="r">Yaş</th></tr></thead>
                <tbody>{[...listelemeler].sort((a, b) => (b.goruntulenme || 0) - (a.goruntulenme || 0)).map((l) => (
                  <tr key={l.listelemeId} onClick={() => setAcikSatir(l.listelemeId)}>
                    <td>{l.gorsel ? <img src={l.gorsel} className="v-mini-foto" alt="" /> : <div className="v-mini-foto v-foto-bos" />}</td>
                    <td className="v-satir-baslik">{l.baslik}</td>
                    <td className="r n">{(l.goruntulenme ?? 0).toLocaleString("tr-TR")}</td>
                    <td className="r n dim">{l.gunlukGoruntulenme ?? "—"}</td>
                    <td className="r n">{l.favori ?? 0}</td>
                    <td className={"r n " + ((l.favoriOrani ?? 0) < 5 && (l.goruntulenme ?? 0) > 100 ? "bad" : "dim")}>{l.favoriOrani ?? "—"}</td>
                    <td className="r n dim">{l.yasGun ? l.yasGun + "g" : "—"}</td>
                  </tr>))}</tbody>
              </table></div>)}

            <div className="v-alt-cubuk">
              <span>{Object.keys(degisiklik).length} listelemede değişiklik bekliyor{denemeYapildi ? " · deneme temiz" : ""}</span>
              <div className="row">
                <button className="v-btn hayalet" disabled={!Object.keys(degisiklik).length} onClick={() => setDegisiklik({})}>sıfırla</button>
                <button className="v-btn hayalet" disabled={!Object.keys(degisiklik).length || etsyYukleniyor} onClick={() => etsyUygula(true)}>Deneme çalıştır</button>
                <button className="v-btn" disabled={!denemeYapildi || etsyYukleniyor} onClick={() => etsyUygula(false)}>Etsy'ye uygula</button>
              </div>
            </div>

            {!!l_uyari(degisiklik, listelemeler) && <div className="v-uyari">{l_uyari(degisiklik, listelemeler)}</div>}

            {etsySonuc.length > 0 && (
              <div className="v-tablo-sar"><table className="v-tablo">
                <thead><tr><th>Listeleme</th><th>Sonuç</th><th>Mesaj</th></tr></thead>
                <tbody>{etsySonuc.map((r, i) => (
                  <tr key={i}><td className="v-satir-baslik">{(r.baslik || r.listelemeId + "")}</td>
                    <td><span className={"v-durum-etiket " + (r.durum === "tamam" ? "iyi" : r.durum === "hata" ? "kotu" : "")}>{r.durum}</span></td>
                    <td className={r.durum === "hata" ? "bad" : "dim"}>{r.mesaj || "güncellendi"}</td></tr>))}</tbody>
              </table></div>)}
          </>)}

          {acikSatir != null && (() => {
            const l = lst(acikSatir); if (!l) return null;
            const d = degisiklik[l.listelemeId] || {};
            return (
              <div className="v-ovl" onClick={() => setAcikSatir(null)}>
                <div className="v-cekmece" onClick={(e) => e.stopPropagation()}>
                  <button className="v-kapat" onClick={() => setAcikSatir(null)}>×</button>
                  <div className="v-cekmece-galeri">
                    {(l.tumGorseller && l.tumGorseller.length ? l.tumGorseller : [l.gorsel]).filter(Boolean).map((g, gi) => (
                      <img key={gi} src={g} alt="" className={gi === 0 ? "v-buyuk-foto" : "v-kucuk-foto"} />))}
                    {!l.gorsel && <div className="v-buyuk-foto v-foto-bos">🏺</div>}
                  </div>
                  <div className="v-cekmece-govde">
                    <div className="v-cekmece-ust">
                      <span className={"v-seo-halka buyuk " + (l.seo.puan >= 80 ? "iyi" : l.seo.puan >= 55 ? "orta" : "kotu")}>{l.seo.puan}</span>
                      <div>
                        <span className="v-eyebrow">SEO PUANI</span>
                        <p className="dim" style={{ margin: "4px 0 0", fontSize: 12.5 }}>{l.seo.sorunlar.join(" · ") || "Sorun yok"}</p>
                      </div>
                      {l.url && <a href={l.url} target="_blank" rel="noreferrer" className="v-btn hayalet" style={{ marginLeft: "auto" }}>Etsy'de aç ↗</a>}
                    </div>

                    <label className="v-alan"><span>BAŞLIK ({(d.baslik ?? l.baslik).length}/140)</span>
                      <input value={d.baslik ?? l.baslik} onChange={(e) => degistir(l.listelemeId, "baslik", e.target.value)} /></label>

                    <div className="v-alan-cift">
                      <label className="v-alan"><span>FİYAT</span>
                        <input type="number" step="0.01" value={d.fiyat ?? (l.fiyat ?? "")} placeholder={l.cokVaryasyonlu ? "çoklu — aşağıda" : ""}
                          onChange={(e) => degistir(l.listelemeId, "fiyat", Number(e.target.value))} /></label>
                      <label className="v-alan"><span>STOK</span>
                        <input type="number" value={d.stok ?? (l.stok ?? "")}
                          onChange={(e) => degistir(l.listelemeId, "stok", Number(e.target.value))} /></label>
                    </div>

                    <div className="v-alan"><span>ETİKETLER — {etiketleri(l.listelemeId).length}/13</span>
                      <div className="v-etiket-bulut">
                        {etiketleri(l.listelemeId).map((e, j) => (
                          <span key={j} className="v-etiket">{e}
                            <button onClick={() => etiketDegistir(l.listelemeId, etiketleri(l.listelemeId).filter((_, k) => k !== j))}>×</button></span>))}
                        {etiketleri(l.listelemeId).length < 13 && (
                          <input className="v-etiket-giris" placeholder="+ ekle" maxLength={20}
                            onKeyDown={(e) => { if (e.key === "Enter" && e.target.value.trim()) {
                              etiketDegistir(l.listelemeId, [...etiketleri(l.listelemeId), e.target.value.trim().toLowerCase()]); e.target.value = ""; } }} />)}
                      </div>
                    </div>

                    {l.cokVaryasyonlu && (
                      <div className="v-alan"><span>VARYASYONLAR</span>
                        <table className="v-mini-tablo"><tbody>
                          {l.varyasyonlar.map((v) => {
                            const vd = d.varyasyonlar?.[v.urunId] || {};
                            return (<tr key={v.urunId}>
                              <td>{v.ozellikler || v.sku || v.urunId}</td>
                              <td><input type="number" step="0.01" value={vd.fiyat ?? (v.fiyat ?? "")}
                                onChange={(e) => varyasyonDegistir(l.listelemeId, v.urunId, "fiyat", e.target.value)} /></td>
                              <td><input type="number" style={{ width: 58 }} value={vd.stok ?? (v.stok ?? "")}
                                onChange={(e) => varyasyonDegistir(l.listelemeId, v.urunId, "stok", e.target.value)} /></td>
                            </tr>);
                          })}
                        </tbody></table>
                      </div>)}

                    <div className="v-cekmece-alt">
                      <button className="v-btn hayalet" disabled={etsyYukleniyor} onClick={() => kopyala(l.listelemeId)}>Kopyala (taslak)</button>
                      <span className="dim" style={{ fontSize: 11.5 }}>{l.goruntulenme ?? 0} görüntülenme · {l.favori ?? 0} favori · {l.yasGun ?? "?"} gün önce yayınlandı</span>
                    </div>
                  </div>
                </div>
              </div>);
          })()}
        </div>)}

        {gorunum === "gider" && (<>
          <div className="kpi-grid k4">
            <Kpi etiket="Toplam gider" deger={P(T.gider + T.tedarik)} alt="seçili dönem" gecikme={0} />
            <Kpi etiket="Tedarikçi ödemeleri" deger={P(T.tedarik)} alt="Asya Deri Halı + Seyran Halı" gecikme={60} />
            <Kpi etiket="Reklam" deger={P(giderler.filter((g) => g.kategori === "Reklam").reduce((s, g) => s + cev(g.tutar, g.cur), 0))} alt="Google + Meta" gecikme={120} />
            <Kpi etiket="Diğer işletme gideri" deger={P(T.gider - giderler.filter((g) => g.kategori === "Reklam").reduce((s, g) => s + cev(g.tutar, g.cur), 0))} gecikme={180} />
          </div>
          <Panel baslik="Gider kayıtları" gecikme={120}
            sag={<button className="btn" onClick={() => setDuzenle({ tip: "giderler", kayit: { id: "", tarih: bugun(), kategori: GIDER_KAT[0], aciklama: "", karsiTaraf: "", tutar: 0, cur: "TRY", sirket: SIRKETLER[1], faturaNo: "", kdv: 20 } })}>Gider ekle</button>} pad={false}>
            <div className="tbl-sar"><table className="tbl">
              <thead><tr><th>Tarih</th><th>Kategori</th><th>Açıklama</th><th>Karşı taraf</th><th>Şirket</th><th>Fatura</th><th className="r">Tutar</th><th className="r">KDV</th><th className="r">{baz}</th><th></th></tr></thead>
              <tbody>{giderler.map((g, i) => (
                <tr key={g.id} className="bel-satir" style={{ animationDelay: Math.min(i * 22, 400) + "ms" }} onClick={() => setDuzenle({ tip: "giderler", kayit: g })}>
                  <td className="kod dim">{g.tarih}</td><td className="kalin">{g.kategori}</td><td className="dim">{g.aciklama}</td>
                  <td>{g.karsiTaraf}</td><td className="dim">{g.sirket}</td><td className="kod dim">{g.faturaNo}</td>
                  <td className="r n">{new Intl.NumberFormat("tr-TR").format(g.tutar)} {g.cur}</td>
                  <td className="r n dim">%{g.kdv}</td><td className="r n">{P(cev(g.tutar, g.cur))}</td>
                  <td className="r"><button className="x lnk" onClick={(e) => { e.stopPropagation(); setDuzenle({ tip: "hareketler", kayit: {
                    id: "", tarih: g.tarih, hesapId: (bankalar.find((b) => b.sirket === g.sirket && b.cur === g.cur) || bankalar[0])?.id || "",
                    yon: "cikis", tutar: g.tutar, kategori: BANKA_KAT.includes(g.kategori) ? g.kategori : "Diğer",
                    karsiTaraf: g.karsiTaraf, aciklama: g.aciklama, belge: g.faturaNo, eslesen: g.id, virmanId: "", kaynakTur: "manuel" } }); }}>bankadan öde</button>
                    <button className="x" style={{ marginLeft: 10 }} onClick={(e) => { e.stopPropagation(); sil("giderler", g.id); }}>sil</button></td></tr>))}
                {!giderler.length && <tr><td colSpan="10" className="bos">Bu dönemde gider kaydı yok.</td></tr>}
              </tbody></table></div>
          </Panel>
        </>)}

        {gorunum === "muhasebe" && (<>
          <div className="grid2">
            {SIRKETLER.map((s, si) => {
              const sip = db.siparisler.filter((o) => o.sirket === s && (ayFilt === "hepsi" || ay(o.tarih) === ayFilt));
              const gid = db.giderler.filter((g) => g.sirket === s && (ayFilt === "hepsi" || ay(g.tarih) === ayFilt));
              const ciro = sip.reduce((a, o) => a + hesap(o).bazNet, 0);
              const bkar = sip.reduce((a, o) => a + hesap(o).bazKar, 0);
              const gtop = gid.reduce((a, g) => a + cev(g.tutar, g.cur), 0);
              const gTed = gid.filter((g) => g.kategori === "Tedarikçi ödemesi").reduce((a, g) => a + cev(g.tutar, g.cur), 0);
              const kdvInd = gid.reduce((a, g) => a + cev(g.tutar, g.cur) * (g.kdv / 100) / (1 + g.kdv / 100), 0);
              const fat = db.faturalar.filter((f) => f.sirket === s && (ayFilt === "hepsi" || ay(f.tarih) === ayFilt));
              const kdvHes = fat.reduce((a, f) => a + cev(f.tutar, f.cur) * (f.kdv / 100) / (1 + f.kdv / 100), 0);
              const oran = s === "Asar Danışmanlık" ? A.vergiTR : A.vergiUS;
              const matrah = bkar - (gtop - gTed);
              const sonuc = matrah - Math.max(0, matrah) * oran / 100 - Math.max(0, kdvHes - kdvInd);
              return (
                <Panel key={s} baslik={s} gecikme={si * 90} sag={<span className={"mini " + (sonuc >= 0 ? "ok" : "bad")}>{P(sonuc)}</span>}>
                  <table className="mini-tbl"><tbody>
                    <tr><td>Ciro (net satış)</td><td className="r n">{P(ciro)}</td></tr>
                    <tr><td>Brüt kâr</td><td className="r n">{P(bkar)}</td></tr>
                    <tr><td>Tedarikçi ödemeleri</td><td className="r n dim">{P(gTed)}</td></tr>
                    <tr><td>İşletme giderleri</td><td className="r n dim">{P(gtop - gTed)}</td></tr>
                    <tr className="ayrac"><td>Vergi öncesi sonuç</td><td className={"r n kalin " + (matrah >= 0 ? "ok" : "bad")}>{P(matrah)}</td></tr>
                    <tr><td>Hesaplanan KDV</td><td className="r n">{P(kdvHes)}</td></tr>
                    <tr><td>İndirilecek KDV</td><td className="r n">{P(kdvInd)}</td></tr>
                    <tr><td>Ödenecek KDV (tahmini)</td><td className="r n">{P(Math.max(0, kdvHes - kdvInd))}</td></tr>
                    <tr><td>Kurumlar vergisi %{oran} (tahmini)</td><td className="r n">{P(Math.max(0, matrah) * oran / 100)}</td></tr>
                    <tr className="ayrac"><td><b>Vergi sonrası tahmini</b></td><td className={"r n kalin " + (sonuc >= 0 ? "ok" : "bad")}><b>{P(sonuc)}</b></td></tr>
                  </tbody></table>
                </Panel>);
            })}
          </div>
          <Panel baslik="Kesilen faturalar" gecikme={180}
            sag={<button className="btn" onClick={() => setDuzenle({ tip: "faturalar", kayit: { id: "", tarih: bugun(), no: "", tip: "Satış", karsiTaraf: "", tutar: 0, cur: "USD", kdv: 0, sirket: SIRKETLER[0], durum: "Kesildi" } })}>Fatura ekle</button>} pad={false}>
            <div className="tbl-sar"><table className="tbl">
              <thead><tr><th>Tarih</th><th>Fatura no</th><th>Tip</th><th>Karşı taraf</th><th>Şirket</th><th className="r">Tutar</th><th className="r">KDV</th><th className="r">{baz}</th><th>Durum</th><th></th></tr></thead>
              <tbody>{[...db.faturalar].sort((a, b) => (a.tarih < b.tarih ? 1 : -1)).map((f, i) => (
                <tr key={f.id} className="bel-satir" style={{ animationDelay: Math.min(i * 22, 400) + "ms" }} onClick={() => setDuzenle({ tip: "faturalar", kayit: f })}>
                  <td className="kod dim">{f.tarih}</td><td className="kod kalin">{f.no}</td><td>{f.tip}</td>
                  <td>{f.karsiTaraf}</td><td className="dim">{f.sirket}</td>
                  <td className="r n">{new Intl.NumberFormat("tr-TR").format(f.tutar)} {f.cur}</td>
                  <td className="r n dim">%{f.kdv}</td><td className="r n">{P(cev(f.tutar, f.cur))}</td>
                  <td><Pill v={f.durum} /></td>
                  <td className="r"><button className="x" onClick={(e) => { e.stopPropagation(); sil("faturalar", f.id); }}>sil</button></td></tr>))}
              </tbody></table></div>
          </Panel>
          <p className="uyari">Ön muhasebe amaçlıdır, resmi beyan yerine geçmez. Vergi ve KDV satırları girdiğiniz oranlarla yapılan tahminlerdir.</p>
        </>)}

        {gorunum === "baglanti" && (<>
          <Panel baslik="Senkron sunucusu" gecikme={0}>
            <div className="form g3">
              <F label="Sunucu adresi" w={2}><input placeholder="https://senkron.kareliasandsons.com" value={db.sunucu.url}
                onChange={(e) => setDb((d) => ({ ...d, sunucu: { ...d.sunucu, url: e.target.value } }))} /></F>
              <F label="Erişim anahtarı"><input type="password" placeholder="PANEL_TOKEN" value={db.sunucu.anahtar}
                onChange={(e) => setDb((d) => ({ ...d, sunucu: { ...d.sunucu, anahtar: e.target.value } }))} /></F>
            </div>
            <p className="ipucu">{db.sunucu.url
              ? "Sunucu tanımlı. Senkron butonları /api/siparisler ucundan veri çeker."
              : "Sunucu adresi boşken senkron demo modunda çalışır — akışı ve tekilleştirmeyi görürsünüz, gerçek veri gelmez. İki kez senkronize edin: ikincisinde mükerrer kayıt oluşmadığını göreceksiniz."}</p>
          </Panel>

          <div className="bag-izgara">
            {db.baglantilar.map((b, i) => {
              const sayi = db.siparisler.filter((o) => o.platform === b.platform).length;
              const yukl = calisiyor === b.platform;
              return (
                <div key={b.platform} className={"bag bel" + (yukl ? " tarama" : "")} style={{ animationDelay: i * 40 + "ms" }}>
                  <div className="bag-ust">
                    <span className="bag-ad">{b.platform}</span>
                    <span className={"kay k-" + (b.yontem === "csv" ? "csv" : b.yontem === "webhook" ? "webhook" : "api")}>
                      {b.yontem === "csv" ? "CSV" : b.yontem === "webhook" ? "WBHK" : "API"}</span>
                  </div>
                  <div className="bag-orta">
                    <b className="n">{sayi}</b><span>kayıt</span>
                    <Pill v={b.sonDurum} />
                  </div>
                  <div className="bag-alt">
                    <span className="kod">{b.sonSenkron ? new Date(b.sonSenkron).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "hiç çalışmadı"}</span>
                    {b.yontem === "csv"
                      ? <button className="btn ghost" onClick={() => setIce(true)}>Dosya yükle</button>
                      : <button className="btn ghost" onClick={() => senkronEt(b.platform)} disabled={!!calisiyor}>{yukl ? "çekiliyor…" : "senkronize et"}</button>}
                  </div>
                </div>);
            })}
          </div>

          <Panel baslik="Senkron günlüğü" sag={<span className="mini">son 60 kayıt</span>} pad={false} gecikme={200}>
            <div className="tbl-sar"><table className="tbl">
              <thead><tr><th>Zaman</th><th>Platform</th><th>Tür</th><th className="r">Yeni</th><th className="r">Güncellenen</th><th>Sonuç</th></tr></thead>
              <tbody>{db.senkronLog.map((l, i) => (
                <tr key={l.id} className="bel-satir" style={{ animationDelay: Math.min(i * 18, 300) + "ms" }}>
                  <td className="kod dim">{new Date(l.zaman).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" })}</td>
                  <td className="kalin">{l.platform}</td><td className="kod dim">{l.tur}</td>
                  <td className="r n ok">{l.yeni || 0}</td><td className="r n dim">{l.guncel || 0}</td>
                  <td className={l.durum === "hata" ? "bad" : "dim"}>{l.mesaj}</td></tr>))}
                {!db.senkronLog.length && <tr><td colSpan="6" className="bos">Henüz senkron çalışmadı. Yukarıdan bir platformu senkronize edin.</td></tr>}
              </tbody></table></div>
          </Panel>
        </>)}

        {gorunum === "ayar" && (<>
          <Panel baslik="Görünüm" gecikme={0}>
            <div className="gorunum">
              <div className="gr-blok">
                <span className="eyebrow">Tema</span>
                <div className="seg">
                  {[["acik", "Açık"], ["koyu", "Koyu"]].map(([id, ad]) => (
                    <button key={id} className={(A.tema || "acik") === id ? "on" : ""}
                      onClick={() => setDb((d) => ({ ...d, ayarlar: { ...d.ayarlar, tema: id } }))}>{ad}</button>))}
                </div>
              </div>
              <div className="gr-blok">
                <span className="eyebrow">Vurgu rengi</span>
                <div className="renkler">
                  {VURGULAR.map((r) => (
                    <button key={r.id} className={"renk" + (V.id === r.id ? " on" : "")}
                      onClick={() => setDb((d) => ({ ...d, ayarlar: { ...d.ayarlar, vurgu: r.id } }))}>
                      <i style={{ background: r.ornek }} /><span>{r.ad}</span>
                    </button>))}
                </div>
              </div>
            </div>
          </Panel>
          <div className="grid2">
            <Panel baslik="Kur ve vergi" gecikme={0}>
              <div className="form g2">
                {CURRENCIES.map((c) => (<F key={c} label={`1 ${c} = ? USD`}>
                  <input type="number" step="0.0001" value={A.kur[c]}
                    onChange={(e) => setDb((d) => ({ ...d, ayarlar: { ...d.ayarlar, kur: { ...d.ayarlar.kur, [c]: Number(e.target.value) } } }))} /></F>))}
                <F label="Kurumlar vergisi TR %"><input type="number" value={A.vergiTR} onChange={(e) => setDb((d) => ({ ...d, ayarlar: { ...d.ayarlar, vergiTR: Number(e.target.value) } }))} /></F>
                <F label="Kurumlar vergisi US %"><input type="number" value={A.vergiUS} onChange={(e) => setDb((d) => ({ ...d, ayarlar: { ...d.ayarlar, vergiUS: Number(e.target.value) } }))} /></F>
              </div>
            </Panel>
            <Panel baslik="Veri" gecikme={80}>
              <div className="veri">
                <p>Kayıtlar tarayıcıda saklanır. Sunucu bağlandığında kaynak veritabanı sunucu olur, panel onu okur.</p>
                <div className="row">
                  <button className="btn" onClick={() => indir(JSON.stringify(db, null, 2), `karelias-yedek-${bugun()}.json`, "application/json")}>JSON yedek indir</button>
                  <button className="btn ghost" onClick={csvAktar}>Siparişleri CSV indir</button>
                  <button className="btn ghost" onClick={() => setIce(true)}>Dosya yükle</button>
                </div>
                <div className="row">
                  <Onayli etiket="Tüm verileri temizle" onay="Sipariş, gider, hakediş ve banka hareketleri silinsin mi?" onTamam={() => { setDb((d) => ({ ...d, siparisler: [], giderler: [], tahsilatlar: [], faturalar: [], senkronLog: [], hareketler: [], bankalar: (d.bankalar || []).map((b) => ({ ...b, acilis: 0 })) })); haber("Kayıtlar temizlendi", "bad"); }} />
                  <Onayli etiket="Fabrika ayarlarına dön" onay="Her şey sıfırlansın mı?" onTamam={() => { setDb(BASLANGIC); haber("Sıfırlandı"); }} />
                </div>
              </div>
            </Panel>
          </div>
          <div className="grid2">
            <Panel baslik="Platformlar ve komisyon" pad={false} gecikme={140}>
              <div className="tbl-sar"><table className="tbl">
                <thead><tr><th>Platform</th><th className="r">Komisyon %</th><th className="r">Ödeme günü</th><th>Yöntem</th><th>PB</th></tr></thead>
                <tbody>{db.platformlar.map((p, i) => (
                  <tr key={p.ad}><td className="kalin">{p.ad}</td>
                    <td className="r"><input className="ic" type="number" step="0.1" value={p.komisyon}
                      onChange={(e) => setDb((d) => { const l = [...d.platformlar]; l[i] = { ...l[i], komisyon: Number(e.target.value) }; return { ...d, platformlar: l }; })} /></td>
                    <td className="r"><input className="ic" type="number" value={p.odemeGun}
                      onChange={(e) => setDb((d) => { const l = [...d.platformlar]; l[i] = { ...l[i], odemeGun: Number(e.target.value) }; return { ...d, platformlar: l }; })} /></td>
                    <td><select className="ic w" value={p.yontem} onChange={(e) => setDb((d) => {
                      const l = [...d.platformlar]; l[i] = { ...l[i], yontem: e.target.value };
                      return { ...d, platformlar: l, baglantilar: d.baglantilar.map((x) => x.platform === p.ad ? { ...x, yontem: e.target.value } : x) }; })}>
                      <option value="api">API</option><option value="webhook">Webhook</option><option value="csv">CSV</option></select></td>
                    <td className="kod dim">{p.cur}</td></tr>))}
                </tbody></table></div>
            </Panel>
            <Panel baslik="Banka hesapları" sag={<button className="btn" onClick={() => setDb((d) => ({ ...d,
              bankalar: [...(d.bankalar || []), { id: uid(), banka: "Yeni banka", etiket: "Yeni hesap", ulke: "TR", cur: "TRY", sirket: SIRKETLER[1], son4: "", acilis: 0 }] }))}>Hesap ekle</button>} pad={false} gecikme={170}>
              <div className="tbl-sar"><table className="tbl">
                <thead><tr><th>Hesap adı</th><th>Ülke</th><th>PB</th><th>Şirket</th><th>Son 4</th><th className="r">Açılış bakiyesi</th><th></th></tr></thead>
                <tbody>{(db.bankalar || []).map((b, i) => {
                  const guncelle = (alan) => (e) => setDb((d) => { const l = [...d.bankalar]; l[i] = { ...l[i], [alan]: alan === "acilis" ? Number(e.target.value) : e.target.value }; return { ...d, bankalar: l }; });
                  return (
                    <tr key={b.id}>
                      <td><input className="ic w2" value={b.etiket} onChange={guncelle("etiket")} /></td>
                      <td><select className="ic" value={b.ulke} onChange={guncelle("ulke")}><option>TR</option><option>USA</option><option>NL</option></select></td>
                      <td><select className="ic" value={b.cur} onChange={guncelle("cur")}>{CURRENCIES.map((c) => <option key={c}>{c}</option>)}</select></td>
                      <td><select className="ic w" value={b.sirket} onChange={guncelle("sirket")}>{SIRKETLER.map((x) => <option key={x}>{x}</option>)}</select></td>
                      <td><input className="ic" style={{ width: 62 }} value={b.son4} onChange={guncelle("son4")} /></td>
                      <td className="r"><input className="ic" type="number" value={b.acilis} onChange={guncelle("acilis")} /></td>
                      <td className="r"><button className="x" onClick={() => setDb((d) => ({ ...d, bankalar: d.bankalar.filter((x) => x.id !== b.id) }))}>sil</button></td>
                    </tr>); })}
                </tbody></table></div>
            </Panel>
            <Panel baslik="Ürün grupları ve eşleme" sag={<span className="mini">platform başlığında aranacak kelimeler</span>} pad={false} gecikme={200}>
              <div className="tbl-sar"><table className="tbl">
                <thead><tr><th>Ürün grubu</th><th className="r">Maliyet</th><th>Tedarikçi</th><th>Eşleme</th></tr></thead>
                <tbody>{db.urunler.map((u, i) => (
                  <tr key={u.ad}><td className="kalin">{u.ad}</td>
                    <td className="r"><input className="ic" type="number" value={u.maliyet}
                      onChange={(e) => setDb((d) => { const l = [...d.urunler]; l[i] = { ...l[i], maliyet: Number(e.target.value) }; return { ...d, urunler: l }; })} /></td>
                    <td><select className="ic w" value={u.tedarikci} onChange={(e) => setDb((d) => { const l = [...d.urunler]; l[i] = { ...l[i], tedarikci: e.target.value }; return { ...d, urunler: l }; })}>
                      {TEDARIKCILER.map((t) => <option key={t}>{t}</option>)}</select></td>
                    <td><input className="ic w2" value={u.anahtar || ""} placeholder="cowhide,dana"
                      onChange={(e) => setDb((d) => { const l = [...d.urunler]; l[i] = { ...l[i], anahtar: e.target.value }; return { ...d, urunler: l }; })} /></td></tr>))}
                </tbody></table></div>
            </Panel>
          </div>
        </>)}
        </div>
      </main>

      <div className="bildirimler">
        {bildirim.map((b) => <div key={b.id} className={"bildirim " + b.tur}>{b.m}</div>)}
      </div>

      {ekstre && <EkstreYukle db={db} onKapat={() => setEkstre(false)} onAktar={(gelenler, hesapId, profil) => {
        let o = null;
        setDb((d) => {
          const { liste, yeni, atlanan } = hareketBirlestir(d.hareketler || [], gelenler);
          o = { yeni, atlanan };
          /* Sütun düzeni hesaba yazılır — sonraki ekstre tek tıkla aktarılır */
          const profiller = profil ? { ...(d.ekstreProfil || {}), [hesapId]: profil } : (d.ekstreProfil || {});
          return { ...d, hareketler: liste, ekstreProfil: profiller };
        });
        setTimeout(() => haber(o.atlanan
          ? `${o.yeni} hareket eklendi · ${o.atlanan} kayıt zaten vardı, atlandı`
          : `${o.yeni} hareket eklendi`), 0);
      }} />}
      {virman && <Virman db={db} ayarlar={A} onKapat={() => setVirman(false)} onKaydet={virmanKaydet} />}
      {duzenle && <Formlar duzenle={duzenle} db={db} onKapat={() => setDuzenle(null)} onKaydet={kaydet} hesap={hesap} P={P} />}
      {ice && <IceAktar db={db} onKapat={() => setIce(false)} onAktar={(gelenler, platform) => {
        let o = null;
        setDb((d) => { const { liste, yeni, guncel, yeniIdler } = birlestir(d.siparisler, gelenler, d, "csv");
          o = { yeni, guncel, yeniIdler };
          return { ...d, siparisler: liste,
            baglantilar: d.baglantilar.map((b) => b.platform === platform ? { ...b, aktif: true, sonSenkron: simdi(), sonDurum: "Bağlı" } : b),
            senkronLog: [{ id: uid(), zaman: simdi(), platform, tur: "CSV", yeni, guncel, durum: "ok", mesaj: `${yeni} yeni, ${guncel} güncellendi` }, ...d.senkronLog].slice(0, 60) }; });
        setIce(false);
        setTimeout(() => { if (o?.yeniIdler?.length) { setParlayan(o.yeniIdler); setTimeout(() => setParlayan([]), 2600); }
          haber(o.guncel
            ? `${platform}: ${o.yeni} yeni kayıt · ${o.guncel} mevcut kayıt güncellendi`
            : `${platform}: ${o.yeni} yeni kayıt aktarıldı`); }, 0);
      }} />}
    </div>
  );
}


/* ═══════ EKSTRE YÜKLEME ═══════ */

/* Dosya adı ve başlık öncesi satırlardan hangi hesap olduğunu tahmin eder */
function hesapTahmin(tablo, bankalar) {
  const havuz = ((tablo.ad || "") + " " + (tablo.onbilgi || "") + " " + tablo.basliklar.join(" ")).toLowerCase();
  const son4 = bankalar.find((b) => b.son4 && havuz.includes(b.son4));
  if (son4) return son4.id;
  const isim = bankalar.find((b) => havuz.includes((b.banka || "").toLowerCase().split(" ")[0]));
  return isim ? isim.id : null;
}

function EkstreYukle({ db, onKapat, onAktar }) {
  const bankalar = db.bankalar || [];
  const profiller = db.ekstreProfil || {};
  const girisRef = useRef(null);
  const sonImza = useRef("");

  const [kuyruk, setKuyruk] = useState([]);
  const [sira, setSira] = useState(0);
  const [uzeri, setUzeri] = useState(false);
  const [okunuyor, setOkunuyor] = useState(false);
  const [hata, setHata] = useState("");
  const [yapistir, setYapistir] = useState(false);
  const [metin, setMetin] = useState("");
  const [profilVar, setProfilVar] = useState(false);
  const [profilKaydet, setProfilKaydet] = useState(true);

  const [hesapId, setHesapId] = useState(bankalar[0]?.id || "");
  const [kip, setKip] = useState("tek");
  const [tarihBicim, setTarihBicim] = useState("oto");
  const [esleme, setEsleme] = useState({});

  const tablo = kuyruk[sira] || null;
  const basliklar = tablo ? tablo.basliklar : [];
  const veriler = tablo ? tablo.veriler : [];
  const imza = basliklar.join("|").toLowerCase();

  /* Kayıtlı düzen varsa onu kullan, yoksa başlıklardan tahmin et */
  const eslemeKur = (t, hid) => {
    const p = profiller[hid];
    if (p && p.imza === t.basliklar.join("|").toLowerCase()) {
      setEsleme(p.esleme || {});
      setKip(p.kip || "tek");
      setTarihBicim(p.tarihBicim || "oto");
      return true;
    }
    const m = {};
    Object.entries(EKSTRE_IPUCU).forEach(([alan, ip]) => {
      const b = t.basliklar.find((x) => ip.some((i) => x.toLowerCase().includes(i)));
      if (b) m[alan] = b;
    });
    setEsleme(m);
    setKip(m.giris && m.cikis ? "iki" : "tek");
    setTarihBicim(m.tarih ? (tarihBicimSez(t.veriler.map((v) => v[m.tarih])) || "oto") : "oto");
    return false;
  };

  /* Yeni dosyaya geçilince hesabı tahmin et ve eşlemeyi kur */
  useEffect(() => {
    if (!tablo) return;
    const anahtar = sira + "|" + imza;
    if (sonImza.current === anahtar) return;
    sonImza.current = anahtar;
    const hid = hesapTahmin(tablo, bankalar) || hesapId;
    setHesapId(hid);
    setProfilVar(eslemeKur(tablo, hid));
  }, [tablo, imza, sira]);

  const hesapDegis = (hid) => {
    setHesapId(hid);
    if (tablo) setProfilVar(eslemeKur(tablo, hid));
  };

  const dosyalariAl = async (dosyalar) => {
    const gelen = Array.from(dosyalar || []);
    if (!gelen.length) return;
    setOkunuyor(true); setHata("");
    const okunan = [], sorunlu = [];
    for (const d of gelen) {
      try {
        const t = await dosyaOku(d);
        if (!t.veriler.length) sorunlu.push(d.name + ": okunabilir satır yok");
        else okunan.push(t);
      } catch (e) { sorunlu.push(d.name + ": " + e.message); }
    }
    setOkunuyor(false);
    if (sorunlu.length) setHata(sorunlu.join(" · "));
    if (!okunan.length) return;
    setYapistir(false);
    setKuyruk((k) => [...k, ...okunan]);
  };

  /* Yapıştırma yolu — dosya indiremediğin durumlar için duruyor */
  useEffect(() => {
    if (!yapistir) return;
    if (!metin.trim()) { setKuyruk([]); setSira(0); return; }
    setKuyruk([{ ...csvAyristir(metin), ad: "Yapıştırılan metin" }]);
    setSira(0);
  }, [metin, yapistir]);

  const hesap = bankalar.find((b) => b.id === hesapId);

  const sayfaSec = async (ad) => {
    setOkunuyor(true); setHata("");
    try {
      const t = await sayfaDegis(tablo, ad);
      setKuyruk((k) => k.map((x, i) => (i === sira ? t : x)));
      sonImza.current = "";
    } catch (e) { setHata("Sayfa okunamadı: " + e.message); }
    setOkunuyor(false);
  };

  const cozumle = () => veriler.map((v) => {
    const tarih = tarihCoz(v[esleme.tarih], tarihBicim);
    const aciklama = v[esleme.aciklama] || "";
    let yon, tutar;
    if (kip === "iki") {
      const g = Math.abs(sayiCoz(v[esleme.giris])), c = Math.abs(sayiCoz(v[esleme.cikis]));
      yon = g >= c ? "giris" : "cikis";
      tutar = g >= c ? g : c;
    } else {
      const t = sayiCoz(v[esleme.tutar]);
      yon = t >= 0 ? "giris" : "cikis";
      tutar = Math.abs(t);
    }
    const h = {
      tarih, hesapId, yon, tutar,
      kategori: kategoriTahmin(aciklama),
      karsiTaraf: v[esleme.karsiTaraf] || "",
      aciklama,
      belge: v[esleme.referans] || "",
      referans: v[esleme.referans] || "",
      eslesen: "", virmanId: "", kaynakTur: "csv",
    };
    return { ...h, anahtar: ekstreAnahtar(hesapId, h) };
  }).filter((h) => h.tarih && h.tutar > 0);

  const cozulen = useMemo(
    () => (veriler.length && (esleme.tarih || esleme.aciklama) ? cozumle() : []),
    [veriler, esleme, kip, tarihBicim, hesapId]);

  const gecersiz = veriler.length - cozulen.length;

  /* Aynı ekstreyi tekrar yüklemek güvenli — kayıtlı hareketler baştan elenir */
  const bilinen = useMemo(
    () => new Set((db.hareketler || []).map((h) => h.anahtar).filter(Boolean)), [db.hareketler]);
  const zatenVar = useMemo(() => cozulen.filter((h) => bilinen.has(h.anahtar)).length, [cozulen, bilinen]);
  const eklenecek = cozulen.length - zatenVar;

  const aktar = () => {
    const profil = tablo && profilKaydet && imza ? { imza, esleme, kip, tarihBicim } : null;
    onAktar(cozulen, hesapId, profil);
    if (sira + 1 < kuyruk.length) setSira(sira + 1);
    else onKapat();
  };

  /* Sezilemediyse söyle — yanlış seçim ayları sessizce kaydırır */
  const belirsizTarih = useMemo(() => {
    if (!tablo || !esleme.tarih || tarihBicim !== "oto") return false;
    const d = tablo.veriler.map((v) => v[esleme.tarih]);
    return d.some((x) => /^\d{1,2}[-.\/]\d{1,2}[-.\/]\d{4}/.test(String(x ?? "").trim())) && !tarihBicimSez(d);
  }, [tablo, esleme.tarih, tarihBicim]);

  const aralik = useMemo(() => {
    if (!cozulen.length) return "";
    const t = cozulen.map((h) => h.tarih).sort();
    return t[0] === t[t.length - 1] ? t[0] : t[0] + " → " + t[t.length - 1];
  }, [cozulen]);

  return (
    <Modal baslik="Banka ekstresi yükle" onClose={onKapat} genis>
      <div
        className={"birak" + (uzeri ? " uzeri" : "")}
        onDragOver={(e) => { e.preventDefault(); setUzeri(true); }}
        onDragLeave={() => setUzeri(false)}
        onDrop={(e) => { e.preventDefault(); setUzeri(false); dosyalariAl(e.dataTransfer.files); }}
      >
        <b>{okunuyor ? "Dosya okunuyor…" : "Ekstre dosyalarını buraya bırakın"}</b>
        <span className="mini">.csv · .xlsx — birden fazla dosya seçebilirsiniz</span>
        <div className="row" style={{ marginTop: 4, display: "flex", gap: 8 }}>
          <button className="btn ghost" onClick={() => girisRef.current?.click()}>Dosya seç</button>
          <button className="btn ghost" onClick={() => { setYapistir(!yapistir); setMetin(""); }}>
            {yapistir ? "Yapıştırmayı kapat" : "Yapıştırarak yükle"}
          </button>
        </div>
        <input ref={girisRef} type="file" accept=".csv,.txt,.xlsx,.xlsm" multiple
          style={{ display: "none" }}
          onChange={(e) => { dosyalariAl(e.target.files); e.target.value = ""; }} />
      </div>

      {kuyruk.length > 0 && (
        <div className="kuyruk">
          {kuyruk.map((k, i) => (
            <button key={i} className={"kuyruk-p" + (i === sira ? " etkin" : "")} onClick={() => setSira(i)}>
              <b>{k.ad}</b><span>{k.veriler.length} satır</span>
            </button>
          ))}
          <button className="kuyruk-p" onClick={() => { setKuyruk([]); setSira(0); sonImza.current = ""; }}>Listeyi temizle</button>
        </div>
      )}

      {hata && <div className="hata-kutu">{hata}</div>}

      {yapistir && (
        <label className="f" style={{ marginTop: 12 }}>
          <span>Ekstre içeriğini yapıştırın (başlık satırı dahil)</span>
          <textarea rows={6} value={metin} onChange={(e) => setMetin(e.target.value)}
            placeholder="Tarih;Açıklama;Tutar;Bakiye&#10;24.07.2026;ETSY PAYOUT;4.820,00;38.140,00" />
        </label>
      )}

      {tablo && (<>
        <div className={"form " + (tablo.sayfalar && tablo.sayfalar.length > 1 ? "g4" : "g3")} style={{ marginTop: 14 }}>
          {tablo.sayfalar && tablo.sayfalar.length > 1 && (
            <F label={"Excel sayfası (" + tablo.sayfalar.length + ")"}>
              <select value={tablo.sayfa} onChange={(e) => sayfaSec(e.target.value)}>
                {tablo.sayfalar.map((x) => <option key={x} value={x}>{x}</option>)}
              </select></F>)}
          <F label="Hangi hesap"><select value={hesapId} onChange={(e) => hesapDegis(e.target.value)}>
            {bankalar.map((b) => <option key={b.id} value={b.id}>{b.etiket} ({b.cur})</option>)}</select></F>
          <F label="Tutar sütunu"><select value={kip} onChange={(e) => setKip(e.target.value)}>
            <option value="tek">Tek sütun (eksi = çıkış)</option>
            <option value="iki">İki sütun (borç / alacak)</option></select></F>
          <F label="Tarih biçimi"><select value={tarihBicim} onChange={(e) => setTarihBicim(e.target.value)}>
            <option value="oto">Otomatik</option>
            <option value="gaa">Gün.Ay.Yıl — 24.07.2026</option>
            <option value="aag">Ay/Gün/Yıl — 07/24/2026</option></select></F>
        </div>

        {belirsizTarih && <div className="hata-kutu" style={{ borderColor: "var(--vurgu)", color: "var(--metin)" }}>
          Tarih biçimi bu dosyadan anlaşılamadı — hepsi 12'nin altında. Yukarıdan gün/ay sırasını seçin,
          yoksa önizlemedeki aylar kayabilir.
        </div>}

        {profilVar && <p className="ipucu" style={{ marginTop: 10 }}>
          Bu hesabın kayıtlı sütun düzeni kullanıldı — eşlemeyi tekrar kurmanıza gerek yok.
        </p>}

        <div className="form g4" style={{ marginTop: 14 }}>
          {["tarih", "aciklama", kip === "iki" ? "giris" : "tutar", kip === "iki" ? "cikis" : "karsiTaraf", "referans"]
            .filter(Boolean).map((alan) => (
            <F key={alan} label={{ tarih: "Tarih", aciklama: "Açıklama", tutar: "Tutar",
              giris: "Alacak / giriş", cikis: "Borç / çıkış", referans: "Referans", karsiTaraf: "Karşı taraf" }[alan]}>
              <select value={esleme[alan] || ""} onChange={(e) => setEsleme({ ...esleme, [alan]: e.target.value })}>
                <option value="">— yok —</option>
                {basliklar.map((b) => <option key={b} value={b}>{b}</option>)}
              </select>
            </F>))}
        </div>

        <div className="onizleme">
          <div className="onizleme-ust">
            <span className="eyebrow">Önizleme{aralik ? " · " + aralik : ""}</span>
            <span className="mini">
              {cozulen.length} okunabilir
              {zatenVar > 0 ? ` · ${zatenVar} kayıtlı, atlanacak` : ""}
              {gecersiz > 0 ? ` · ${gecersiz} satır atlanacak` : ""}
            </span>
          </div>
          <table className="mini-tbl"><tbody>
            {cozulen.slice(0, 5).map((h, i) => (
              <tr key={i}>
                <td className="kod dim">{h.tarih}</td>
                <td>{h.aciklama.slice(0, 46)}</td>
                <td className="dim">{h.kategori}</td>
                <td className={"r n " + (h.yon === "giris" ? "ok" : "bad")}>
                  {h.yon === "giris" ? "+" : "−"}{new Intl.NumberFormat("tr-TR").format(h.tutar)} {hesap?.cur}
                </td>
              </tr>))}
            {!cozulen.length && <tr><td className="dim">Sütun eşlemesini kontrol edin — tarih ve tutar zorunlu.</td></tr>}
          </tbody></table>
        </div>

        <p className="ipucu">
          Kategoriler açıklamadan tahmin edildi, tablodan tek tek düzeltebilirsiniz.
          Aynı ekstreyi tekrar yüklerseniz mükerrer kayıt oluşmaz.
        </p>
        <label className="f" style={{ flexDirection: "row", alignItems: "center", gap: 8, marginTop: 10 }}>
          <input type="checkbox" checked={profilKaydet} onChange={(e) => setProfilKaydet(e.target.checked)}
            style={{ width: "auto" }} />
          <span style={{ textTransform: "none", letterSpacing: 0, fontSize: 13, fontWeight: 400 }}>
            Bu düzeni hesaba kaydet — sonraki yüklemede eşleme kendiliğinden dolsun
          </span>
        </label>
      </>)}

      <div className="modal-f">
        <button className="btn ghost" onClick={onKapat}>Vazgeç</button>
        <button className="btn" disabled={!cozulen.length} onClick={aktar}>
          {eklenecek > 0 ? `${eklenecek} hareketi aktar` : `${cozulen.length} satırı aktar`}
          {sira + 1 < kuyruk.length ? " · sıradaki dosya" : ""}
        </button>
      </div>
    </Modal>);
}

/* ═══════ VİRMAN — hesaplar arası aktarım ═══════ */

function Virman({ db, ayarlar, onKapat, onKaydet }) {
  const b = db.bankalar || [];
  const [v, setV] = useState({ tarih: bugun(), kaynakId: b[0]?.id || "", hedefId: b[5]?.id || b[1]?.id || "", cikan: 0, giren: 0, aciklama: "" });
  const kaynak = b.find((x) => x.id === v.kaynakId);
  const hedef = b.find((x) => x.id === v.hedefId);
  const farkliSirket = kaynak && hedef && kaynak.sirket !== hedef.sirket;

  /* Para birimi farklıysa kur üzerinden öner, kullanıcı düzeltebilir */
  const onerGiren = (cikan) => {
    if (!kaynak || !hedef) return cikan;
    const usd = (Number(cikan) || 0) * (ayarlar.kur[kaynak.cur] || 1);
    return Math.round((usd / (ayarlar.kur[hedef.cur] || 1)) * 100) / 100;
  };

  return (
    <Modal baslik="Hesaplar arası virman" onClose={onKapat}>
      <div className="form g2">
        <F label="Tarih"><input type="date" value={v.tarih} onChange={(e) => setV({ ...v, tarih: e.target.value })} /></F>
        <F label="Açıklama"><input value={v.aciklama} onChange={(e) => setV({ ...v, aciklama: e.target.value })} placeholder="Sermaye aktarımı, döviz alımı…" /></F>
        <F label="Kaynak hesap"><select value={v.kaynakId} onChange={(e) => setV({ ...v, kaynakId: e.target.value })}>
          {b.map((x) => <option key={x.id} value={x.id}>{x.etiket} ({x.cur})</option>)}</select></F>
        <F label="Hedef hesap"><select value={v.hedefId} onChange={(e) => setV({ ...v, hedefId: e.target.value })}>
          {b.map((x) => <option key={x.id} value={x.id}>{x.etiket} ({x.cur})</option>)}</select></F>
        <F label={`Çıkan tutar (${kaynak?.cur || ""})`}>
          <input type="number" step="0.01" value={v.cikan}
            onChange={(e) => { const c = Number(e.target.value); setV({ ...v, cikan: c, giren: onerGiren(c) }); }} /></F>
        <F label={`Giren tutar (${hedef?.cur || ""})`}>
          <input type="number" step="0.01" value={v.giren} onChange={(e) => setV({ ...v, giren: Number(e.target.value) })} /></F>
      </div>
      {farkliSirket && (
        <p className="uyari" style={{ marginTop: 14 }}>
          Bu virman <b>{kaynak.sirket}</b> ile <b>{hedef.sirket}</b> arasında. Şirketler arası aktarım olarak
          kaydedilecek — yıl sonunda Form 5472 bildirimine girmesi gerekebilir, belgesini saklayın.
        </p>)}
      <div className="modal-f"><button className="btn ghost" onClick={onKapat}>Vazgeç</button>
        <button className="btn" disabled={!v.cikan || v.kaynakId === v.hedefId} onClick={() => onKaydet(v)}>Virmanı işle</button></div>
    </Modal>);
}

/* ═══════ CSV YÜKLEME ═══════ */

function IceAktar({ db, onKapat, onAktar }) {
  const girisRef = useRef(null);
  const [metin, setMetin] = useState("");
  const [tablo, setTablo] = useState(null);
  const [uzeri, setUzeri] = useState(false);
  const [okunuyor, setOkunuyor] = useState(false);
  const [hata, setHata] = useState("");
  const [yapistir, setYapistir] = useState(false);
  const [platform, setPlatform] = useState(db.platformlar[0].ad);
  const [tarihBicim, setTarihBicim] = useState("oto");
  const [paraBirimi, setParaBirimi] = useState("");
  const [paraSezildi, setParaSezildi] = useState(false);
  const [esleme, setEsleme] = useState({});

  const basliklar = tablo ? tablo.basliklar : [];
  const veriler = tablo ? tablo.veriler : [];
  const imza = basliklar.join("|").toLowerCase();

  const dosyaAl = async (dosyalar) => {
    const d = Array.from(dosyalar || [])[0];
    if (!d) return;
    setOkunuyor(true); setHata("");
    try {
      const t = await dosyaOku(d);
      if (!t.veriler.length) setHata(d.name + ": okunabilir satır yok");
      else { setTablo(t); setYapistir(false); }
    } catch (e) { setHata(d.name + ": " + e.message); }
    setOkunuyor(false);
  };

  useEffect(() => {
    if (!yapistir) return;
    setTablo(metin.trim() ? { ...csvAyristir(metin), ad: "Yapıştırılan metin" } : null);
  }, [metin, yapistir]);

  const sayfaSec = async (ad) => {
    setOkunuyor(true); setHata("");
    try { setTablo(await sayfaDegis(tablo, ad)); }
    catch (e) { setHata("Sayfa okunamadı: " + e.message); }
    setOkunuyor(false);
  };

  /* Yeni tablo gelince sütunları, platformu ve tarih biçimini tahmin et */
  useEffect(() => {
    if (!basliklar.length) return;
    const m = otoEsle(basliklar);
    if (platformOrani(basliklar, veriler, db.platformlar, m.platform) < 0.6) {
      const p = platformSutunuBul(basliklar, veriler, db.platformlar);
      if (p) m.platform = p; else delete m.platform;
    }
    setEsleme(m);
    setTarihBicim(m.tarih ? (tarihBicimSez(veriler.map((v) => v[m.tarih])) || "oto") : "oto");
    const pb = m.cur ? "" : paraSez(veriler, m, db.platformlar);
    setParaBirimi(pb);
    setParaSezildi(!!pb);
  }, [imza]);

  /* Platform sütunu varsa her satır kendi platformunu taşır — tek yüklemede hepsi girer */
  const satirPlatform = !!esleme.platform;

  const bul = (metin2, liste, yedek) => {
    const t = (metin2 || "").toLowerCase().trim();
    if (!t) return yedek;
    const tam = liste.find((x) => x.toLowerCase() === t);
    if (tam) return tam;
    const kismi = liste.find((x) => x.toLowerCase().includes(t) || t.includes(x.toLowerCase()));
    return kismi || yedek;
  };

  const cozumle = () => veriler.map((v, i) => {
    const pAd = satirPlatform ? bul(v[esleme.platform], db.platformlar.map((x) => x.ad), platform) : platform;
    const p = db.platformlar.find((x) => x.ad === pAd) || db.platformlar[0];
    const t = (v[esleme.tarih] || "").slice(0, 10);
    const say = (alan) => (esleme[alan] ? sayiCoz(v[esleme[alan]]) : 0);
    const yaz = (alan) => (esleme[alan] ? String(v[esleme[alan]]).trim() : "");

    const urunAdi = yaz("urunAdi") || yaz("urun");
    const eslesen = urunEsle(`${yaz("urun")} ${urunAdi} ${yaz("sku")}`, db.urunler);
    /* İade sütunu her zaman tutar taşımıyor; elle tutulan tablolarda çoğu zaman
       not oluyor ("iade", "değişim ürün hatalı"). Sayısal okunursa tutar, değilse
       iade işareti sayılır — yoksa iadeler "teslim edildi" görünür. */
    const iadeHam = yaz("iadeTutar");
    const iadeTutar = say("iadeTutar");
    const iadeVar = iadeTutar > 0 || (!!iadeHam && !/^[\d\s.,+-]+$/.test(iadeHam));
    const durum = yaz("durum")
      ? bul(yaz("durum"), SIPARIS_DURUM, "Teslim edildi")
      : (iadeVar ? "İade" : "Teslim edildi");
    const cur = yaz("cur") || paraBirimi || p.cur;

    /* Tarih sütunu eşlenmişse ve okunamıyorsa satır elenir — okunamayan tarihi
       bugüne çevirmek kaydı sessizce yanlış aya yazar. */
    const tarih = /^\d{4}-\d{2}-\d{2}$/.test(t)
      ? t : (tarihCoz(v[esleme.tarih], tarihBicim) || (esleme.tarih ? null : bugun()));
    const urunAd = eslesen ? eslesen.ad : (yaz("urun") || "Eşleşmedi");
    const fiyat = say("fiyat");
    const adet = say("adet") || 1;

    return {
      disId: yaz("disId")
        || "oto-" + parmakIzi(tarih, pAd, urunAd, yaz("sku"), fiyat, adet, yaz("musteri")),
      tarih,
      platform: pAd,
      urun: urunAd,
      urunAdi, sku: yaz("sku"),
      adet,
      fiyat,
      cur,
      en: say("en") || null, boy: say("boy") || null, m2: say("m2") || null,
      birimMaliyet: say("maliyet"),
      kargoGider: say("kargo"),
      komisyonOran: esleme.komisyonOran ? say("komisyonOran") : p.komisyon,
      komisyonGercek: esleme.komisyonGercek && say("komisyonGercek") ? say("komisyonGercek") : null,
      iadeTutar,
      iadeSebep: iadeVar && !iadeTutar ? iadeHam.slice(0, 120) : "",
      durum,
      odemeDurum: bul(yaz("odemeDurum"), ODEME_DURUM, "Bekliyor"),
      sirket: bul(yaz("sirket"), SIRKETLER, cur === "TRY" ? SIRKETLER[1] : SIRKETLER[0]),
      tedarikci: bul(yaz("tedarikci"), TEDARIKCILER, yaz("tedarikci") || null),
      ulke: yaz("ulke"), musteri: yaz("musteri"),
      takipNo: yaz("takipNo"), kargoFirma: yaz("kargoFirma"),
    };
  }).filter((o) => o.fiyat > 0 && o.tarih);

  const cozulen = useMemo(() => (veriler.length ? cozumle() : []), [veriler, esleme, platform, tarihBicim, paraBirimi]);
  const atlanan = veriler.length - cozulen.length;
  const tarihsiz = useMemo(() => {
    if (!esleme.tarih) return 0;
    return veriler.filter((v) => {
      const t = (v[esleme.tarih] || "").slice(0, 10);
      return !/^\d{4}-\d{2}-\d{2}$/.test(t) && !tarihCoz(v[esleme.tarih], tarihBicim);
    }).length;
  }, [veriler, esleme.tarih, tarihBicim]);
  /* Aynı (platform, sipariş no) çifti tek kayda düşer — kaç satırın birleşeceğini
     önden söylemezsek ciro sessizce eksik görünür. */
  const cakisan = useMemo(() => {
    const g = new Set();
    let n = 0;
    cozulen.forEach((o) => { const k = o.platform + ":" + o.disId; if (g.has(k)) n++; else g.add(k); });
    return n;
  }, [cozulen]);
  /* Eşleşmeyen satır maliyetsiz kalır — sessizce yanlış gruba yazmaktansa görünür olsun */
  const eslesmeyen = useMemo(() => cozulen.filter((o) => o.urun === "Eşleşmedi").length, [cozulen]);
  const platformlar = useMemo(() => {
    const m = {}; cozulen.forEach((o) => { m[o.platform] = (m[o.platform] || 0) + 1; }); return m;
  }, [cozulen]);

  const ALANLAR = [["disId","Sipariş no"],["tarih","Tarih"],["platform","Platform"],["urun","Ürün grubu"],
    ["urunAdi","Ürün adı"],["sku","SKU"],["adet","Adet"],["fiyat","Fiyat"],["cur","Para birimi"],
    ["maliyet","Maliyet"],["kargo","Kargo"],["komisyonOran","Komisyon %"],["komisyonGercek","Gerçek komisyon"],
    ["iadeTutar","İade tutarı"],["durum","Durum"],["odemeDurum","Ödeme"],["sirket","Şirket"],
    ["tedarikci","Tedarikçi"],["en","En"],["boy","Boy"],["m2","m²"],["ulke","Ülke"],["musteri","Müşteri"]];

  return (
    <Modal baslik="Sipariş dosyası yükle" onClose={onKapat} genis>
      <div
        className={"birak" + (uzeri ? " uzeri" : "")}
        onDragOver={(e) => { e.preventDefault(); setUzeri(true); }}
        onDragLeave={() => setUzeri(false)}
        onDrop={(e) => { e.preventDefault(); setUzeri(false); dosyaAl(e.dataTransfer.files); }}
      >
        <b>{okunuyor ? "Dosya okunuyor…" : (tablo ? tablo.ad : "Sipariş dosyasını buraya bırakın")}</b>
        <span className="mini">.csv · .xlsx — satış takip dosyanızı doğrudan yükleyebilirsiniz</span>
        <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
          <button className="btn ghost" onClick={() => girisRef.current?.click()}>Dosya seç</button>
          <button className="btn ghost" onClick={() => { setYapistir(!yapistir); setMetin(""); }}>
            {yapistir ? "Yapıştırmayı kapat" : "Yapıştırarak yükle"}
          </button>
        </div>
        <input ref={girisRef} type="file" accept=".csv,.txt,.xlsx,.xlsm" style={{ display: "none" }}
          onChange={(e) => { dosyaAl(e.target.files); e.target.value = ""; }} />
      </div>

      {hata && <div className="hata-kutu">{hata}</div>}

      <div className={"form " + (tablo && tablo.sayfalar && tablo.sayfalar.length > 1 ? "g4" : "g3")} style={{ marginTop: 12 }}>
        {tablo && tablo.sayfalar && tablo.sayfalar.length > 1 && (
          <F label={"Excel sayfası (" + tablo.sayfalar.length + ")"}>
            <select value={tablo.sayfa} onChange={(e) => sayfaSec(e.target.value)}>
              {tablo.sayfalar.map((x) => <option key={x} value={x}>{x}</option>)}
            </select></F>)}
        <F label={satirPlatform ? "Platform (sütundan okunuyor)" : "Hangi platform"}>
          <select value={platform} disabled={satirPlatform} onChange={(e) => setPlatform(e.target.value)}>
            {db.platformlar.map((x) => <option key={x.ad}>{x.ad}</option>)}</select></F>
        <F label="Tarih biçimi"><select value={tarihBicim} onChange={(e) => setTarihBicim(e.target.value)}>
          <option value="oto">Otomatik</option>
          <option value="gaa">Gün.Ay.Yıl — 24.07.2026</option>
          <option value="aag">Ay/Gün/Yıl — 07/24/2026</option></select></F>
        <F label="Tutarların para birimi">
          <select value={paraBirimi} disabled={!!esleme.cur}
            onChange={(e) => { setParaBirimi(e.target.value); setParaSezildi(false); }}>
            <option value="">Platforma göre</option>
            {CURRENCIES.map((c) => <option key={c} value={c}>Tümü {c}</option>)}
          </select></F>
        <F label="Bulunan"><input readOnly value={veriler.length ? `${veriler.length} satır · ${basliklar.length} sütun` : "—"} /></F>
      </div>

      {paraSezildi && <p className="uyari" style={{ marginTop: 12 }}>
        Dosyadaki tutarlar tek para biriminde tutulmuş görünüyor: TRY çalışan platformların
        satırları USD platformlarıyla aynı büyüklükte. Hepsi <b>{paraBirimi}</b> kabul edildi.
        Yanlışsa yukarıdan değiştirin — "Platforma göre" seçilirse Trendyol ve Shopify TR
        satırları TRY sayılır ve ciro kırkta bir görünür.
      </p>}

      {yapistir && <label className="f" style={{ marginTop: 12 }}><span>CSV içeriğini yapıştırın (başlık satırı dahil)</span>
        <textarea rows={5} value={metin} onChange={(e) => setMetin(e.target.value)}
          placeholder="No,Tarih,Platform,Ürün,Adet,Fiyat,PB,BirimMaliyet,Kargo,KomisyonOran,Durum" /></label>}

      {basliklar.length > 0 && (<>
        <div className="form g4" style={{ marginTop: 14 }}>
          {ALANLAR.map(([alan, etiket]) => (
            <F key={alan} label={etiket}>
              <select value={esleme[alan] || ""} onChange={(e) => setEsleme({ ...esleme, [alan]: e.target.value })}>
                <option value="">— yok —</option>
                {basliklar.map((b) => <option key={b} value={b}>{b}</option>)}</select>
            </F>))}
        </div>

        <div className="onizleme">
          <div className="onizleme-ust">
            <span className="eyebrow">Önizleme</span>
            <span className="mini">{cozulen.length} okunabilir{atlanan > 0 ? ` · ${atlanan} atlanacak` : ""}
              {tarihsiz > 0 ? ` · ${tarihsiz} tarihsiz` : ""}
              {cakisan > 0 ? ` · ${cakisan} satır aynı sipariş no ile birleşecek` : ""}
              {eslesmeyen > 0 ? ` · ${eslesmeyen} satırın ürün grubu eşleşmedi` : ""}</span>
          </div>
          {satirPlatform && (
            <p className="mini" style={{ marginTop: 0, marginBottom: 9 }}>
              {Object.entries(platformlar).map(([k, v]) => `${k}: ${v}`).join(" · ")}
            </p>)}
          <table className="mini-tbl"><tbody>
            {cozulen.slice(0, 5).map((o, i) => (
              <tr key={i}>
                <td className="kod dim">{o.tarih}</td>
                <td>{o.platform}</td>
                <td className="kalin">{o.urun}</td>
                <td className="r n">{o.adet}×{o.fiyat}</td>
                <td className="r n dim">−{o.birimMaliyet} −{o.kargoGider}</td>
                <td className="r n dim">%{o.komisyonOran}</td>
              </tr>))}
            {!cozulen.length && <tr><td className="dim">Sütun eşlemesini kontrol edin — tarih ve fiyat zorunlu.</td></tr>}
          </tbody></table>
          {eslesmeyen > 0 && <p className="uyari" style={{ marginTop: 11 }}>
            {eslesmeyen} satır hiçbir ürün grubuna oturmadı; "Eşleşmedi" olarak girer ve maliyetsiz görünür.
            Ayarlar → Ürünler'de o gruba anahtar kelime ekleyip dosyayı yeniden yükleyin.
          </p>}
        </div>
      </>)}

      <div className="modal-f"><button className="btn ghost" onClick={onKapat}>Vazgeç</button>
        <button className="btn" disabled={!cozulen.length} onClick={() => onAktar(cozulen, satirPlatform ? "CSV" : platform)}>
          {cozulen.length} siparişi aktar</button></div>
    </Modal>);
}

/* ═══════ FORMLAR ═══════ */

function Formlar({ duzenle, db, onKapat, onKaydet, hesap, P }) {
  const [k, setK] = useState(duzenle.kayit);
  const s = (a) => (e) => setK({ ...k, [a]: e.target.value });
  const sn = (a) => (e) => setK({ ...k, [a]: Number(e.target.value) });
  const tip = duzenle.tip;

  if (tip === "siparisler") {
    const h = hesap(k);
    return (
      <Modal baslik={k.disId ? `${k.platform} · ${k.disId}` : (k.id ? "Siparişi düzenle" : "Yeni sipariş")} onClose={onKapat} genis>
        {k.kaynakTur !== "manuel" && (
          <div className="senk-bilgi"><Kaynak t={k.kaynakTur} />
            <span>Bu kayıt {k.kaynakTur === "csv" ? "CSV ile" : "senkronla"} geldi. Değiştirdiğiniz alanlar kilitlenir, sonraki senkron bunları ezmez.</span>
            {(k.elle || []).length > 0 && <b>{k.elle.length} alan kilitli</b>}</div>)}
        <div className="form g4">
          <F label="Sipariş no"><input value={k.no} onChange={s("no")} /></F>
          <F label="Platform sipariş no"><input value={k.disId} onChange={s("disId")} /></F>
          <F label="Tarih"><input type="date" value={k.tarih} onChange={s("tarih")} /></F>
          <F label="Platform"><select value={k.platform} onChange={(e) => {
            const p = db.platformlar.find((x) => x.ad === e.target.value);
            setK({ ...k, platform: e.target.value, komisyonOran: p ? p.komisyon : k.komisyonOran, cur: p ? p.cur : k.cur,
              sirket: p && p.cur === "TRY" ? SIRKETLER[1] : SIRKETLER[0] }); }}>
            {db.platformlar.map((p) => <option key={p.ad}>{p.ad}</option>)}</select></F>

          <F label="Ürün grubu" w={2}><select value={k.urun} onChange={(e) => {
            const u = db.urunler.find((x) => x.ad === e.target.value);
            const c = k.cur === "TRY" ? Math.round(1 / (db.ayarlar.kur.TRY || 0.024)) : 1;
            setK({ ...k, urun: e.target.value, birimMaliyet: u ? Math.round(u.maliyet * c) : k.birimMaliyet, tedarikci: u ? u.tedarikci : k.tedarikci }); }}>
            {db.urunler.map((u) => <option key={u.ad}>{u.ad}</option>)}</select></F>
          <F label="Platformdaki ürün adı" w={2}><input value={k.urunAdi} onChange={s("urunAdi")} placeholder="Cowhide Rug Natural 200x150" /></F>

          <F label="SKU"><input value={k.sku} onChange={s("sku")} /></F>
          <F label="Tedarikçi"><select value={k.tedarikci} onChange={s("tedarikci")}>{TEDARIKCILER.map((x) => <option key={x}>{x}</option>)}</select></F>
          <F label="Şirket"><select value={k.sirket} onChange={s("sirket")}>{SIRKETLER.map((x) => <option key={x}>{x}</option>)}</select></F>
          <F label="Para birimi"><select value={k.cur} onChange={s("cur")}>{CURRENCIES.map((c) => <option key={c}>{c}</option>)}</select></F>

          <F label="Adet"><input type="number" value={k.adet} onChange={sn("adet")} /></F>
          <F label="Birim satış fiyatı"><input type="number" step="0.01" value={k.fiyat} onChange={sn("fiyat")} /></F>
          <F label="Birim ürün maliyeti"><input type="number" step="0.01" value={k.birimMaliyet} onChange={sn("birimMaliyet")} /></F>
          <F label="Komisyon %"><input type="number" step="0.1" value={k.komisyonOran} onChange={sn("komisyonOran")} /></F>

          <F label="Gerçek komisyon"><input type="number" step="0.01" value={k.komisyonGercek ?? ""} placeholder="boşsa oran kullanılır"
            onChange={(e) => setK({ ...k, komisyonGercek: e.target.value === "" ? null : Number(e.target.value) })} /></F>
          <F label="Kargo gideri"><input type="number" step="0.01" value={k.kargoGider} onChange={sn("kargoGider")} /></F>
          <F label="Diğer kesinti"><input type="number" step="0.01" value={k.digerKesinti} onChange={sn("digerKesinti")} /></F>
          <F label="İade tutarı"><input type="number" step="0.01" value={k.iadeTutar} onChange={sn("iadeTutar")} /></F>

          <F label="Sipariş durumu"><select value={k.durum} onChange={s("durum")}>{SIPARIS_DURUM.map((x) => <option key={x}>{x}</option>)}</select></F>
          <F label="Ödeme durumu"><select value={k.odemeDurum} onChange={s("odemeDurum")}>{ODEME_DURUM.map((x) => <option key={x}>{x}</option>)}</select></F>
          <F label="İade sebebi" w={2}><input value={k.iadeSebep} onChange={s("iadeSebep")} /></F>

          <F label="Ülke"><input value={k.ulke} onChange={s("ulke")} placeholder="USA, TR, DE…" /></F>
          <F label="Müşteri"><input value={k.musteri} onChange={s("musteri")} /></F>
          <F label="Kargo firması"><input value={k.kargoFirma} onChange={s("kargoFirma")} /></F>
          <F label="Takip no"><input value={k.takipNo} onChange={s("takipNo")} /></F>
          <F label="Not" w={4}><input value={k.not} onChange={s("not")} /></F>
        </div>
        <div className="ozet-kutu">
          <div><span className="eyebrow">Net satış</span><b className="n">{P(h.bazNet)}</b></div>
          <div><span className="eyebrow">Komisyon</span><b className="n dim">−{P(h.bazKom)}</b></div>
          <div><span className="eyebrow">Kargo</span><b className="n dim">−{P(h.bazKargo)}</b></div>
          <div><span className="eyebrow">Maliyet</span><b className="n dim">−{P(h.bazMal)}</b></div>
          <div><span className="eyebrow">Kâr</span><b className={"n " + (h.kar >= 0 ? "ok" : "bad")}>{P(h.bazKar)}</b></div>
          <div><span className="eyebrow">Marj</span><b className={"n " + (h.marj >= 0 ? "ok" : "bad")}>%{h.marj.toFixed(1)}</b></div>
        </div>
        <div className="modal-f"><button className="btn ghost" onClick={onKapat}>Vazgeç</button>
          <button className="btn" onClick={() => onKaydet("siparisler", k)}>Siparişi kaydet</button></div>
      </Modal>);
  }

  if (tip === "hareketler") {
    const hesap2 = (db.bankalar || []).find((b) => b.id === k.hesapId);
    return (
      <Modal baslik={k.id ? "Banka hareketini düzenle" : "Yeni banka hareketi"} onClose={onKapat}>
        <div className="form g2">
          <F label="Tarih"><input type="date" value={k.tarih} onChange={s("tarih")} /></F>
          <F label="Hesap"><select value={k.hesapId} onChange={s("hesapId")}>
            {(db.bankalar || []).map((b) => <option key={b.id} value={b.id}>{b.etiket}</option>)}</select></F>
          <F label="Yön"><select value={k.yon} onChange={s("yon")}>
            <option value="giris">Giriş — bankaya yatan</option>
            <option value="cikis">Çıkış — bankadan çıkan</option></select></F>
          <F label={`Tutar (${hesap2?.cur || ""})`}><input type="number" step="0.01" value={k.tutar} onChange={sn("tutar")} /></F>
          <F label="Kategori"><select value={k.kategori} onChange={s("kategori")}>
            {BANKA_KAT.map((x) => <option key={x}>{x}</option>)}</select></F>
          <F label="Karşı taraf"><input value={k.karsiTaraf} onChange={s("karsiTaraf")} placeholder="Etsy, Asya Deri Halı, GİB…" /></F>
          <F label="Açıklama" w={2}><input value={k.aciklama} onChange={s("aciklama")} /></F>
          <F label="Belge / dekont no"><input value={k.belge} onChange={s("belge")} /></F>
          <F label="Şirket"><input readOnly value={hesap2?.sirket || "—"} /></F>
        </div>
        <div className="modal-f"><button className="btn ghost" onClick={onKapat}>Vazgeç</button>
          <button className="btn" onClick={() => onKaydet("hareketler", k)}>Hareketi kaydet</button></div>
      </Modal>);
  }

  if (tip === "giderler") return (
    <Modal baslik={k.id ? "Gideri düzenle" : "Yeni gider"} onClose={onKapat}>
      <div className="form g2">
        <F label="Tarih"><input type="date" value={k.tarih} onChange={s("tarih")} /></F>
        <F label="Kategori"><select value={k.kategori} onChange={s("kategori")}>{GIDER_KAT.map((x) => <option key={x}>{x}</option>)}</select></F>
        <F label="Açıklama" w={2}><input value={k.aciklama} onChange={s("aciklama")} /></F>
        <F label="Karşı taraf"><input value={k.karsiTaraf} onChange={s("karsiTaraf")} list="ktl" />
          <datalist id="ktl">{TEDARIKCILER.map((t) => <option key={t} value={t} />)}<option value="Google" /><option value="Meta" /><option value="DHL" /></datalist></F>
        <F label="Şirket"><select value={k.sirket} onChange={s("sirket")}>{SIRKETLER.map((x) => <option key={x}>{x}</option>)}</select></F>
        <F label="Tutar"><input type="number" step="0.01" value={k.tutar} onChange={sn("tutar")} /></F>
        <F label="Para birimi"><select value={k.cur} onChange={s("cur")}>{CURRENCIES.map((c) => <option key={c}>{c}</option>)}</select></F>
        <F label="Fatura no"><input value={k.faturaNo} onChange={s("faturaNo")} /></F>
        <F label="KDV %"><input type="number" value={k.kdv} onChange={sn("kdv")} /></F>
      </div>
      <div className="modal-f"><button className="btn ghost" onClick={onKapat}>Vazgeç</button>
        <button className="btn" onClick={() => onKaydet("giderler", k)}>Gideri kaydet</button></div>
    </Modal>);

  if (tip === "tahsilatlar") return (
    <Modal baslik={k.id ? "Hakedişi düzenle" : "Yeni hakediş"} onClose={onKapat}>
      <div className="form g2">
        <F label="Tarih"><input type="date" value={k.tarih} onChange={s("tarih")} /></F>
        <F label="Platform"><select value={k.platform} onChange={s("platform")}>{db.platformlar.map((p) => <option key={p.ad}>{p.ad}</option>)}</select></F>
        <F label="Dönem" w={2}><input value={k.donem} onChange={s("donem")} placeholder="Temmuz 1. yarı" /></F>
        <F label="Tutar"><input type="number" step="0.01" value={k.tutar} onChange={sn("tutar")} /></F>
        <F label="Para birimi"><select value={k.cur} onChange={s("cur")}>{CURRENCIES.map((c) => <option key={c}>{c}</option>)}</select></F>
        <F label="Şirket"><select value={k.sirket} onChange={s("sirket")}>{SIRKETLER.map((x) => <option key={x}>{x}</option>)}</select></F>
        <F label="Durum"><select value={k.durum} onChange={s("durum")}>{ODEME_DURUM.map((x) => <option key={x}>{x}</option>)}</select></F>
      </div>
      <div className="modal-f"><button className="btn ghost" onClick={onKapat}>Vazgeç</button>
        <button className="btn" onClick={() => onKaydet("tahsilatlar", k)}>Hakedişi kaydet</button></div>
    </Modal>);

  return (
    <Modal baslik={k.id ? "Faturayı düzenle" : "Yeni fatura"} onClose={onKapat}>
      <div className="form g2">
        <F label="Tarih"><input type="date" value={k.tarih} onChange={s("tarih")} /></F>
        <F label="Fatura no"><input value={k.no} onChange={s("no")} /></F>
        <F label="Tip"><select value={k.tip} onChange={s("tip")}><option>Satış</option><option>Alış</option></select></F>
        <F label="Karşı taraf"><input value={k.karsiTaraf} onChange={s("karsiTaraf")} /></F>
        <F label="Tutar"><input type="number" step="0.01" value={k.tutar} onChange={sn("tutar")} /></F>
        <F label="Para birimi"><select value={k.cur} onChange={s("cur")}>{CURRENCIES.map((c) => <option key={c}>{c}</option>)}</select></F>
        <F label="KDV %"><input type="number" value={k.kdv} onChange={sn("kdv")} /></F>
        <F label="Şirket"><select value={k.sirket} onChange={s("sirket")}>{SIRKETLER.map((x) => <option key={x}>{x}</option>)}</select></F>
        <F label="Durum"><select value={k.durum} onChange={s("durum")}><option>Kesildi</option><option>Kesilecek</option></select></F>
      </div>
      <div className="modal-f"><button className="btn ghost" onClick={onKapat}>Vazgeç</button>
        <button className="btn" onClick={() => onKaydet("faturalar", k)}>Faturayı kaydet</button></div>
    </Modal>);
}

/* ═══════ STİL ═══════ */

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Inter:wght@400;450;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

.app{
--kok:#121316; --kat:#1A1C20; --kat2:#202329; --cizgi:#343841; --cizgi2:#282B32;
--metin:#EEF0F3; --soluk:#A9AFBA; --sonuk:#8B919D;
--yosun:#7FCB99; --kina:#E4735C; --cini:#84A6E8; --erguvan:#A87CC4;
display:flex;min-height:100vh;background:var(--kok);color:var(--metin);
font-family:'Inter',ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;
font-size:14px;line-height:1.55;-webkit-font-smoothing:antialiased;font-feature-settings:'cv05','ss03';
position:relative;overflow-x:hidden}
.app *{box-sizing:border-box}
.app::after{content:"";position:fixed;inset:0;pointer-events:none;z-index:1;opacity:.5;
background:radial-gradient(1000px 500px at 22% -8%, rgba(var(--vRGB),.07), transparent 62%)}

.n{font-variant-numeric:tabular-nums;font-feature-settings:'tnum';letter-spacing:-.005em;font-weight:500}
.kod{font-family:'JetBrains Mono',ui-monospace,Menlo,monospace;font-variant-numeric:tabular-nums;font-size:12px;letter-spacing:-.01em}
.eyebrow{font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--soluk)}
.dim{color:var(--soluk)}.ok{color:var(--yosun)}.bad{color:var(--kina)}.warn{color:var(--vurgu)}
.kalin{font-weight:600}.r{text-align:right}.mini{font-size:12px;color:var(--soluk)}

/* ── hareket ── */
@keyframes bel{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}
@keyframes belS{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:none}}
@keyframes ac{from{transform:scaleX(0)}to{transform:scaleX(1)}}
@keyframes parla{0%{background:rgba(var(--vRGB),.20)}100%{background:transparent}}
@keyframes don{to{transform:rotate(360deg)}}
@keyframes tara{0%{left:-40%}100%{left:110%}}
@keyframes gir{from{opacity:0;transform:translateY(10px) scale(.98)}to{opacity:1;transform:none}}
@keyframes bildir{0%{opacity:0;transform:translateX(24px)}12%{opacity:1;transform:none}88%{opacity:1;transform:none}100%{opacity:0;transform:translateX(24px)}}
.bel{animation:bel .55s cubic-bezier(.22,.9,.3,1) backwards}
.bel-satir{animation:belS .4s ease backwards}
.buyu{transform-origin:left;animation:ac .8s cubic-bezier(.22,.9,.3,1) backwards}
.parla{animation:parla 2.4s ease-out}
.sahne{display:flex;flex-direction:column;gap:14px;animation:gir .4s cubic-bezier(.22,.9,.3,1)}

/* ── sol ray ── */
.rail{width:214px;flex:0 0 214px;background:linear-gradient(180deg,#1A1D22,#141519);border-right:1px solid var(--cizgi);
display:flex;flex-direction:column;padding:20px 0;position:sticky;top:0;height:100vh;z-index:3}
.brand{display:flex;gap:11px;align-items:center;padding:0 18px 24px}
.brand-k{font-family:'Instrument Serif',Georgia,serif;font-size:19px;line-height:1;color:var(--dgmY);
background:linear-gradient(140deg,var(--dgmA),var(--dgmB));padding:8px 9px 9px;border-radius:5px;
box-shadow:0 3px 14px rgba(var(--vRGB),.22)}
.brand-k em{font-style:italic;opacity:.72}
.brand-t{font-size:13px;font-weight:600;letter-spacing:-.01em;display:flex;flex-direction:column}
.brand-t span{font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--soluk);margin-top:4px}
.rail nav{display:flex;flex-direction:column;gap:2px;padding:0 10px}
.nav{position:relative;display:flex;align-items:center;justify-content:space-between;gap:6px;text-align:left;
background:none;border:0;color:var(--soluk);font-size:14px;padding:9px 11px;border-radius:6px;cursor:pointer;font:inherit;
transition:background .18s,color .18s,transform .18s}
.nav:hover{color:var(--metin);background:rgba(var(--vRGB),.06);transform:translateX(2px)}
.nav.on{color:var(--metin);background:linear-gradient(90deg,rgba(var(--vRGB),.16),rgba(var(--vRGB),.03));font-weight:600}
.nav.on::before{content:"";position:absolute;left:0;top:7px;bottom:7px;width:2px;border-radius:2px;
background:linear-gradient(180deg,var(--vurgu2),var(--vurgu3));box-shadow:0 0 9px rgba(var(--vRGB),.55)}
.nav b{font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;color:var(--sonuk);background:rgba(255,255,255,.04);
padding:1px 5px;border-radius:3px}
.nav.on b{color:var(--vurgu);background:rgba(var(--vRGB),.1)}
.nokta{position:absolute;right:9px;top:11px;width:5px;height:5px;border-radius:50%;background:var(--vurgu);
box-shadow:0 0 0 0 rgba(var(--vRGB),.5);animation:nabiz 2.4s infinite}
@keyframes nabiz{0%{box-shadow:0 0 0 0 rgba(var(--vRGB),.45)}70%{box-shadow:0 0 0 7px rgba(var(--vRGB),0)}100%{box-shadow:0 0 0 0 rgba(var(--vRGB),0)}}
.rail-f{margin-top:auto;padding:15px 18px 0;border-top:1px solid var(--cizgi)}
.rail-v{font-size:20px;font-weight:600;color:var(--vurgu);margin-top:5px;font-variant-numeric:tabular-nums;letter-spacing:-.025em}
.rail-s{font-size:11.5px;color:var(--soluk);margin-top:8px;font-family:'JetBrains Mono',monospace;letter-spacing:-.01em}
.cikis{margin-top:12px;width:100%;background:transparent;border:1px solid var(--cizgi);color:var(--soluk);
padding:7px 10px;border-radius:6px;font:inherit;font-size:12.5px;cursor:pointer;
transition:color .18s,border-color .18s,background .18s}
.cikis:hover{color:var(--kina);border-color:var(--kina);background:rgba(0,0,0,.03)}

/* ── üst çubuk ── */
.main{flex:1;min-width:0;padding:16px 22px 60px;display:flex;flex-direction:column;gap:14px;position:relative;z-index:2}
.bar{display:flex;justify-content:space-between;gap:12px;flex-wrap:wrap;align-items:center;
position:sticky;top:0;z-index:9;padding:8px 0;margin:-8px 0 0;background:rgba(21,16,12,.82);backdrop-filter:blur(14px)}
.bar-l{display:flex;gap:7px;flex-wrap:wrap}.bar-r{display:flex;gap:8px;align-items:center}
.app select,.app input,.app textarea{background:linear-gradient(180deg,#1F1A15,#1A1611);
border:1px solid var(--cizgi);color:var(--metin);border-radius:6px;padding:6px 10px;font:inherit;outline:none;
transition:border-color .18s,box-shadow .18s}
.app textarea{font-family:'JetBrains Mono',monospace;font-size:11.5px;resize:vertical;width:100%}
.app select:focus,.app input:focus,.app textarea:focus{border-color:var(--vurgu3);box-shadow:0 0 0 3px rgba(var(--vRGB),.13)}
.app select:hover,.app input:hover{border-color:#4A3827}
.arama{position:relative;display:flex}
.arama input{min-width:230px;padding-right:26px}
.temizle{position:absolute;right:6px;top:50%;transform:translateY(-50%);background:none;border:0;color:var(--sonuk);cursor:pointer;font-size:15px;line-height:1}
.temizle:hover{color:var(--kina)}
.seg{display:flex;border:1px solid var(--cizgi);border-radius:6px;overflow:hidden}
.seg button{background:#1C1712;border:0;color:var(--soluk);padding:7px 13px;cursor:pointer;
font-size:12.5px;font-weight:600;letter-spacing:.02em;border-right:1px solid var(--cizgi);transition:all .16s}
.seg button:last-child{border-right:0}
.seg button:hover{color:var(--metin)}
.seg button.on{background:linear-gradient(140deg,var(--dgmA),var(--dgmB));color:var(--dgmY);font-weight:700}
.senk{display:flex;align-items:center;gap:7px}
.carkifelek{width:11px;height:11px;border:1.6px solid var(--sonuk);border-top-color:var(--vurgu);border-radius:50%;display:block}
.senk.calisiyor .carkifelek{animation:don .75s linear infinite}
.senk:hover .carkifelek{border-top-color:var(--vurgu2)}

/* ── HERO ── */
.hero{background:linear-gradient(155deg,#2A241D 0%,#221D18 55%,#1C1813 100%);border:1px solid var(--cizgi);
border-radius:12px;padding:22px 24px 18px;position:relative;overflow:hidden;animation:bel .6s cubic-bezier(.22,.9,.3,1) backwards}
.hero::before{content:"";position:absolute;inset:0;pointer-events:none;
background:radial-gradient(620px 220px at 8% 0%, rgba(var(--vRGB),.11), transparent 70%)}
.hero-ust{display:flex;justify-content:space-between;gap:28px;flex-wrap:wrap;position:relative}
.hero-sol{min-width:0}
.hero-rakam{font-family:'Instrument Serif',Georgia,serif;font-size:66px;line-height:1.02;margin:8px 0 4px;
letter-spacing:-.02em;background:linear-gradient(160deg,var(--vurgu2) 2%,var(--vurgu) 52%,var(--vurgu3) 100%);
-webkit-background-clip:text;background-clip:text;color:transparent;font-variant-numeric:tabular-nums}
.hero-rakam em{font-style:italic;font-size:38px;margin-right:5px;opacity:.75}
.hero-alt{display:flex;align-items:center;gap:12px;font-size:13.5px;color:var(--soluk)}
.ayirac{width:1px;height:11px;background:var(--cizgi)}
.hero-sag{display:flex;gap:10px;align-items:flex-start;flex-wrap:wrap}
.hero-mini{background:rgba(0,0,0,.22);border:1px solid var(--cizgi);border-radius:8px;padding:10px 13px;min-width:134px;
display:flex;flex-direction:column;gap:4px;transition:border-color .2s,transform .2s}
.hero-mini:hover{border-color:#4A3827;transform:translateY(-2px)}
.hero-mini b{font-size:18px;font-weight:600;letter-spacing:-.025em;font-variant-numeric:tabular-nums}
.delta{font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;padding:2px 6px;border-radius:3px;letter-spacing:.02em}
.delta.up{color:var(--yosun);background:rgba(111,185,138,.11)}
.delta.down{color:var(--kina);background:rgba(210,96,74,.11)}
.kivilcim{width:100%;height:22px;display:block;margin-top:2px}

/* ── akış şeridi (imza) ── */
.akis{display:flex;gap:4px;margin-top:22px;position:relative}
.akis-seg{min-width:0;display:flex;flex-direction:column;gap:8px;animation:bel .6s cubic-bezier(.22,.9,.3,1) backwards;cursor:default}
.akis-seg i{display:block;height:12px;border-radius:3px;width:100%;transition:transform .25s,filter .25s;transform-origin:center bottom}
.akis-seg:hover i{transform:scaleY(1.35);filter:brightness(1.2)}
.akis-bilgi{display:flex;flex-direction:column;gap:1px;min-width:0}
.akis-bilgi b{font-size:19px;font-weight:600;letter-spacing:-.025em;font-variant-numeric:tabular-nums}
.akis-bilgi span{font-size:12.5px;color:var(--soluk);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.akis-bilgi em{font-style:normal;font-size:12px;color:var(--soluk);font-variant-numeric:tabular-nums}
.s-mal{background:linear-gradient(90deg,#4E545E,#6B7280)}
.s-kom{background:linear-gradient(90deg,#6E4F86,#8A66A3)}
.s-go{background:linear-gradient(90deg,#31637A,#417F99)}
.s-gid{background:linear-gradient(90deg,#7A6A54,#9A886C)}
.s-kar{background:linear-gradient(90deg,var(--vurgu),var(--vurgu2))}
.s-zarar{background:linear-gradient(90deg,#A8412F,var(--kina))}

/* ── kartlar ── */
.kpi-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:10px}
.kpi-grid.k4{grid-template-columns:repeat(4,1fr)}
.kpi{background:linear-gradient(165deg,var(--kat2),var(--kat));border:1px solid var(--cizgi);border-radius:9px;padding:12px 13px;
transition:transform .22s cubic-bezier(.22,.9,.3,1),border-color .22s,box-shadow .22s}
.kpi:hover{transform:translateY(-3px);border-color:#4A3827;box-shadow:0 12px 26px rgba(0,0,0,.34)}
.kpi-ust{display:flex;justify-content:space-between;align-items:center;gap:6px}
.kpi-v{font-size:24px;font-weight:600;margin-top:8px;letter-spacing:-.025em;font-variant-numeric:tabular-nums;font-feature-settings:'tnum'}
.kpi-alt{display:flex;align-items:flex-end;justify-content:space-between;gap:8px;margin-top:3px}
.kpi-a{font-size:12px;color:var(--soluk)}
.kpi-alt .kivilcim{width:56px;flex:0 0 56px;height:20px;margin:0}

.panel{background:linear-gradient(170deg,var(--kat2),var(--kat));border:1px solid var(--cizgi);border-radius:10px;overflow:hidden}
.panel-h{display:flex;justify-content:space-between;align-items:center;gap:10px;padding:12px 15px;border-bottom:1px solid var(--cizgi2)}
.panel-h-r{display:flex;gap:7px;align-items:center}
.panel-b{padding:14px}
.grid2{display:grid;grid-template-columns:1fr 1fr;gap:14px}

/* ── platform listesi ── */
.pl-liste{padding:6px 4px}
.pl{display:grid;grid-template-columns:118px 1fr 82px 74px;align-items:center;gap:11px;padding:7px 12px;border-radius:6px;
animation:belS .45s ease backwards;transition:background .18s}
.pl:hover{background:rgba(var(--vRGB),.05)}
.pl-ad{font-size:13.5px;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.pl-yol{height:7px;background:rgba(0,0,0,.3);border-radius:4px;overflow:hidden}
.pl-yol i{display:block;height:100%;border-radius:4px;background:linear-gradient(90deg,var(--vurgu3),var(--vurgu))}
.pl-v{font-size:13px;text-align:right}
.pl-k{font-size:13px;text-align:right}

/* ── tablo ── */
.tbl-sar{overflow-x:auto}
.tbl{width:100%;border-collapse:collapse;font-size:13.5px}
.tbl th{text-align:left;font-size:11px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;
color:var(--soluk);padding:11px 12px;border-bottom:1px solid var(--cizgi);white-space:nowrap;
position:sticky;top:0;background:var(--kat2);z-index:2}
.tbl th.r{text-align:right}
.tbl td{padding:10px 12px;border-bottom:1px solid var(--cizgi2);white-space:nowrap}
.tbl tbody tr{cursor:pointer;transition:background .15s,box-shadow .15s}
.tbl tbody tr:hover{background:rgba(var(--vRGB),.055);box-shadow:inset 2px 0 0 var(--vurgu)}

/* ── sipariş tablosu: sayı hiyerarşisi ── */
.tbl .net-h{font-size:14px;font-weight:600;letter-spacing:-.01em}
.tbl .marj-h{font-size:13px;font-weight:500}
.tbl .marj-h.bad{color:var(--kina)}
.tbl .kucuk{font-size:12.5px}
.tbl .urun-h{font-weight:600;letter-spacing:-.005em}
.tbl .no-h{white-space:nowrap}

/* Kaynak, rozet yerine sipariş numarasının önünde küçük bir işaret */
.kay-n{width:5px;height:5px;border-radius:50%;display:inline-block;margin-right:7px;
vertical-align:middle;background:var(--sonuk)}
.kay-n.k-api{background:var(--cini)}
.kay-n.k-webhook{background:var(--yosun)}
.kay-n.k-csv{background:var(--vurgu)}

/* Platform: renkli işaret + ad — 12 platformu okumadan ayırt etmek için */
.plat{display:inline-flex;align-items:center;gap:7px;font-size:13px;font-weight:500}
.plat i{width:7px;height:7px;border-radius:2px;flex:0 0 7px;box-shadow:0 0 0 2.5px rgba(255,255,255,.05)}

/* ── SİPARİŞ LİSTESİ ──
   Tablo değil, ferah satırlar. Her satır iki kademe: üstte ne satıldı ve ne
   kazandırdı, altta kim/nereden ve maliyet kırılımı. On beş sütunun hepsini
   aynı ağırlıkta dizmek sayıları duvara çeviriyordu. */
.sip-liste{display:flex;flex-direction:column;min-width:940px}
.sip{position:relative;display:grid;align-items:center;gap:20px;
grid-template-columns:3px minmax(240px,380px) minmax(200px,1fr) 118px 118px auto 34px;
padding:15px 18px 15px 0;border-bottom:1px solid var(--cizgi2);cursor:pointer;
transition:background .16s}
.sip:hover{background:rgba(var(--vRGB),.05)}
.sip-bar{align-self:stretch;border-radius:0 3px 3px 0;opacity:.85;transition:opacity .16s,width .16s}
.sip:hover .sip-bar{opacity:1}

.sip-urun{font-size:15px;font-weight:600;letter-spacing:-.012em;line-height:1.3;
display:flex;align-items:baseline;gap:9px}
.sip-olcu{font-size:12px;font-weight:400;color:var(--soluk);letter-spacing:0}
.sip-meta{display:flex;align-items:center;gap:9px;margin-top:5px;font-size:12.5px;color:var(--soluk);
flex-wrap:wrap}
.sip-meta .kod{font-size:12px}
.sip-meta .ayr{width:3px;height:3px;border-radius:50%;background:var(--cizgi);flex:0 0 3px}
.sip-plat{display:inline-flex;align-items:center;gap:6px;font-weight:500;color:var(--metin)}
.sip-plat i{width:6px;height:6px;border-radius:2px;flex:0 0 6px}
.sip-mus{max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}

.sip-gider{display:flex;flex-direction:column;gap:7px;min-width:0}
.sip-kirilim{display:flex;gap:11px;font-size:11.5px;color:var(--soluk);white-space:nowrap}
.sip-kirilim b{font-weight:500;color:var(--metin)}

.sip-tutar{text-align:right;align-self:center}
.sip-net{font-family:'Instrument Serif',Georgia,serif;font-size:22px;line-height:1.05;letter-spacing:-.01em}
.sip-kar{font-size:16px;font-weight:600;letter-spacing:-.01em;line-height:1.2}
.sip-etiket{margin-top:4px;font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--soluk)}
.sip-etiket.bad{color:var(--kina)}

.sip-durum{display:flex;flex-direction:column;gap:5px;align-items:flex-start}

/* Gün başlığı — listeye ritim verir ve yılı gösterir */
.gun{display:flex;align-items:center;gap:12px;padding:26px 18px 9px 6px}
.gun:first-child{padding-top:14px}
.gun-ad{font-size:12px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:var(--metin)}
.gun-adet{font-size:12px;color:var(--soluk)}
.gun-cizgi{flex:1;height:1px;background:var(--cizgi2);min-width:20px}
.gun-tut{font-size:13px;font-weight:600}
.gun-kar{font-size:13px;font-weight:600}

/* Silme düğmesi yalnızca satırın üzerine gelince — 481 kez tekrarlanmasın */
.sil-h{opacity:0;transition:opacity .15s,color .16s}
.tbl tbody tr:hover .sil-h{opacity:1}
.sil-h:focus-visible{opacity:1}
.bos{text-align:center;color:var(--soluk);padding:34px!important;white-space:normal!important;font-size:14px}
.mini-tbl{width:100%;border-collapse:collapse;font-size:13.5px}
.mini-tbl td{padding:9px 2px;border-bottom:1px solid var(--cizgi2)}
.mini-tbl tr.ayrac td{border-top:1px solid var(--cizgi);border-bottom:0;padding-top:9px}

.pill{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:500;padding:3px 9px 3px 7px;border-radius:4px;
background:rgba(255,255,255,.035);color:var(--soluk);border:1px solid var(--cizgi)}
.pill i{width:4px;height:4px;border-radius:50%;background:currentColor;flex:0 0 4px}
.pill.ok{color:var(--yosun);border-color:rgba(111,185,138,.3);background:rgba(111,185,138,.09)}
.pill.info{color:var(--cini);border-color:rgba(110,146,216,.3);background:rgba(110,146,216,.09)}
.pill.warn{color:var(--vurgu);border-color:rgba(var(--vRGB),.3);background:rgba(var(--vRGB),.09)}
.pill.bad{color:var(--kina);border-color:rgba(210,96,74,.32);background:rgba(210,96,74,.09)}

.kay{font-family:'JetBrains Mono',monospace;font-size:11px;font-weight:500;letter-spacing:.04em;padding:2.5px 6px;border-radius:3px;
border:1px solid var(--cizgi);color:var(--sonuk)}
.k-api{color:var(--cini);border-color:rgba(110,146,216,.3);background:rgba(110,146,216,.07)}
.k-webhook{color:var(--yosun);border-color:rgba(111,185,138,.3);background:rgba(111,185,138,.07)}
.k-csv{color:var(--vurgu);border-color:rgba(var(--vRGB),.3);background:rgba(var(--vRGB),.07)}
.k-manuel{color:var(--sonuk)}
.kilit{font-style:normal;color:var(--vurgu);font-size:10px;margin-left:7px;vertical-align:middle}

.serit{display:flex;height:7px;border-radius:3px;overflow:hidden;background:rgba(0,0,0,.3);min-width:66px}
.serit i{display:block;height:100%}
.mini-bar{height:6px;background:rgba(0,0,0,.3);border-radius:3px;overflow:hidden}
.mini-bar i{display:block;height:100%;background:linear-gradient(90deg,var(--vurgu3),var(--vurgu2))}
.mini-bar i.neg{background:linear-gradient(90deg,#A8412F,var(--kina))}

/* ── bağlantı kartları ── */
.bag-izgara{display:grid;grid-template-columns:repeat(4,1fr);gap:11px}
.bag{position:relative;overflow:hidden;background:linear-gradient(165deg,var(--kat2),var(--kat));border:1px solid var(--cizgi);
border-radius:9px;padding:13px 14px;display:flex;flex-direction:column;gap:11px;
transition:transform .22s,border-color .22s,box-shadow .22s;animation:bel .5s cubic-bezier(.22,.9,.3,1) backwards}
.bag:hover{transform:translateY(-3px);border-color:#4A3827;box-shadow:0 12px 26px rgba(0,0,0,.34)}
.bag.tarama::after{content:"";position:absolute;top:0;bottom:0;width:36%;
background:linear-gradient(90deg,transparent,rgba(var(--vRGB),.16),transparent);animation:tara 1.1s ease-in-out infinite}
.bag-ust{display:flex;justify-content:space-between;align-items:center;gap:8px}
.bag-ad{font-size:14px;font-weight:600;letter-spacing:-.01em}
.bag-orta{display:flex;align-items:baseline;gap:6px}
.bag-orta b{font-size:23px;font-weight:600;letter-spacing:-.03em;color:var(--vurgu);font-variant-numeric:tabular-nums}
.bag-orta span{font-size:12.5px;color:var(--soluk);margin-right:auto}
.bag-alt{display:flex;justify-content:space-between;align-items:center;gap:8px;padding-top:10px;border-top:1px solid var(--cizgi2)}
.bag-alt span{font-size:11.5px;color:var(--soluk)}
.bag-alt .btn{padding:5px 11px;font-size:12.5px}

/* ── düğmeler ── */
.btn{background:linear-gradient(150deg,var(--dgmA),var(--dgmB));color:var(--dgmY);border:0;border-radius:6px;padding:6px 13px;
font:inherit;font-weight:600;cursor:pointer;transition:transform .16s,box-shadow .16s,filter .16s;
box-shadow:0 2px 10px rgba(var(--vRGB),.16)}
.btn:hover:not(:disabled){transform:translateY(-1px);box-shadow:0 6px 18px rgba(var(--vRGB),.26);filter:brightness(1.05)}
.btn:active:not(:disabled){transform:translateY(0)}
.btn:disabled{opacity:.42;cursor:default;box-shadow:none}
.btn.ghost{background:transparent;color:var(--soluk);border:1px solid var(--cizgi);box-shadow:none}
.btn.ghost:hover:not(:disabled){color:var(--metin);border-color:#4A3827;background:rgba(var(--vRGB),.05);transform:translateY(-1px)}
.x{background:none;border:0;color:var(--soluk);cursor:pointer;font:inherit;font-size:12.5px;transition:color .16s}
.x:hover{color:var(--kina)}
.x.lnk{color:var(--cini)}.x.lnk:hover{color:#9DB8EE;text-decoration:underline}
.onay{display:inline-flex;gap:7px;align-items:center;font-size:13px}
.onay b{color:var(--vurgu);font-weight:500}

/* ── kip ── */
.ovl{position:fixed;inset:0;background:rgba(8,5,3,.76);backdrop-filter:blur(4px);display:flex;align-items:flex-start;
justify-content:center;padding:34px 20px;overflow:auto;z-index:50;animation:gir .22s ease}
.modal{background:linear-gradient(170deg,var(--kat2),var(--kat));border:1px solid var(--cizgi);border-radius:12px;width:100%;
max-width:520px;box-shadow:0 30px 70px rgba(0,0,0,.6);animation:gir .3s cubic-bezier(.22,.9,.3,1)}
.modal.genis{max-width:900px}
.modal-h{display:flex;justify-content:space-between;align-items:center;padding:14px 17px;border-bottom:1px solid var(--cizgi2)}
.modal-b{padding:17px}
.modal-f{display:flex;justify-content:flex-end;gap:8px;padding:17px 0 0}
.form{display:grid;gap:11px}
.form.g2{grid-template-columns:1fr 1fr}.form.g3{grid-template-columns:repeat(3,1fr)}.form.g4{grid-template-columns:repeat(4,1fr)}
.f{display:flex;flex-direction:column;gap:5px;min-width:0}
.f>span{font-size:11px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:var(--soluk)}
.f input,.f select{width:100%}
.ic{width:84px;text-align:right;padding:3px 7px!important}
.ic.w{width:130px;text-align:left}.ic.w2{width:168px;text-align:left}
.ozet-kutu{display:grid;grid-template-columns:repeat(6,1fr);gap:10px;margin-top:17px;padding:13px 15px;
background:rgba(0,0,0,.24);border:1px solid var(--cizgi);border-radius:8px}
.ozet-kutu div{display:flex;flex-direction:column;gap:4px}
.ozet-kutu b{font-size:16px}
.senk-bilgi{display:flex;gap:11px;align-items:center;margin-bottom:15px;padding:12px 14px;background:rgba(0,0,0,.24);
border:1px solid var(--cizgi);border-radius:8px;font-size:12.5px;color:var(--soluk)}
.senk-bilgi b{color:var(--vurgu);font-weight:600;margin-left:auto;white-space:nowrap}
.onizleme-ust{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}
.onizleme{margin-top:15px;padding:12px 14px;background:rgba(0,0,0,.24);border:1px solid var(--cizgi);border-radius:8px}
.veri{display:flex;flex-direction:column;gap:11px}
.veri p{margin:0;color:var(--soluk);font-size:13px}
.veri .row{display:flex;gap:8px;flex-wrap:wrap;align-items:center}
.uyari{margin:0;font-size:13px;color:var(--soluk);border-left:2px solid var(--vurgu3);padding-left:11px}
.ipucu{margin:14px 0 0;font-size:13px;color:var(--soluk)}

/* ── dosya bırakma ── */
.birak{border:1.5px dashed var(--cizgi);border-radius:10px;padding:20px 18px;display:flex;flex-direction:column;
align-items:center;gap:6px;text-align:center;background:rgba(0,0,0,.2);transition:border-color .15s,background .15s}
.birak.uzeri{border-color:var(--vurgu);background:rgba(var(--vRGB),.09)}
.birak b{font-size:14px;font-weight:600}
.kuyruk{display:flex;flex-wrap:wrap;gap:7px;margin-top:11px}
.kuyruk-p{display:flex;align-items:center;gap:7px;padding:5px 11px;border:1px solid var(--cizgi);border-radius:20px;
font-size:12.5px;color:var(--soluk);background:rgba(0,0,0,.2);cursor:pointer;font-family:inherit}
.kuyruk-p:hover{border-color:var(--vurgu3)}
.kuyruk-p.etkin{border-color:var(--vurgu);color:var(--metin)}
.kuyruk-p b{font-weight:500;max-width:190px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.hata-kutu{margin-top:11px;padding:10px 13px;border:1px solid var(--kina);border-left-width:3px;border-radius:8px;
font-size:13px;color:var(--kina);background:rgba(228,115,92,.07)}

/* ── bildirim ── */
.bildirimler{position:fixed;right:18px;bottom:18px;display:flex;flex-direction:column;gap:8px;z-index:80}
.bildirim{background:linear-gradient(150deg,var(--kat2),var(--kat));border:1px solid var(--cizgi);border-left:3px solid var(--vurgu);
border-radius:8px;padding:12px 16px;font-size:13.5px;font-weight:500;box-shadow:0 14px 34px rgba(0,0,0,.5);animation:bildir 3.4s ease forwards;max-width:330px}
.bildirim.bad{border-left-color:var(--kina)}

@media(max-width:1240px){.bag-izgara{grid-template-columns:repeat(3,1fr)}}
@media(max-width:1100px){.kpi-grid,.kpi-grid.k4{grid-template-columns:repeat(3,1fr)}.grid2{grid-template-columns:1fr}
.form.g4,.form.g3{grid-template-columns:repeat(2,1fr)}.ozet-kutu{grid-template-columns:repeat(3,1fr)}
.hero-rakam{font-size:52px}.bag-izgara{grid-template-columns:repeat(2,1fr)}}
@media(max-width:760px){.app{flex-direction:column}.rail{width:100%;flex:none;height:auto;position:static;padding:14px 0}
.rail nav{flex-direction:row;overflow:auto;padding-bottom:4px}.nav b,.rail-f{display:none}
.kpi-grid,.kpi-grid.k4{grid-template-columns:repeat(2,1fr)}.main{padding:14px}
.hero{padding:18px 16px}.hero-rakam{font-size:42px}.akis{flex-wrap:wrap}.akis-seg{flex-basis:46%}
.bag-izgara{grid-template-columns:1fr}}

@media(prefers-reduced-motion:reduce){
.app *,.app *::before,.app *::after{animation-duration:.01ms!important;animation-iteration-count:1!important;transition-duration:.01ms!important}}

/* ═══════════════ AÇIK TEMA — vellum kâğıt, beyaz panel, bronz varak ═══════════════ */
.app.acik{
--kok:#FFFFFF; --kat:#FFFFFF; --kat2:#FFFFFF; --cizgi:#D9D9DE; --cizgi2:#EAEAEE;
--metin:#0B0B0D; --soluk:#45454C; --sonuk:#5E5E67;
--yosun:#1B7A44; --kina:#C0271A; --cini:#1D4FBF; --erguvan:#7C3A8E;
color-scheme:light}
.acik::after{background:none}

.acik .rail{background:#FAFAFB;border-right-color:#E2E2E7}
.acik .brand-k{color:var(--dgmY);background:linear-gradient(140deg,var(--dgmA),var(--dgmB));box-shadow:0 3px 12px rgba(var(--vRGB),.24)}
.acik .nav:hover{background:rgba(var(--vRGB),.08)}
.acik .nav.on{background:linear-gradient(90deg,rgba(var(--vRGB),.15),rgba(var(--vRGB),.02))}
.acik .nav.on::before{background:linear-gradient(180deg,var(--vurgu2),var(--vurgu3));box-shadow:0 0 8px rgba(var(--vRGB),.4)}
.acik .nav b{background:#EDEDF1;color:#3C3C44}
.acik .nav.on b{background:rgba(var(--vRGB),.13)}

.acik .bar{background:rgba(255,255,255,.94)}
.acik select,.acik input,.acik textarea{background:#FFFFFF;border-color:var(--cizgi)}
.acik select:hover,.acik input:hover{border-color:#B9B9C2}
.acik select:focus,.acik input:focus,.acik textarea:focus{border-color:var(--vurgu);box-shadow:0 0 0 3px rgba(var(--vRGB),.12)}
.acik .seg button{background:#FFFFFF}
.acik .seg button.on{background:linear-gradient(140deg,var(--dgmA),var(--dgmB));color:var(--dgmY)}
.acik .carkifelek{border-color:#C3C3CB;border-top-color:var(--vurgu)}
.acik .tema-dgm{font-size:14px;line-height:1;padding:5px 10px}

.acik .hero{background:#FFFFFF;border-color:#D9D9DE;box-shadow:0 1px 3px rgba(16,16,20,.06)}
.acik .hero::before{background:none}
.acik .hero-rakam{background:none;-webkit-text-fill-color:var(--dgmB);color:var(--dgmB)}
.acik .hero-mini{background:#FFFFFF;box-shadow:none;border-color:#E2E2E7}
.acik .hero-mini:hover{border-color:#B9B9C2}
.acik .delta.up{background:rgba(62,140,95,.1)}
.acik .delta.down{background:rgba(188,74,52,.1)}

.acik .s-mal{background:linear-gradient(90deg,#4A4A52,#6E6E78)}
.acik .s-kom{background:linear-gradient(90deg,#6B3E8C,#8C5CAE)}
.acik .s-go{background:linear-gradient(90deg,#1D6B87,#3B90AC)}
.acik .s-gid{background:linear-gradient(90deg,#9A5A2E,#BE7C4C)}
.acik .s-kar{background:linear-gradient(90deg,var(--vurgu),var(--vurgu2))}
.acik .s-zarar{background:linear-gradient(90deg,#A81E12,#C0271A)}

.acik .kpi,.acik .panel,.acik .bag,.acik .modal{background:#FFFFFF;box-shadow:0 1px 3px rgba(16,16,20,.05)}
.acik .kpi:hover,.acik .bag:hover{border-color:#B9B9C2;box-shadow:0 8px 20px rgba(16,16,20,.1)}
.acik .tbl th{background:#F7F7F9;color:#2E2E36;border-bottom-color:#D9D9DE}
.acik .tbl tbody tr:hover{background:rgba(var(--vRGB),.055);box-shadow:inset 2px 0 0 var(--vurgu)}
.acik .pl:hover{background:rgba(var(--vRGB),.055)}
.acik .pl-yol{background:#E8E8ED}
.acik .pl-yol i{background:linear-gradient(90deg,var(--vurgu2),var(--vurgu))}
.acik .serit,.acik .mini-bar{background:#E8E8ED}
.acik .mini-bar i{background:linear-gradient(90deg,var(--vurgu2),var(--vurgu))}
.acik .mini-bar i.neg{background:linear-gradient(90deg,#C0271A,#8E1C12)}
.acik .bag-orta b{color:var(--vurgu)}
.acik .bag.tarama::after{background:linear-gradient(90deg,transparent,rgba(var(--vRGB),.14),transparent)}

.acik .pill{background:#F3F3F6;border-color:#D9D9DE;color:#3C3C44}
.acik .pill.ok{background:#E6F5EC;border-color:#9CCFB2;color:#136135}
.acik .pill.info{background:#E8EEFC;border-color:#A3BAEC;color:#173F9C}
.acik .pill.warn{background:#FFF2DC;border-color:#E7BE7A;color:#8A5200}
.acik .pill.bad{background:#FCE9E7;border-color:#EBA79F;color:#9B1F13}
.acik .k-api{background:rgba(61,107,181,.07)}
.acik .k-webhook{background:#E6F5EC;color:#136135;border-color:#9CCFB2}
.acik .k-csv{background:#FFF2DC;color:#8A5200;border-color:#E7BE7A}

.acik .btn{background:linear-gradient(150deg,var(--dgmA),var(--dgmB));color:var(--dgmY);box-shadow:0 2px 8px rgba(var(--vRGB),.2)}
.acik .btn:hover:not(:disabled){box-shadow:0 6px 16px rgba(var(--vRGB),.28)}
.acik .btn.ghost{color:var(--soluk);background:transparent;box-shadow:none}
.acik .btn.ghost:hover:not(:disabled){background:rgba(var(--vRGB),.07);border-color:#CFC0A9;color:var(--metin)}

.acik .ovl{background:rgba(12,12,16,.42)}
.acik .modal{box-shadow:0 24px 60px rgba(16,16,20,.22)}
.acik .ozet-kutu,.acik .senk-bilgi,.acik .onizleme{background:#F7F7F9;border-color:#E2E2E7}
.acik .birak,.acik .kuyruk-p{background:#F7F7F9;border-color:#D8D8DE}
.acik .plat i{box-shadow:0 0 0 2.5px rgba(0,0,0,.04)}
.acik .sip-bar{opacity:.9}
.acik .bildirim{background:#FFFFFF;box-shadow:0 12px 30px rgba(16,16,20,.18)}
.acik .uyari{border-left-color:var(--vurgu)}
.acik .kod{color:#4A4A52}
.kod{color:var(--soluk)}
.kod.kalin{color:var(--metin);font-weight:500}

/* ═══════════════ VURGU RENKLERİ ═══════════════
   Hiçbiri sarı değil; hiçbiri kâr yeşili ya da zarar kırmızısıyla karışmıyor. */

/* Erguvan — İstanbul'un bahar moru, dut/patlıcan tonunda */
.app.v-erguvan{--vurgu:#CC72AE;--vurgu2:#E9A9D3;--vurgu3:#8C4879;--vRGB:204,114,174;
--dgmA:#C4699F;--dgmB:#94477C;--dgmY:#FFF2FA}
.app.acik.v-erguvan{--vurgu:#9A4A82;--vurgu2:#BE71A4;--vurgu3:#E9D2E1;--vRGB:154,74,130;
--dgmA:#A8558F;--dgmB:#7C3A67;--dgmY:#FFF4FB}

/* Çini — İznik turkuazı */
.app.v-cini{--vurgu:#46BDB6;--vurgu2:#86DDD7;--vurgu3:#217D79;--vRGB:70,189,182;
--dgmA:#3BAFA8;--dgmB:#1E7873;--dgmY:#EFFFFE;--yosun:#9BD37F}
.app.acik.v-cini{--vurgu:#14807A;--vurgu2:#3FA9A3;--vurgu3:#C6E7E5;--vRGB:20,128,122;
--dgmA:#1B8B85;--dgmB:#0F625E;--dgmY:#F0FFFE;--yosun:#4C8A2B}

/* Çivit — kök boya indigosu */
.app.v-civit{--vurgu:#7B99EE;--vurgu2:#AEC3F9;--vurgu3:#3F5CAE;--vRGB:123,153,238;
--dgmA:#6485E4;--dgmB:#3B57A6;--dgmY:#F5F8FF}
.app.acik.v-civit{--vurgu:#33509E;--vurgu2:#5C7FD4;--vurgu3:#CFDAF6;--vRGB:51,80,158;
--dgmA:#3E60B8;--dgmB:#283F7E;--dgmY:#F5F8FF}

/* Gece — renksiz, platin gri; en sakin seçenek */
.app.v-gece{--vurgu:#C2CDD8;--vurgu2:#E4EAF0;--vurgu3:#6F7C88;--vRGB:194,205,216;
--dgmA:#C2CDD8;--dgmB:#8D9AA6;--dgmY:#1B2026}
.app.acik.v-gece{--vurgu:#46525D;--vurgu2:#74818D;--vurgu3:#D9DEE4;--vRGB:70,82,93;
--dgmA:#4E5A66;--dgmB:#333D46;--dgmY:#FFFFFF}

/* Kâr şeridinin vurgu dilimi seçilen renkle akar */
.s-kar{background:linear-gradient(90deg,var(--vurgu3),var(--vurgu))}
.acik .s-kar{background:linear-gradient(90deg,var(--vurgu),var(--vurgu2))}

/* Görünüm seçici */
.gorunum{display:flex;gap:30px;flex-wrap:wrap}
.gr-blok{display:flex;flex-direction:column;gap:9px}
.renkler{display:flex;gap:8px;flex-wrap:wrap}
.renk{display:flex;align-items:center;gap:8px;background:transparent;border:1px solid var(--cizgi);
border-radius:7px;padding:7px 12px 7px 9px;cursor:pointer;color:var(--soluk);font:inherit;font-size:13px;
transition:border-color .18s,color .18s,transform .18s,background .18s}
.renk:hover{color:var(--metin);border-color:var(--vurgu);transform:translateY(-1px)}
.renk.on{color:var(--metin);border-color:var(--vurgu);background:rgba(var(--vRGB),.1);font-weight:600}
.renk i{width:15px;height:15px;border-radius:50%;display:block;box-shadow:0 0 0 1px rgba(0,0,0,.22) inset}

/* ── Sayfalama ── */
.sayfalar{display:flex;align-items:center;justify-content:center;gap:8px;padding:14px;border-top:1px solid var(--cizgi2)}
.sayfalar span{font-size:13px;color:var(--metin);font-variant-numeric:tabular-nums;padding:0 8px}
.sayfalar em{font-style:normal;color:var(--soluk)}
.sayfalar .btn{padding:5px 11px;font-size:12.5px}


/* ── Etsy listeleme ── */
.etsy-ust{display:flex;gap:28px;flex-wrap:wrap;padding-bottom:14px;border-bottom:1px solid var(--cizgi2)}
.etsy-ust>div{display:flex;flex-direction:column;gap:5px}
.etsy-ust b{font-size:20px;font-weight:600;letter-spacing:-.025em;font-variant-numeric:tabular-nums}
.etsy-toplu-cubuk{display:flex;gap:16px;flex-wrap:wrap;align-items:center;padding-top:14px}
.etsy-toplu-cubuk .row{display:flex;gap:6px;align-items:center}
.etsy-toplu-cubuk .btn{padding:5px 11px;font-size:12.5px}
.etsy-sekme{display:flex;gap:2px;border-bottom:1px solid var(--cizgi)}
.etsy-sekme button{background:none;border:0;border-bottom:2px solid transparent;color:var(--soluk);
padding:9px 15px;cursor:pointer;font:inherit;font-size:13.5px;transition:color .18s,border-color .18s}
.etsy-sekme button:hover{color:var(--metin)}
.etsy-sekme button.on{color:var(--vurgu);border-bottom-color:var(--vurgu);font-weight:600}
.etsy-foto{width:38px;height:38px;object-fit:cover;border-radius:5px;display:block;border:1px solid var(--cizgi)}
.etsy-foto.bos{background:var(--cizgi2)}
.ic-genis{width:100%;min-width:230px;text-align:left;padding:4px 8px!important;font-size:12.5px}
.etsy-baslik{display:flex;align-items:center;gap:8px;min-width:300px;white-space:normal!important}
.etsy-link{color:var(--vurgu);text-decoration:none;font-size:14px;flex:0 0 auto}
.etsy-link:hover{opacity:.65}
.etsy-sorun{white-space:normal!important;max-width:280px;font-size:12px;line-height:1.4}
.seo-rozet{display:inline-block;min-width:34px;text-align:center;font-weight:700;font-size:12.5px;
padding:3px 7px;border-radius:5px;font-variant-numeric:tabular-nums}
.seo-rozet.iyi{background:rgba(31,122,68,.13);color:var(--yosun);border:1px solid rgba(31,122,68,.3)}
.seo-rozet.orta{background:rgba(200,140,20,.13);color:#9A6A00;border:1px solid rgba(200,140,20,.3)}
.seo-rozet.kotu{background:rgba(192,39,26,.11);color:var(--kina);border:1px solid rgba(192,39,26,.3)}
.acik .seo-rozet.orta{color:#8A5A00}
.tbl tbody tr.degisti{background:rgba(var(--vRGB),.09);box-shadow:inset 2px 0 0 var(--vurgu)}
.tbl tbody tr.degisti:hover{background:rgba(var(--vRGB),.14)}
.tbl tbody tr.etsy-detay:hover{background:none}
.etsy-detay td{background:var(--kat2);padding:0!important;white-space:normal!important}
.acik .etsy-detay td{background:#F7F7F9}
.etsy-detay-ic{display:flex;gap:34px;flex-wrap:wrap;padding:16px 18px}
.etsy-blok{display:flex;flex-direction:column;gap:9px;min-width:280px}
.etiketler{display:flex;flex-wrap:wrap;gap:6px;align-items:center;max-width:520px}
.etiket{display:inline-flex;align-items:center;gap:5px;background:rgba(var(--vRGB),.1);
border:1px solid rgba(var(--vRGB),.28);color:var(--vurgu);border-radius:5px;padding:3px 6px 3px 9px;font-size:12.5px}
.etiket button{background:none;border:0;color:inherit;cursor:pointer;font-size:14px;line-height:1;opacity:.6;padding:0 2px}
.etiket button:hover{opacity:1;color:var(--kina)}
.etiket-giris{width:110px;padding:3px 8px!important;font-size:12.5px}
.app input[type=checkbox]{width:15px;height:15px;accent-color:var(--vurgu);cursor:pointer}

/* ── Banka hesapları ── */
.hesaplar{display:flex;flex-direction:column;gap:4px;padding:6px 0}
.hs-grup{padding:10px 14px 16px}
.hs-grup+.hs-grup{border-top:1px solid var(--cizgi2)}
.hs-baslik{display:flex;justify-content:space-between;align-items:baseline;gap:12px;margin-bottom:11px}
.hs-baslik b{font-size:16px;font-weight:600;letter-spacing:-.02em;color:var(--vurgu)}
.hs-izgara{display:grid;grid-template-columns:repeat(5,1fr);gap:10px}
.hs{background:var(--kat2);border:1px solid var(--cizgi);border-radius:9px;padding:12px 13px;cursor:pointer;
display:flex;flex-direction:column;gap:9px;transition:transform .2s,border-color .2s,box-shadow .2s;
animation:bel .5s cubic-bezier(.22,.9,.3,1) backwards}
.hs:hover{transform:translateY(-3px);border-color:var(--vurgu);box-shadow:0 10px 22px rgba(0,0,0,.2)}
.acik .hs:hover{box-shadow:0 8px 20px rgba(16,16,20,.1)}
.hs-ust{display:flex;justify-content:space-between;align-items:center;gap:9px}
.hs-ust .hs-ad{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
/* Logo kendi satırında: banka logoları yatay, kare kutuya sıkışınca okunmuyor.
   Beyaz kart zemini logonun kendi zeminiyle çakışmasın diye her logo beyaz bir
   pula oturuyor — koyu temada da aynı görünüyor. */
.hs-marka{display:flex;justify-content:space-between;align-items:center;gap:10px;min-height:32px}
.bnk-logo{height:32px;width:auto;max-width:150px;object-fit:contain;background:#fff;
border:1px solid var(--cizgi2);border-radius:6px;padding:4px 7px;display:block}
.acik .bnk-logo{border-color:#E4E4E9}
.bnk-mark{width:26px;height:26px;flex:0 0 26px;display:inline-flex;align-items:center;justify-content:center;
border:1px solid;border-radius:6px;font-size:11.5px;font-weight:700;letter-spacing:.02em;line-height:1}
.hs-ad{font-size:13px;font-weight:600;letter-spacing:-.005em;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.hs-bakiye{font-size:20px;font-weight:600;letter-spacing:-.03em;font-variant-numeric:tabular-nums;display:flex;align-items:baseline;gap:5px}
.hs-bakiye em{font-style:normal;font-size:12px;font-weight:500;color:var(--soluk)}
.hs-alt{display:flex;justify-content:space-between;align-items:center;gap:8px;font-size:11.5px;color:var(--soluk);
padding-top:9px;border-top:1px solid var(--cizgi2)}
@media(max-width:1240px){.hs-izgara{grid-template-columns:repeat(3,1fr)}}
@media(max-width:760px){.hs-izgara{grid-template-columns:repeat(2,1fr)}}

/* ═══════════════════════════════════════════════════════════════
   ETSY VİTRİNİ — panelden kasıtlı olarak farklı bir kimlik.
   Etsy turuncusu, kremsi sıcak zemin, kartlı galeri düzeni.
   Sadece .vitrin içinde geçerli — panelin geri kalanına sızmaz.
   ═══════════════════════════════════════════════════════════════ */
.vitrin{
  --et-turuncu:#F1641E; --et-turuncu2:#FF8A50; --et-koyu:#7A3410;
  --et-zemin:#FFF9F4; --et-kart:#FFFFFF; --et-cizgi:#F3DFCE; --et-metin:#3D2B1F;
  --et-soluk:#8A6F5C; --et-iyi:#2F8F5B; --et-orta:#C9821E; --et-kotu:#D6432B;
  background:var(--et-zemin);color:var(--et-metin);border-radius:14px;padding:22px;margin:-4px;
  font-family:'Inter',sans-serif;
}
.acik .vitrin{--et-zemin:#FFFBF7}
.vitrin .bel{animation:bel .5s cubic-bezier(.22,.9,.3,1) backwards}

.v-eyebrow{font-size:10.5px;font-weight:700;letter-spacing:.11em;text-transform:uppercase;color:var(--et-turuncu)}
.v-hero{display:flex;justify-content:space-between;align-items:flex-end;gap:24px;flex-wrap:wrap;
padding-bottom:20px;margin-bottom:18px;border-bottom:2px solid var(--et-cizgi)}
.v-baslik{font-family:'Instrument Serif',Georgia,serif;font-size:34px;font-weight:400;margin:6px 0 14px;
color:var(--et-koyu);letter-spacing:-.01em}
.v-secim{display:flex;gap:8px;flex-wrap:wrap}
.v-secim select{background:var(--et-kart);border:1.5px solid var(--et-cizgi);border-radius:8px;
padding:8px 12px;font:inherit;font-size:13px;color:var(--et-metin);cursor:pointer}
.v-btn{background:linear-gradient(135deg,var(--et-turuncu2),var(--et-turuncu));color:#fff;border:0;
border-radius:8px;padding:9px 18px;font:inherit;font-weight:700;font-size:13px;cursor:pointer;
box-shadow:0 3px 10px rgba(241,100,30,.28);transition:transform .16s,box-shadow .16s}
.v-btn:hover:not(:disabled){transform:translateY(-1px);box-shadow:0 6px 16px rgba(241,100,30,.36)}
.v-btn:disabled{opacity:.35;cursor:default;box-shadow:none}
.v-btn.hayalet{background:transparent;color:var(--et-koyu);border:1.5px solid var(--et-cizgi);box-shadow:none}
.v-btn.hayalet:hover:not(:disabled){border-color:var(--et-turuncu);background:rgba(241,100,30,.05)}

.v-hero-istatistik{display:flex;gap:26px}
.v-hero-istatistik div{display:flex;flex-direction:column;gap:2px;align-items:flex-end}
.v-hero-istatistik b{font-family:'JetBrains Mono',monospace;font-size:24px;font-weight:600;color:var(--et-koyu);letter-spacing:-.02em}
.v-hero-istatistik b.v-canli{color:var(--et-turuncu)}
.v-hero-istatistik span{font-size:10.5px;color:var(--et-soluk);text-transform:uppercase;letter-spacing:.06em}

.v-uyari{background:#FFF3EC;border:1.5px solid #F5C9A6;color:#8A4A1A;border-radius:10px;
padding:13px 16px;font-size:13px;line-height:1.5;margin-bottom:16px}
.v-bos{text-align:center;padding:60px 20px;color:var(--et-soluk);font-size:14px;line-height:1.7}
.v-bos span{display:block;font-size:40px;margin-bottom:10px}

.v-cubuk{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:14px;margin-bottom:18px}
.v-sekme{display:flex;gap:3px;background:var(--et-kart);border:1.5px solid var(--et-cizgi);border-radius:10px;padding:3px}
.v-sekme button{background:none;border:0;padding:8px 16px;border-radius:7px;font:inherit;font-size:13px;
font-weight:600;color:var(--et-soluk);cursor:pointer;transition:all .16s}
.v-sekme button.on{background:linear-gradient(135deg,var(--et-turuncu2),var(--et-turuncu));color:#fff}
.v-toplu{display:flex;gap:7px;align-items:center;flex-wrap:wrap;font-size:12px;color:var(--et-soluk)}
.v-toplu input{border:1.5px solid var(--et-cizgi);border-radius:7px;padding:6px 10px;font:inherit;font-size:12.5px;width:140px}
.v-toplu button{background:var(--et-kart);border:1.5px solid var(--et-cizgi);border-radius:7px;padding:6px 11px;
font:inherit;font-size:12px;font-weight:600;color:var(--et-koyu);cursor:pointer;transition:all .16s}
.v-toplu button:hover:not(:disabled){border-color:var(--et-turuncu);color:var(--et-turuncu)}
.v-toplu button:disabled{opacity:.35;cursor:default}

/* ── Galeri kartları ── */
.v-galeri{display:grid;grid-template-columns:repeat(auto-fill,minmax(238px,1fr));gap:16px}
.v-kart{background:var(--et-kart);border:1.5px solid var(--et-cizgi);border-radius:14px;overflow:hidden;
cursor:pointer;transition:transform .2s cubic-bezier(.22,.9,.3,1),box-shadow .2s,border-color .2s}
.v-kart:hover{transform:translateY(-4px);box-shadow:0 14px 30px rgba(122,52,16,.14);border-color:var(--et-turuncu2)}
.v-kart.v-degisti{border-color:var(--et-turuncu);box-shadow:0 0 0 3px rgba(241,100,30,.13)}
.v-foto-sar{position:relative;aspect-ratio:1/1;background:#F3E7DA}
.v-foto{width:100%;height:100%;object-fit:cover;display:block}
.v-foto-bos{display:flex;align-items:center;justify-content:center;font-size:38px;opacity:.35}
.v-foto-ust{position:absolute;top:10px;left:10px;right:10px;display:flex;justify-content:space-between;align-items:flex-start}
.v-foto-ust input[type=checkbox]{width:19px;height:19px;accent-color:var(--et-turuncu);cursor:pointer;
box-shadow:0 2px 6px rgba(0,0,0,.25);border-radius:5px}
.v-foto-alt{position:absolute;bottom:0;left:0;right:0;padding:22px 12px 10px;
background:linear-gradient(0deg,rgba(0,0,0,.68),transparent);display:flex;justify-content:space-between;align-items:flex-end}
.v-fiyat{font-family:'JetBrains Mono',monospace;font-size:16px;font-weight:700;color:#fff}
.v-stok{font-size:11px;color:#F3E7DA;background:rgba(0,0,0,.3);padding:2px 7px;border-radius:5px}
.v-stok.tukendi{background:var(--et-kotu);color:#fff}
.v-rozet{position:absolute;top:10px;right:44px;background:var(--et-turuncu);color:#fff;font-size:9.5px;
font-weight:700;padding:3px 7px;border-radius:5px;letter-spacing:.03em}
.v-kart-alt{padding:12px 13px 13px}
.v-kart-baslik{display:block;font-size:13px;font-weight:600;line-height:1.35;color:var(--et-metin);
overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;min-height:35px}
.v-kart-meta{display:flex;gap:11px;margin-top:8px;font-size:11px;color:var(--et-soluk)}

.v-seo-halka{display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:50%;
font-family:'JetBrains Mono',monospace;font-size:12px;font-weight:700;box-shadow:0 2px 8px rgba(0,0,0,.18)}
.v-seo-halka.iyi{background:var(--et-iyi);color:#fff}
.v-seo-halka.orta{background:var(--et-orta);color:#fff}
.v-seo-halka.kotu{background:var(--et-kotu);color:#fff}
.v-seo-halka.kucuk{width:26px;height:26px;font-size:10.5px;box-shadow:none}
.v-seo-halka.buyuk{width:52px;height:52px;font-size:18px}

/* ── Tablolar (SEO / Performans) ── */
.v-tablo-sar{overflow-x:auto;background:var(--et-kart);border:1.5px solid var(--et-cizgi);border-radius:12px}
.v-tablo{width:100%;border-collapse:collapse;font-size:13px}
.v-tablo th{text-align:left;font-size:10px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;
color:var(--et-soluk);padding:12px 14px;border-bottom:1.5px solid var(--et-cizgi)}
.v-tablo td{padding:10px 14px;border-bottom:1px solid var(--et-cizgi)}
.v-tablo tbody tr{cursor:pointer;transition:background .15s}
.v-tablo tbody tr:hover{background:#FFF3EC}
.v-mini-foto{width:36px;height:36px;border-radius:7px;object-fit:cover;display:block}
.v-satir-baslik{max-width:320px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:500}
.v-durum-etiket{font-size:11px;font-weight:700;padding:3px 9px;border-radius:6px;text-transform:capitalize}
.v-durum-etiket.iyi{background:#E3F3EA;color:var(--et-iyi)}
.v-durum-etiket.kotu{background:#FBE4E0;color:var(--et-kotu)}

.v-alt-cubuk{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:12px;
margin-top:18px;padding-top:16px;border-top:1.5px solid var(--et-cizgi);font-size:13px;color:var(--et-soluk)}
.v-alt-cubuk .row{display:flex;gap:9px}

/* ── Detay çekmecesi ── */
.v-ovl{position:fixed;inset:0;background:rgba(61,43,31,.5);backdrop-filter:blur(3px);z-index:60;
display:flex;justify-content:flex-end;animation:gir .22s ease}
.v-cekmece{width:min(680px,92vw);height:100%;background:var(--et-zemin);overflow-y:auto;position:relative;
box-shadow:-20px 0 50px rgba(0,0,0,.25);animation:v-kaydir .3s cubic-bezier(.22,.9,.3,1)}
@keyframes v-kaydir{from{transform:translateX(40px);opacity:0}to{transform:none;opacity:1}}
.v-kapat{position:absolute;top:16px;right:16px;width:34px;height:34px;border-radius:50%;background:rgba(0,0,0,.35);
color:#fff;border:0;font-size:20px;line-height:1;cursor:pointer;z-index:5}
.v-kapat:hover{background:rgba(0,0,0,.55)}
.v-cekmece-galeri{display:flex;gap:6px;padding:6px;background:#000}
.v-buyuk-foto{width:100%;aspect-ratio:4/3;object-fit:cover;border-radius:8px 8px 0 0;display:block}
.v-kucuk-foto{display:none}
.v-cekmece-govde{padding:22px 26px 30px;display:flex;flex-direction:column;gap:18px}
.v-cekmece-ust{display:flex;align-items:center;gap:14px}
.v-alan{display:flex;flex-direction:column;gap:6px}
.v-alan>span{font-size:10.5px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;color:var(--et-soluk)}
.v-alan input,.v-alan textarea{border:1.5px solid var(--et-cizgi);border-radius:9px;padding:9px 12px;
font:inherit;font-size:13.5px;color:var(--et-metin);background:var(--et-kart)}
.v-alan input:focus{outline:none;border-color:var(--et-turuncu);box-shadow:0 0 0 3px rgba(241,100,30,.12)}
.v-alan-cift{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.v-etiket-bulut{display:flex;flex-wrap:wrap;gap:7px;align-items:center}
.v-etiket{display:inline-flex;align-items:center;gap:6px;background:#FFF3EC;border:1.5px solid #F5C9A6;
color:var(--et-koyu);border-radius:8px;padding:5px 7px 5px 11px;font-size:12.5px;font-weight:600}
.v-etiket button{background:none;border:0;color:inherit;cursor:pointer;font-size:15px;opacity:.55;padding:0 2px}
.v-etiket button:hover{opacity:1;color:var(--et-kotu)}
.v-etiket-giris{width:100px;padding:5px 9px!important;font-size:12.5px!important}
.v-mini-tablo{width:100%;border-collapse:collapse;font-size:12.5px}
.v-mini-tablo td{padding:7px 4px;border-bottom:1px solid var(--et-cizgi)}
.v-mini-tablo input{width:100%;max-width:90px;border:1.5px solid var(--et-cizgi);border-radius:6px;padding:4px 7px;font:inherit}
.v-cekmece-alt{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px;
padding-top:14px;border-top:1.5px solid var(--et-cizgi)}

@media(max-width:760px){.v-hero{flex-direction:column;align-items:flex-start}.v-hero-istatistik{gap:16px}
.v-galeri{grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:10px}
.v-cekmece{width:100vw}.v-alan-cift{grid-template-columns:1fr}}
`;
